var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g, _path68, _path69, _g2, _path70, _path71, _g3, _path72, _path73, _g4, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 138,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39 6.235L53.2.363a9.168 9.168 0 0110.216 6.819l24.826 107.854a9.167 9.167 0 01-6.125 10.994L38.65 136.9c-5.45 1.722-11.212-1.562-12.509-7.128L.26 18.167c-1.302-5.59 2.452-11.1 8.13-11.932z",
    fill: "#403466"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.253 115.071a9.13 9.13 0 01-6.1 10.949l-43.497 10.879c-5.423 1.703-11.15-1.567-12.441-7.105L.315 18.118C-.982 12.549 2.758 7.06 8.415 6.233L53.251.358A9.13 9.13 0 0163.41 7.15l24.842 107.921z",
    fill: "#413467"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.26 115.105a9.094 9.094 0 01-6.074 10.905L38.66 136.898c-5.395 1.683-11.09-1.572-12.374-7.082L.372 18.07C-.92 12.523 2.805 7.056 8.44 6.23L53.3.352a9.091 9.091 0 0110.102 6.766L88.26 115.105z",
    fill: "#413568"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.27 115.139a9.055 9.055 0 01-6.05 10.86l-43.554 10.897c-5.368 1.664-11.028-1.577-12.306-7.059L.429 18.022C-.86 12.497 2.852 7.051 8.466 6.228L53.35.346a9.053 9.053 0 0110.045 6.74L88.27 115.139z",
    fill: "#423569"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.278 115.172a9.02 9.02 0 01-6.025 10.817L38.67 136.894c-5.34 1.645-10.967-1.582-12.238-7.036L.485 17.973C-.797 12.47 2.9 7.045 8.491 6.226L53.398.339a9.015 9.015 0 019.988 6.714l24.892 108.119z",
    fill: "#43366A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.287 115.207a8.983 8.983 0 01-6 10.772l-43.61 10.914c-5.314 1.626-10.907-1.588-12.171-7.013L.54 17.926C-.737 12.443 2.946 7.039 8.516 6.223l44.93-5.89a8.976 8.976 0 019.931 6.688l24.91 108.186z",
    fill: "#43366B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.296 115.241a8.945 8.945 0 01-5.977 10.727L38.68 136.891c-5.286 1.607-10.846-1.592-12.103-6.991L.598 17.877C-.675 12.415 2.993 7.033 8.542 6.22L53.495.327a8.938 8.938 0 019.874 6.661l24.927 108.253z",
    fill: "#44376C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.304 115.274a8.908 8.908 0 01-5.951 10.683L38.687 136.89c-5.26 1.587-10.785-1.598-12.036-6.968L.654 17.829C-.613 12.389 3.04 7.027 8.567 6.217L53.544.321a8.9 8.9 0 019.817 6.635l24.943 108.318z",
    fill: "#45376D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.312 115.308a8.872 8.872 0 01-5.927 10.639L38.69 136.888c-5.232 1.568-10.723-1.603-11.968-6.945L.71 17.78C-.553 12.361 3.086 7.021 8.592 6.214l45-5.9a8.862 8.862 0 019.76 6.609l24.96 108.385z",
    fill: "#45386E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.321 115.342a8.835 8.835 0 01-5.902 10.594l-43.723 10.95c-5.205 1.549-10.663-1.608-11.9-6.922L.765 17.732C-.49 12.335 3.135 7.016 8.618 6.212L53.641.309a8.824 8.824 0 019.703 6.582L88.32 115.342z",
    fill: "#46386F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.33 115.375a8.797 8.797 0 01-5.877 10.55l-43.751 10.96c-5.178 1.529-10.602-1.614-11.833-6.901L.823 17.684C-.43 12.308 3.181 7.01 8.643 6.209L53.69.302a8.785 8.785 0 019.645 6.556L88.33 115.375z",
    fill: "#473970"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.339 115.409a8.762 8.762 0 01-5.853 10.506l-43.78 10.968c-5.15 1.51-10.54-1.619-11.766-6.877L.88 17.636C-.368 12.28 3.228 7.003 8.668 6.205L53.74.297a8.747 8.747 0 019.588 6.53l25.01 108.583z",
    fill: "#473971"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.347 115.443a8.722 8.722 0 01-5.828 10.461l-43.807 10.977c-5.124 1.491-10.48-1.625-11.698-6.855L.936 17.587C-.306 12.254 3.276 6.998 8.693 6.204L53.79.291a8.709 8.709 0 019.53 6.503l25.028 108.649z",
    fill: "#483A72"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.356 115.477a8.687 8.687 0 01-5.803 10.417l-43.836 10.985c-5.096 1.472-10.419-1.629-11.631-6.831L.992 17.539C-.245 12.227 3.322 6.992 8.718 6.201L53.838.284a8.671 8.671 0 019.473 6.477l25.045 108.716z",
    fill: "#493A73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.363 115.511a8.65 8.65 0 01-5.778 10.373L38.72 136.878c-5.07 1.453-10.358-1.634-11.563-6.809L1.048 17.491C-.185 12.2 3.368 6.987 8.743 6.199L53.885.279a8.633 8.633 0 019.417 6.45l25.061 108.782z",
    fill: "#493B74"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.373 115.545a8.612 8.612 0 01-5.754 10.328l-43.892 11.004c-5.042 1.433-10.297-1.64-11.496-6.787L1.104 17.443C-.123 12.174 3.415 6.98 8.768 6.197L53.935.273a8.596 8.596 0 019.36 6.424l25.078 108.848z",
    fill: "#4A3B75"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.38 115.579a8.576 8.576 0 01-5.729 10.284l-43.92 11.012c-5.015 1.414-10.236-1.644-11.429-6.764L1.16 17.394c-1.223-5.248 2.302-10.42 7.633-11.2L53.983.265a8.557 8.557 0 019.302 6.398L88.381 115.58z",
    fill: "#4B3C76"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.39 115.613a8.54 8.54 0 01-5.705 10.24l-43.949 11.021c-4.987 1.395-10.174-1.65-11.36-6.741L1.216 17.346C0 12.12 3.51 6.97 8.82 6.192L54.033.26a8.519 8.519 0 019.245 6.372l25.112 108.98z",
    fill: "#4B3C77"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.398 115.647a8.5 8.5 0 01-5.68 10.194l-43.977 11.031c-4.96 1.375-10.113-1.655-11.293-6.718L1.273 17.298C.061 12.093 3.556 6.964 8.843 6.19L54.082.255A8.482 8.482 0 0163.27 6.6l25.129 109.047z",
    fill: "#4C3D78"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.407 115.68a8.465 8.465 0 01-5.656 10.151L38.746 136.87c-4.933 1.356-10.053-1.661-11.225-6.695L1.33 17.249C.122 12.066 3.603 6.957 8.869 6.186L54.13.248a8.444 8.444 0 019.132 6.319L88.407 115.68z",
    fill: "#4D3D79"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.416 115.715a8.428 8.428 0 01-5.63 10.106l-44.033 11.048c-4.906 1.337-9.992-1.666-11.159-6.672L1.387 17.201C.185 12.04 3.651 6.952 8.896 6.184L54.18.243a8.406 8.406 0 019.075 6.292l25.161 109.18z",
    fill: "#4D3E7A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88.425 115.748a8.391 8.391 0 01-5.605 10.062l-44.062 11.057c-4.879 1.318-9.93-1.671-11.091-6.65L1.444 17.152C.246 12.013 3.699 6.947 8.92 6.18L54.23.236a8.369 8.369 0 019.017 6.266l25.179 109.246z",
    fill: "#4E3E7B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.432 115.782a8.352 8.352 0 01-5.58 10.017l-44.09 11.066c-4.852 1.299-9.87-1.676-11.024-6.626L1.5 17.105C.307 11.986 3.745 6.941 8.945 6.18L54.277.23a8.33 8.33 0 018.96 6.24l25.195 109.312z",
    fill: "#4F3F7C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.44 115.816a8.317 8.317 0 01-5.555 9.973l-44.118 11.075c-4.825 1.28-9.81-1.681-10.956-6.604L1.555 17.056C.367 11.958 3.791 6.935 8.97 6.176L54.326.224a8.293 8.293 0 018.902 6.214l25.213 109.378z",
    fill: "#4F3F7D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.45 115.85a8.278 8.278 0 01-5.532 9.928L38.77 136.862c-4.797 1.261-9.748-1.686-10.888-6.581L1.612 17.008C.429 11.932 3.839 6.928 8.996 6.173L54.375.218a8.256 8.256 0 018.845 6.187L88.45 115.85z",
    fill: "#50407E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M88.46 115.884a8.242 8.242 0 01-5.507 9.884l-44.175 11.093c-4.77 1.241-9.687-1.691-10.821-6.559L1.669 16.96C.492 11.905 3.887 6.923 9.022 6.17L54.425.212a8.218 8.218 0 018.788 6.16L88.46 115.885z",
    fill: "#51407F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M88.467 115.918a8.206 8.206 0 01-5.482 9.84L38.782 136.86c-4.742 1.222-9.626-1.698-10.753-6.536L1.725 16.912C.552 11.878 3.933 6.918 9.047 6.168L54.473.206a8.181 8.181 0 018.732 6.135l25.262 109.577z",
    fill: "#514180"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.475 115.951a8.167 8.167 0 01-5.457 9.795l-44.231 11.111c-4.716 1.203-9.565-1.702-10.686-6.513L1.781 16.864C.615 11.85 3.982 6.91 9.072 6.164L54.522.2a8.144 8.144 0 018.676 6.108l25.278 109.643z",
    fill: "#524181"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M88.484 115.985a8.132 8.132 0 01-5.432 9.751l-44.26 11.119c-4.689 1.184-9.504-1.707-10.618-6.49L1.837 16.815c-1.163-4.991 2.19-9.909 7.26-10.653L54.57.194a8.106 8.106 0 018.617 6.082l25.296 109.709z",
    fill: "#534282"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M88.493 116.019a8.095 8.095 0 01-5.408 9.707l-44.287 11.128c-4.662 1.164-9.443-1.713-10.551-6.468L1.894 16.766C.736 11.797 4.074 6.9 9.122 6.16L54.62.188a8.068 8.068 0 018.56 6.055L88.493 116.02z",
    fill: "#534283"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88.502 116.053a8.056 8.056 0 01-5.383 9.661l-44.316 11.138c-4.634 1.144-9.382-1.718-10.483-6.445L1.95 16.718C.799 11.77 4.122 6.894 9.148 6.158L54.67.18a8.032 8.032 0 018.503 6.03l25.33 109.842z",
    fill: "#544384"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M88.51 116.087a8.021 8.021 0 01-5.358 9.618l-44.344 11.146c-4.606 1.125-9.32-1.723-10.415-6.423L2.007 16.67C.86 11.744 4.168 6.89 9.173 6.155L54.717.175a7.995 7.995 0 018.447 6.004L88.51 116.087z",
    fill: "#554384"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M88.519 116.121a7.983 7.983 0 01-5.334 9.573L38.812 136.85c-4.58 1.106-9.26-1.728-10.348-6.4L2.064 16.622C.92 11.717 4.215 6.882 9.198 6.152L54.766.17a7.958 7.958 0 018.39 5.977l25.363 109.975z",
    fill: "#554385"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88.527 116.155a7.945 7.945 0 01-5.308 9.528l-44.401 11.165c-4.553 1.086-9.2-1.734-10.281-6.377L2.12 16.574C.982 11.69 4.262 6.877 9.223 6.15L54.815.164a7.92 7.92 0 018.332 5.95l25.38 110.041z",
    fill: "#564486"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.535 116.189a7.908 7.908 0 01-5.284 9.484l-44.43 11.173c-4.524 1.068-9.137-1.738-10.212-6.353L2.175 16.526C1.042 11.663 4.308 6.872 9.248 6.147L54.863.157a7.883 7.883 0 018.274 5.925l25.398 110.107z",
    fill: "#574487"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M88.544 116.223a7.872 7.872 0 01-5.26 9.44l-44.457 11.182c-4.498 1.048-9.077-1.744-10.146-6.331L2.231 16.478C1.105 11.636 4.356 6.866 9.274 6.145L54.912.152a7.846 7.846 0 018.217 5.898l25.415 110.173z",
    fill: "#574588"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M88.553 116.256a7.836 7.836 0 01-5.234 9.396l-44.486 11.191c-4.47 1.029-9.016-1.749-10.077-6.308L2.289 16.429c-1.122-4.82 2.114-9.57 7.01-10.287L54.963.146a7.81 7.81 0 018.16 5.871l25.431 110.239z",
    fill: "#584589"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88.561 116.29a7.797 7.797 0 01-5.21 9.351l-44.513 11.2c-4.443 1.01-8.955-1.754-10.01-6.285L2.344 16.38C1.227 11.582 4.45 6.854 9.325 6.14L55.01.138a7.773 7.773 0 018.104 5.845L88.561 116.29z",
    fill: "#59468A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M88.57 116.324a7.762 7.762 0 01-5.185 9.307L38.842 136.84c-4.416.99-8.893-1.76-9.943-6.263L2.401 16.332C1.288 11.555 4.496 6.848 9.349 6.137L55.059.133a7.736 7.736 0 018.047 5.82L88.57 116.323z",
    fill: "#59468B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M88.578 116.358a7.723 7.723 0 01-5.16 9.262l-44.57 11.218c-4.389.972-8.833-1.764-9.875-6.239L2.458 16.284C1.35 11.529 4.544 6.842 9.375 6.134L55.11.128a7.7 7.7 0 017.99 5.792l25.48 110.438z",
    fill: "#5A478C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M88.588 116.392a7.687 7.687 0 01-5.136 9.218l-44.6 11.227c-4.361.952-8.771-1.77-9.807-6.218L2.514 16.236C1.412 11.5 4.591 6.836 9.4 6.13L55.158.121a7.663 7.663 0 017.932 5.766l25.498 110.505z",
    fill: "#5B478D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M88.596 116.426a7.65 7.65 0 01-5.11 9.174l-44.628 11.235c-4.335.934-8.711-1.775-9.74-6.194L2.572 16.188C1.474 11.476 4.638 6.831 9.426 6.13L55.207.116a7.626 7.626 0 017.875 5.74l25.514 110.57z",
    fill: "#5B488E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M88.604 116.46a7.613 7.613 0 01-5.086 9.129l-44.655 11.245c-4.308.914-8.65-1.78-9.673-6.172L2.627 16.139C1.534 11.447 4.685 6.825 9.451 6.126L55.255.108a7.59 7.59 0 017.818 5.714l25.53 110.638z",
    fill: "#5C488F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88.612 116.494a7.575 7.575 0 01-5.061 9.084l-44.684 11.254c-4.28.895-8.589-1.785-9.606-6.149L2.683 16.091c-1.088-4.67 2.048-9.272 6.792-9.968L55.303.103a7.554 7.554 0 017.761 5.687l25.548 110.704z",
    fill: "#5D4990"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M88.622 116.528a7.538 7.538 0 01-5.037 9.04l-44.711 11.263c-4.254.875-8.529-1.791-9.539-6.126L2.741 16.043c-1.083-4.648 2.038-9.23 6.76-9.921L55.354.097a7.518 7.518 0 017.704 5.66l25.565 110.771z",
    fill: "#5D4991"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M88.63 116.561a7.501 7.501 0 01-5.012 8.996l-44.74 11.271c-4.226.857-8.467-1.795-9.471-6.103L2.797 15.994c-1.079-4.627 2.029-9.187 6.729-9.876L55.4.091a7.482 7.482 0 017.647 5.634L88.63 116.561z",
    fill: "#5E4A92"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M88.638 116.595a7.464 7.464 0 01-4.987 8.951l-44.768 11.28c-4.199.837-8.406-1.801-9.403-6.081L2.853 15.945c-1.073-4.604 2.02-9.143 6.699-9.83L55.45.086a7.444 7.444 0 017.589 5.608l25.598 110.902z",
    fill: "#5F4A93"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M88.647 116.629a7.427 7.427 0 01-4.962 8.907l-44.796 11.289c-4.172.818-8.345-1.806-9.336-6.058L2.91 15.898C1.84 11.314 4.92 6.796 9.577 6.114L55.5.079a7.408 7.408 0 017.532 5.582L88.647 116.63z",
    fill: "#5F4B94"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M88.655 116.663a7.391 7.391 0 01-4.938 8.863l-44.825 11.298c-4.144.799-8.284-1.812-9.267-6.035L2.965 15.849C1.902 11.287 4.966 6.79 9.602 6.111L55.548.073a7.372 7.372 0 017.476 5.556l25.631 111.034z",
    fill: "#604B95"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M88.664 116.697a7.354 7.354 0 01-4.913 8.818l-44.853 11.307a7.948 7.948 0 01-9.2-6.013L3.021 15.801C1.964 11.26 5.013 6.784 9.627 6.108L55.597.066a7.337 7.337 0 017.419 5.529l25.648 111.102z",
    fill: "#614C96"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M88.673 116.731a7.317 7.317 0 01-4.888 8.774l-44.881 11.316c-4.09.76-8.162-1.823-9.134-5.99L3.078 15.752c-1.053-4.52 1.982-8.974 6.574-9.647L55.646.06a7.301 7.301 0 017.361 5.503l25.666 111.168z",
    fill: "#614C97"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M88.682 116.765a7.28 7.28 0 01-4.864 8.73l-44.91 11.325a7.877 7.877 0 01-9.065-5.967L3.135 15.705c-1.048-4.499 1.973-8.932 6.543-9.602L55.696.055a7.264 7.264 0 017.303 5.476l25.683 111.234z",
    fill: "#624D98"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M88.69 116.799a7.243 7.243 0 01-4.84 8.685l-44.937 11.334a7.841 7.841 0 01-8.998-5.944L3.19 15.657C2.147 11.179 5.154 6.767 9.703 6.1L55.743.048a7.229 7.229 0 017.247 5.45L88.69 116.8z",
    fill: "#634D99"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M88.699 116.833a7.205 7.205 0 01-4.815 8.64L38.92 136.816a7.803 7.803 0 01-8.93-5.921L3.246 15.608C2.21 11.152 5.201 6.76 9.73 6.098L55.793.043a7.193 7.193 0 017.19 5.423l25.716 111.367z",
    fill: "#634E9A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M88.706 116.866a7.168 7.168 0 01-4.79 8.596l-44.993 11.352c-3.982.683-7.919-1.843-8.863-5.898L3.303 15.56c-1.033-4.435 1.945-8.804 6.45-9.465L55.84.036a7.158 7.158 0 017.132 5.398l25.733 111.432z",
    fill: "#644E9B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M88.716 116.9a7.132 7.132 0 01-4.764 8.552l-45.022 11.36a7.734 7.734 0 01-8.796-5.876L3.36 15.511C2.333 11.1 5.296 6.75 9.78 6.092L55.89.03A7.123 7.123 0 0162.966 5.4L88.716 116.9z",
    fill: "#654F9C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M88.724 116.934a7.094 7.094 0 01-4.74 8.507l-45.05 11.37c-3.927.644-7.796-1.853-8.728-5.853L3.416 15.463c-1.023-4.391 1.927-8.72 6.388-9.373L55.939.024a7.088 7.088 0 017.019 5.345l25.766 111.565z",
    fill: "#654F9D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M88.733 116.968a7.057 7.057 0 01-4.715 8.463l-45.08 11.379c-3.9.625-7.735-1.859-8.66-5.831L3.473 15.415c-1.018-4.37 1.917-8.677 6.356-9.327L55.99.018a7.052 7.052 0 016.96 5.32l25.784 111.63z",
    fill: "#66509E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M88.741 117.002a7.02 7.02 0 01-4.69 8.418l-45.107 11.388c-3.873.606-7.675-1.864-8.593-5.808L3.529 15.366c-1.013-4.348 1.908-8.634 6.325-9.282L56.037.012a7.016 7.016 0 016.904 5.292l25.8 111.698z",
    fill: "#67509F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M88.75 117.036a6.983 6.983 0 01-4.666 8.374l-45.136 11.397c-3.845.586-7.612-1.869-8.525-5.786L3.586 15.318C2.578 10.991 5.484 6.726 9.88 6.082L56.087.005a6.982 6.982 0 016.847 5.267L88.75 117.036z",
    fill: "#6751A0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M88.76 117.069L62.925 5.239A6.947 6.947 0 0056.136 0L9.906 6.08c-4.375.641-7.267 4.885-6.263 9.19l26.853 115.773c.906 3.888 4.64 6.329 8.459 5.762l45.163-11.406a6.947 6.947 0 004.641-8.33z",
    fill: "#6851A1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M86.576 115.125L61.716 7.298a6.629 6.629 0 00-6.48-5L11.097 8.07c-4.176.612-6.936 4.662-5.978 8.772l25.918 111.466c.864 3.711 4.428 6.042 8.072 5.5l43.038-10.734a6.63 6.63 0 004.43-7.95z",
    fill: "#30274D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M86.903 114.633L62.045 6.806a6.629 6.629 0 00-6.48-5L11.423 7.578C7.248 8.19 4.49 12.24 5.446 16.35l25.918 111.467c.865 3.711 4.428 6.041 8.072 5.499l43.038-10.733a6.63 6.63 0 004.429-7.95z",
    fill: "url(#paint0_linear_3128_3574)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M10.551 55.254a.496.496 0 01-.773-.29L7.406 44.796a.497.497 0 01.965-.225l2.373 10.17a.496.496 0 01-.193.514z",
    fill: "#382E6B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M10.16 55.343a.496.496 0 01-.772-.29l-2.373-10.17a.496.496 0 01.966-.225l2.373 10.17a.497.497 0 01-.193.515z",
    fill: "#594A8E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69 42.865a.496.496 0 01-.774-.29l-2.373-10.17a.496.496 0 01.966-.225l2.373 10.17a.494.494 0 01-.193.515z",
    fill: "#382E6B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 42.953a.496.496 0 01-.774-.29L4.154 32.495a.496.496 0 01.965-.225l2.373 10.17a.496.496 0 01-.193.514z",
    fill: "#594A8E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.024,
    d: "M102.082 83.935l-46.514 6.973c-1.89.247-3.743-1.852-4.116-4.664L41.158 8.598c-.373-2.812.869-5.315 2.76-5.562L91.139 1.4c1.89-.247 3.743 1.852 4.116 4.664l9.586 72.31c.373 2.812-.869 5.315-2.759 5.561z",
    fill: "#F0ECEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.049,
    d: "M102.167 83.917l-46.384 6.955c-1.888.246-3.737-1.845-4.109-4.648L41.401 8.734c-.372-2.802.869-5.296 2.757-5.543l47.09-1.629c1.888-.247 3.737 1.845 4.11 4.648l9.567 72.164c.371 2.802-.87 5.297-2.758 5.543z",
    fill: "#ECE8E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.073,
    d: "M102.253 83.9L56 90.835c-1.886.246-3.732-1.838-4.102-4.631L41.644 8.872c-.37-2.793.87-5.28 2.756-5.525l46.957-1.622c1.886-.246 3.732 1.838 4.102 4.631l9.549 72.02c.371 2.791-.869 5.278-2.755 5.523z",
    fill: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    d: "M102.338 83.882l-46.123 6.916c-1.883.245-3.726-1.83-4.095-4.614L41.888 9.009c-.369-2.783.87-5.262 2.754-5.507l46.826-1.615c1.883-.246 3.726 1.83 4.095 4.614l9.529 71.873c.368 2.784-.87 5.262-2.754 5.508z",
    fill: "#E3DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.122,
    d: "M102.423 83.865L56.43 90.762c-1.88.245-3.72-1.823-4.088-4.597L42.132 9.146c-.369-2.774.87-5.244 2.75-5.489L91.576 2.05c1.881-.246 3.72 1.823 4.088 4.597l9.51 71.728c.368 2.773-.87 5.243-2.751 5.49z",
    fill: "#DFDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.146,
    d: "M102.51 83.846l-45.864 6.879c-1.878.245-3.714-1.817-4.08-4.58L42.374 9.282c-.367-2.764.87-5.226 2.749-5.471l46.563-1.6c1.878-.245 3.714 1.816 4.08 4.58l9.491 71.583c.367 2.764-.87 5.226-2.748 5.471z",
    fill: "#DBD7D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.171,
    d: "M102.595 83.828l-45.733 6.86c-1.876.245-3.709-1.809-4.075-4.563L42.62 9.42c-.365-2.754.87-5.209 2.746-5.453l46.431-1.593c1.876-.245 3.709 1.809 4.075 4.563l9.471 71.438c.364 2.755-.871 5.209-2.747 5.453z",
    fill: "#D6D3D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.195,
    d: "M102.681 83.81l-45.602 6.841c-1.873.245-3.704-1.801-4.068-4.546L42.862 9.557c-.363-2.744.871-5.19 2.744-5.435l46.3-1.585c1.873-.245 3.703 1.801 4.067 4.546l9.452 71.293c.364 2.745-.87 5.19-2.744 5.435z",
    fill: "#D2CECE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M102.767 83.793l-45.473 6.82c-1.87.245-3.698-1.794-4.06-4.529L43.105 9.694c-.362-2.735.871-5.173 2.742-5.417l46.168-1.578c1.87-.244 3.698 1.794 4.06 4.53l9.433 71.147c.363 2.735-.871 5.173-2.741 5.417z",
    fill: "#CECACA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.244,
    d: "M102.852 83.775L57.51 90.578c-1.868.244-3.692-1.787-4.054-4.513L43.35 9.83c-.361-2.726.871-5.156 2.74-5.4l46.035-1.57c1.868-.244 3.692 1.787 4.054 4.513l9.413 71.002c.362 2.725-.871 5.155-2.739 5.4z",
    fill: "#CAC6C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.268,
    d: "M102.939 83.757l-45.213 6.784c-1.866.243-3.686-1.78-4.046-4.496L43.593 9.968c-.36-2.716.871-5.138 2.737-5.381l45.905-1.563c1.865-.244 3.686 1.78 4.046 4.495l9.394 70.857c.361 2.716-.872 5.138-2.736 5.381z",
    fill: "#C6C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.293,
    d: "M103.024 83.74l-45.082 6.764c-1.863.244-3.681-1.772-4.04-4.479l-10.065-75.92c-.36-2.707.871-5.12 2.734-5.363l45.773-1.556c1.863-.244 3.68 1.772 4.04 4.479l9.375 70.71c.359 2.708-.872 5.121-2.735 5.365z",
    fill: "#C1BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.317,
    d: "M103.11 83.721l-44.953 6.746c-1.86.243-3.675-1.766-4.033-4.463L44.08 10.242c-.357-2.697.873-5.103 2.733-5.345l45.64-1.549c1.86-.243 3.675 1.766 4.033 4.463l9.356 70.565c.358 2.697-.872 5.103-2.732 5.345z",
    fill: "#BDB9BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.342,
    d: "M103.195 83.704L58.373 90.43c-1.858.242-3.67-1.758-4.026-4.446L44.323 10.379c-.356-2.687.872-5.084 2.73-5.327l45.51-1.542c1.858-.242 3.67 1.758 4.026 4.446l9.336 70.421c.356 2.687-.872 5.085-2.73 5.327z",
    fill: "#B9B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.366,
    d: "M103.282 83.686L58.59 90.394c-1.856.242-3.664-1.751-4.019-4.43L44.568 10.517c-.355-2.678.872-5.067 2.728-5.31l45.377-1.534c1.856-.242 3.664 1.751 4.02 4.429l9.316 70.275c.356 2.679-.872 5.067-2.727 5.31z",
    fill: "#B5B1B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M103.367 83.668l-44.562 6.689c-1.853.241-3.658-1.744-4.012-4.412l-9.982-75.292c-.354-2.668.873-5.05 2.725-5.291l45.247-1.527c1.853-.242 3.658 1.744 4.012 4.412l9.298 70.13c.353 2.668-.873 5.05-2.726 5.291z",
    fill: "#B0ADAD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.415,
    d: "M103.453 83.65l-44.432 6.67c-1.85.242-3.652-1.735-4.005-4.395L45.054 10.79c-.352-2.658.873-5.032 2.724-5.272l45.114-1.52c1.85-.242 3.653 1.736 4.005 4.395l9.279 69.985c.352 2.658-.873 5.031-2.723 5.272z",
    fill: "#ACA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    d: "M103.539 83.632l-44.302 6.651c-1.848.241-3.647-1.729-3.998-4.378l-9.94-74.978c-.352-2.65.872-5.014 2.72-5.255L93.004 4.16C94.85 3.92 96.649 5.89 97 8.54l9.26 69.84c.35 2.648-.875 5.013-2.722 5.253z",
    fill: "#A8A4A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.463,
    d: "M103.625 83.614l-44.172 6.633c-1.845.24-3.641-1.722-3.991-4.362l-9.92-74.822c-.35-2.64.874-4.996 2.719-5.236l44.851-1.505c1.845-.241 3.642 1.722 3.991 4.36l9.241 69.695c.349 2.64-.874 4.997-2.719 5.237z",
    fill: "#A4A0A1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.488,
    d: "M103.711 83.597L59.67 90.21c-1.843.24-3.636-1.714-3.984-4.345l-9.9-74.664c-.349-2.63.873-4.979 2.716-5.22l44.72-1.497c1.842-.24 3.635 1.714 3.984 4.345l9.221 69.549c.349 2.63-.873 4.979-2.716 5.219z",
    fill: "#A09C9D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.512,
    d: "M103.795 83.58l-43.911 6.593c-1.84.24-3.63-1.707-3.977-4.328l-9.878-74.507c-.347-2.62.874-4.961 2.714-5.201l44.588-1.49c1.84-.24 3.63 1.707 3.977 4.328l9.202 69.403c.347 2.62-.874 4.961-2.715 5.201z",
    fill: "#9B9899"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.537,
    d: "M103.881 83.561l-43.78 6.576c-1.838.24-3.625-1.7-3.971-4.312l-9.858-74.35c-.345-2.611.875-4.943 2.712-5.183L93.44 4.808c1.838-.24 3.624 1.7 3.971 4.312l9.183 69.258c.345 2.611-.875 4.943-2.713 5.183z",
    fill: "#979495"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.561,
    d: "M103.968 83.543L60.317 90.1c-1.835.24-3.619-1.693-3.964-4.294l-9.837-74.193c-.345-2.602.875-4.926 2.71-5.165L93.551 4.97c1.835-.24 3.618 1.693 3.964 4.294l9.163 69.113c.344 2.602-.875 4.926-2.71 5.165z",
    fill: "#939091"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.585,
    d: "M104.053 83.526l-43.52 6.537c-1.833.24-3.614-1.685-3.957-4.277L46.76 11.749c-.344-2.592.875-4.908 2.707-5.147L93.66 5.134c1.833-.24 3.614 1.685 3.957 4.277l9.144 68.968c.343 2.591-.875 4.908-2.708 5.147z",
    fill: "#8F8B8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M104.139 83.507l-43.39 6.519c-1.83.239-3.608-1.679-3.95-4.26l-9.796-73.88c-.343-2.582.875-4.89 2.705-5.129l44.06-1.461c1.83-.24 3.608 1.678 3.95 4.26l9.125 68.823c.343 2.582-.875 4.89-2.704 5.128z",
    fill: "#8B8789"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.634,
    d: "M104.225 83.49l-43.26 6.499c-1.828.238-3.602-1.672-3.943-4.244l-9.775-73.722c-.341-2.573.875-4.873 2.703-5.11l43.93-1.455c1.826-.238 3.601 1.672 3.942 4.244l9.105 68.677c.341 2.572-.875 4.872-2.702 5.11z",
    fill: "#868384"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.658,
    d: "M104.31 83.472l-43.13 6.48c-1.825.24-3.596-1.663-3.936-4.226L47.49 12.159c-.34-2.563.875-4.854 2.7-5.092L93.988 5.62c1.826-.238 3.597 1.664 3.937 4.227l9.086 68.532c.34 2.563-.876 4.855-2.701 5.093z",
    fill: "#827F80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.683,
    d: "M104.397 83.454l-43 6.462c-1.823.237-3.591-1.657-3.93-4.21l-9.733-73.41c-.338-2.553.876-4.837 2.699-5.074l43.666-1.44c1.823-.237 3.59 1.657 3.93 4.21l9.066 68.388c.338 2.553-.876 4.837-2.698 5.075z",
    fill: "#7E7B7C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.707,
    d: "M104.482 83.436l-42.87 6.443c-1.82.238-3.585-1.65-3.922-4.193l-9.713-73.253c-.337-2.543.876-4.819 2.696-5.056l43.534-1.432c1.82-.238 3.585 1.65 3.922 4.193l9.049 68.242c.336 2.543-.877 4.819-2.696 5.056z",
    fill: "#7A7678"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.732,
    d: "M104.567 83.419l-42.74 6.423c-1.818.237-3.58-1.642-3.915-4.176l-9.69-73.095c-.337-2.535.875-4.802 2.693-5.04l43.402-1.424c1.818-.237 3.58 1.642 3.915 4.177l9.029 68.096c.336 2.535-.876 4.802-2.694 5.039z",
    fill: "#757274"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.756,
    d: "M104.653 83.4l-42.61 6.405c-1.815.237-3.573-1.635-3.907-4.16l-9.671-72.938c-.335-2.524.876-4.784 2.691-5.02L94.427 6.27c1.815-.237 3.574 1.635 3.908 4.16l9.009 67.95c.335 2.525-.876 4.784-2.691 5.02z",
    fill: "#716E70"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M104.738 83.383l-42.48 6.386c-1.812.236-3.567-1.628-3.9-4.143l-9.65-72.781c-.334-2.516.876-4.767 2.688-5.003l43.14-1.41c1.812-.237 3.567 1.628 3.901 4.143l8.99 67.805c.334 2.515-.876 4.766-2.689 5.003z",
    fill: "#6D6A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.805,
    d: "M104.825 83.365l-42.35 6.367c-1.81.236-3.562-1.621-3.894-4.126l-9.629-72.624c-.332-2.506.877-4.75 2.687-4.985l43.008-1.402c1.81-.237 3.562 1.62 3.895 4.126l8.97 67.66c.332 2.505-.877 4.748-2.687 4.984z",
    fill: "#696668"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.829,
    d: "M104.911 83.348l-42.22 6.348c-1.807.235-3.556-1.614-3.887-4.11L49.196 13.12c-.33-2.496.877-4.731 2.684-4.967l42.877-1.395c1.807-.236 3.556 1.613 3.887 4.109l8.951 67.515c.332 2.496-.876 4.731-2.684 4.967z",
    fill: "#656164"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.854,
    d: "M104.996 83.33l-42.09 6.328c-1.805.236-3.551-1.606-3.88-4.092l-9.588-72.31c-.33-2.486.877-4.713 2.682-4.949L94.865 6.92c1.805-.235 3.551 1.606 3.88 4.093l8.933 67.37c.329 2.485-.878 4.712-2.682 4.947z",
    fill: "#605D60"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.878,
    d: "M105.082 83.311l-41.96 6.31c-1.802.236-3.545-1.598-3.873-4.075l-9.566-72.154c-.329-2.476.877-4.696 2.68-4.93L94.975 7.08c1.803-.235 3.546 1.599 3.874 4.075l8.913 67.225c.328 2.477-.878 4.695-2.68 4.93z",
    fill: "#5C595B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M105.168 83.293l-41.829 6.291c-1.8.236-3.54-1.591-3.867-4.059L49.927 13.53c-.328-2.467.877-4.678 2.677-4.913l42.48-1.373c1.8-.236 3.54 1.591 3.868 4.059l8.893 67.079c.328 2.467-.877 4.678-2.677 4.912z",
    fill: "#585557"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.927,
    d: "M105.253 83.276l-41.699 6.272c-1.797.235-3.534-1.584-3.86-4.042l-9.525-71.84c-.325-2.457.879-4.66 2.676-4.894l42.35-1.366c1.796-.234 3.533 1.585 3.86 4.042l8.873 66.934c.326 2.457-.878 4.66-2.675 4.894z",
    fill: "#545153"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.951,
    d: "M105.34 83.258l-41.57 6.254c-1.794.234-3.528-1.578-3.852-4.025l-9.504-71.684c-.324-2.447.878-4.642 2.673-4.876l42.218-1.359c1.794-.234 3.528 1.577 3.852 4.025l8.855 66.79c.325 2.447-.878 4.641-2.672 4.875z",
    fill: "#4F4C4F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    d: "M105.424 83.24l-41.439 6.234c-1.792.234-3.523-1.57-3.846-4.008L50.656 13.94c-.323-2.438.879-4.624 2.67-4.858L95.414 7.73c1.792-.234 3.523 1.57 3.846 4.008l8.836 66.644c.323 2.437-.879 4.624-2.671 4.857z",
    fill: "#4B484B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.51 83.223l-41.309 6.215c-1.79.234-3.517-1.562-3.839-3.99L50.9 14.077c-.322-2.429.879-4.608 2.668-4.84l41.955-1.345c1.789-.234 3.517 1.563 3.838 3.991l8.817 66.498c.322 2.43-.878 4.608-2.668 4.84z",
    fill: "#474447"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M115.57 83.214l-52.678 7.658c-2.36.086-4.558-1.867-4.885-4.339l-9.88-74.55C47.797 9.51 49.46 7.416 51.82 7.33l53.335-2.703c2.359-.086 4.558 1.867 4.885 4.339l9.224 69.597c.327 2.472-1.335 4.565-3.694 4.65z",
    fill: "#F4F0EF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M116.906 83.045l-52.678 7.658c-2.36.086-4.558-1.867-4.885-4.339l-9.88-74.552c-.329-2.472 1.334-4.565 3.693-4.65l53.335-2.704c2.359-.086 4.558 1.867 4.885 4.34l9.224 69.596c.327 2.473-1.335 4.566-3.694 4.651z",
    fill: "url(#paint1_linear_3128_3574)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.024,
    d: "M115.317 86.496l-42.71 4.216c-1.734.138-3.325-1.86-3.536-4.44L63.26 15.038c-.211-2.58 1.036-4.804 2.77-4.942l43.11.68c1.734-.138 3.326 1.86 3.537 4.44l5.411 66.338c.21 2.58-1.037 4.804-2.771 4.942z",
    fill: "#F0ECEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.049,
    d: "M115.396 86.484l-42.59 4.204c-1.733.138-3.322-1.853-3.532-4.424l-5.799-71.09c-.21-2.571 1.036-4.787 2.768-4.925l42.989.68c1.732-.137 3.321 1.854 3.531 4.425l5.401 66.205c.21 2.57-1.036 4.787-2.768 4.925z",
    fill: "#ECE8E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.073,
    d: "M115.474 86.472l-42.47 4.193c-1.73.138-3.317-1.846-3.526-4.409L63.691 15.31c-.209-2.562 1.035-4.77 2.765-4.909l42.869.682c1.73-.138 3.316 1.846 3.525 4.409l5.39 66.071c.208 2.562-1.036 4.77-2.766 4.909z",
    fill: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    d: "M115.553 86.459L73.202 90.64c-1.728.137-3.311-1.84-3.52-4.393l-5.776-70.803c-.209-2.553 1.035-4.755 2.762-4.892l42.748.682c1.727-.137 3.311 1.84 3.52 4.393l5.379 65.939c.209 2.553-1.035 4.755-2.762 4.892z",
    fill: "#E3DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.122,
    d: "M115.632 86.446L73.4 90.618c-1.725.136-3.306-1.833-3.514-4.378l-5.764-70.658c-.207-2.545 1.035-4.74 2.76-4.877l42.627.683c1.725-.137 3.307 1.833 3.514 4.377l5.368 65.806c.208 2.544-1.033 4.738-2.759 4.875z",
    fill: "#DFDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.146,
    d: "M115.711 86.434l-42.112 4.16c-1.723.137-3.302-1.826-3.509-4.362l-5.752-70.514c-.207-2.537 1.034-4.723 2.756-4.86l42.508.683c1.722-.137 3.301 1.826 3.508 4.362l5.357 65.672c.208 2.536-1.032 4.722-2.756 4.86z",
    fill: "#DBD7D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.171,
    d: "M115.791 86.422L73.798 90.57c-1.72.138-3.297-1.818-3.503-4.346l-5.741-70.37c-.207-2.527 1.033-4.706 2.753-4.843l42.387.683c1.721-.137 3.297 1.819 3.504 4.346l5.346 65.539c.206 2.527-1.033 4.706-2.753 4.843z",
    fill: "#D6D3D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.195,
    d: "M115.868 86.41l-41.873 4.137c-1.719.137-3.292-1.812-3.498-4.33L64.768 15.99c-.205-2.519 1.033-4.691 2.751-4.827l42.267.684c1.719-.137 3.292 1.812 3.498 4.33l5.335 65.405c.205 2.518-1.032 4.69-2.751 4.827z",
    fill: "#D2CECE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M115.948 86.398l-41.754 4.126c-1.716.136-3.288-1.806-3.493-4.315l-5.717-70.083c-.205-2.509 1.032-4.674 2.748-4.81l42.146.684c1.716-.136 3.288 1.806 3.493 4.315l5.324 65.271c.205 2.51-1.031 4.676-2.747 4.812z",
    fill: "#CECACA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.244,
    d: "M116.028 86.385L74.393 90.5c-1.714.137-3.282-1.798-3.487-4.299l-5.705-69.939c-.204-2.5 1.03-4.658 2.745-4.794l42.026.685c1.714-.136 3.282 1.799 3.487 4.3l5.313 65.138c.205 2.502-1.031 4.66-2.744 4.795z",
    fill: "#CAC6C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.268,
    d: "M116.106 86.373l-41.515 4.103c-1.712.136-3.278-1.791-3.481-4.283l-5.694-69.795c-.203-2.492 1.03-4.641 2.742-4.778l41.906.686c1.711-.136 3.278 1.791 3.481 4.283l5.303 65.006c.203 2.492-1.031 4.642-2.742 4.778z",
    fill: "#C6C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.293,
    d: "M116.185 86.36L74.79 90.454c-1.709.135-3.273-1.785-3.476-4.268l-5.682-69.65c-.202-2.484 1.03-4.627 2.739-4.762l41.785.686c1.709-.136 3.273 1.785 3.476 4.268l5.292 64.872c.203 2.483-1.029 4.626-2.739 4.762z",
    fill: "#C1BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.317,
    d: "M116.264 86.349l-41.277 4.08c-1.707.136-3.268-1.777-3.47-4.252l-5.67-69.507c-.202-2.475 1.029-4.61 2.736-4.746l41.665.688c1.707-.136 3.268 1.777 3.47 4.252l5.281 64.739c.203 2.475-1.029 4.61-2.735 4.746z",
    fill: "#BDB9BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.342,
    d: "M116.344 86.336l-41.157 4.07c-1.704.135-3.263-1.771-3.464-4.237l-5.659-69.363c-.2-2.465 1.03-4.594 2.733-4.729l41.545.688c1.704-.136 3.263 1.771 3.464 4.237l5.27 64.605c.201 2.466-1.028 4.594-2.732 4.73z",
    fill: "#B9B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.366,
    d: "M116.422 86.324l-41.038 4.058c-1.702.135-3.258-1.764-3.459-4.221l-5.647-69.219c-.2-2.457 1.028-4.578 2.73-4.713l41.425.689c1.702-.136 3.259 1.764 3.459 4.22l5.26 64.473c.2 2.457-1.028 4.578-2.73 4.713z",
    fill: "#B5B1B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M116.5 86.311l-40.918 4.047c-1.7.135-3.253-1.757-3.453-4.205l-5.635-69.075c-.2-2.448 1.027-4.561 2.727-4.696l41.305.689c1.699-.135 3.253 1.757 3.453 4.205l5.248 64.34c.2 2.447-1.027 4.56-2.727 4.695z",
    fill: "#B0ADAD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.415,
    d: "M116.58 86.3l-40.799 4.035c-1.697.135-3.249-1.75-3.447-4.19l-5.623-68.93c-.2-2.44 1.026-4.546 2.724-4.681l41.184.69c1.697-.135 3.249 1.75 3.448 4.19l5.237 64.205c.199 2.44-1.027 4.545-2.724 4.68z",
    fill: "#ACA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    d: "M116.659 86.287L75.98 90.311c-1.695.134-3.243-1.743-3.442-4.174L66.926 17.35c-.198-2.43 1.027-4.529 2.722-4.664l41.063.69c1.696-.134 3.244 1.744 3.443 4.175l5.226 64.072c.199 2.43-1.026 4.529-2.721 4.664z",
    fill: "#A8A4A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.463,
    d: "M116.737 86.275l-40.56 4.013c-1.692.135-3.239-1.737-3.436-4.158l-5.6-68.643c-.197-2.422 1.026-4.513 2.719-4.648l40.943.691c1.693-.134 3.239 1.737 3.437 4.159l5.215 63.938c.198 2.422-1.025 4.514-2.718 4.648z",
    fill: "#A4A0A1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.488,
    d: "M116.817 86.262l-40.44 4.001c-1.69.135-3.234-1.73-3.431-4.143l-5.588-68.498c-.197-2.412 1.025-4.497 2.715-4.631l40.823.692c1.69-.135 3.234 1.73 3.432 4.143l5.204 63.805c.198 2.412-1.024 4.497-2.715 4.63z",
    fill: "#A09C9D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.512,
    d: "M116.896 86.25l-40.32 3.99c-1.689.135-3.23-1.722-3.426-4.126l-5.577-68.355c-.196-2.404 1.025-4.48 2.713-4.615l40.702.692c1.688-.134 3.23 1.723 3.426 4.127l5.194 63.673c.196 2.403-1.024 4.48-2.712 4.614z",
    fill: "#9B9899"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.537,
    d: "M116.975 86.238l-40.201 3.98c-1.686.133-3.225-1.717-3.42-4.112l-5.565-68.211c-.195-2.396 1.024-4.465 2.71-4.599l40.582.693c1.686-.134 3.225 1.717 3.42 4.112l5.184 63.54c.195 2.394-1.024 4.463-2.71 4.597z",
    fill: "#979495"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.561,
    d: "M117.053 86.226l-40.082 3.967c-1.683.134-3.22-1.71-3.415-4.095L68.005 18.03c-.195-2.386 1.023-4.448 2.706-4.582l40.462.693c1.683-.134 3.22 1.71 3.415 4.096l5.173 63.406c.195 2.387-1.023 4.449-2.707 4.583z",
    fill: "#939091"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.585,
    d: "M117.133 86.214L77.17 90.17c-1.68.134-3.215-1.702-3.409-4.08L68.22 18.167c-.195-2.378 1.022-4.433 2.704-4.566l40.341.694c1.682-.134 3.215 1.702 3.41 4.08l5.161 63.273c.194 2.377-1.023 4.432-2.703 4.566z",
    fill: "#8F8B8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M117.211 86.2l-39.843 3.946c-1.678.133-3.21-1.696-3.403-4.064l-5.53-67.78c-.193-2.368 1.022-4.416 2.701-4.55l40.222.695c1.678-.133 3.21 1.696 3.403 4.064l5.151 63.14c.193 2.37-1.022 4.417-2.701 4.55z",
    fill: "#8B8789"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.634,
    d: "M117.291 86.189l-39.724 3.933c-1.676.133-3.205-1.689-3.398-4.049L68.652 18.44c-.193-2.36 1.022-4.4 2.698-4.534l40.101.695c1.677-.133 3.206 1.688 3.398 4.048l5.141 63.006c.191 2.362-1.023 4.401-2.699 4.535z",
    fill: "#868384"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.658,
    d: "M117.37 86.177l-39.604 3.922c-1.674.133-3.201-1.682-3.392-4.033l-5.506-67.491c-.192-2.351 1.02-4.384 2.695-4.517l39.98.695c1.674-.133 3.201 1.682 3.393 4.034l5.129 62.872c.192 2.352-1.021 4.384-2.695 4.517z",
    fill: "#827F80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.683,
    d: "M117.448 86.164l-39.484 3.911c-1.672.133-3.196-1.675-3.387-4.017L69.082 18.71c-.19-2.343 1.02-4.368 2.693-4.5l39.86.695c1.672-.132 3.196 1.675 3.387 4.018l5.119 62.74c.191 2.343-1.021 4.368-2.693 4.5z",
    fill: "#7E7B7C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.707,
    d: "M117.527 86.152l-39.365 3.9c-1.67.133-3.192-1.668-3.382-4.002l-5.482-67.203c-.19-2.334 1.02-4.352 2.69-4.485l39.739.697c1.67-.132 3.191 1.668 3.382 4.002l5.107 62.606c.19 2.334-1.019 4.352-2.689 4.485z",
    fill: "#7A7678"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.732,
    d: "M117.606 86.139L78.36 90.028c-1.667.132-3.186-1.662-3.376-3.986l-5.47-67.06c-.19-2.324 1.019-4.335 2.686-4.468l39.619.698c1.667-.133 3.186 1.66 3.376 3.986l5.097 62.473c.19 2.325-1.019 4.336-2.686 4.468z",
    fill: "#757274"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.756,
    d: "M117.686 86.127l-39.127 3.877c-1.664.133-3.181-1.654-3.37-3.97l-5.46-66.915c-.189-2.316 1.019-4.32 2.684-4.452l39.499.698c1.665-.133 3.182 1.654 3.371 3.97l5.085 62.34c.19 2.317-1.018 4.32-2.682 4.452z",
    fill: "#716E70"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M117.765 86.115L78.758 89.98c-1.663.132-3.177-1.648-3.365-3.955l-5.447-66.77c-.188-2.308 1.018-4.304 2.68-4.436l39.38.698c1.662-.132 3.176 1.648 3.365 3.955l5.074 62.207c.188 2.306-1.018 4.303-2.68 4.435z",
    fill: "#6D6A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.805,
    d: "M117.843 86.103l-38.888 3.854c-1.66.132-3.172-1.64-3.359-3.939l-5.435-66.627c-.188-2.3 1.017-4.288 2.677-4.42l39.26.7c1.66-.132 3.172 1.64 3.359 3.94l5.064 62.072c.187 2.299-1.018 4.288-2.678 4.42z",
    fill: "#696668"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.829,
    d: "M117.922 86.09l-38.768 3.844c-1.658.132-3.166-1.634-3.353-3.924l-5.424-66.483c-.187-2.29 1.017-4.271 2.674-4.403l39.139.7c1.658-.132 3.167 1.634 3.354 3.924l5.053 61.94c.186 2.29-1.017 4.27-2.675 4.403z",
    fill: "#656164"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.854,
    d: "M118.001 86.078L79.352 89.91c-1.655.131-3.162-1.627-3.348-3.908l-5.412-66.34c-.186-2.28 1.017-4.254 2.672-4.386l39.018.701c1.656-.131 3.163 1.627 3.349 3.908l5.042 61.806c.185 2.281-1.017 4.255-2.672 4.387z",
    fill: "#605D60"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.878,
    d: "M118.08 86.066l-38.529 3.82c-1.653.132-3.157-1.62-3.343-3.892l-5.4-66.195c-.185-2.273 1.016-4.24 2.669-4.37l38.897.7c1.653-.13 3.158 1.62 3.343 3.893l5.032 61.673c.185 2.273-1.016 4.24-2.669 4.37z",
    fill: "#5C595B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M118.16 86.053l-38.41 3.81c-1.65.132-3.152-1.613-3.337-3.876l-5.388-66.051c-.185-2.264 1.015-4.223 2.665-4.354l38.777.702c1.652-.132 3.153 1.613 3.338 3.876l5.02 61.54c.185 2.263-1.014 4.222-2.665 4.353z",
    fill: "#585557"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.927,
    d: "M118.237 86.041l-38.29 3.799c-1.648.131-3.147-1.606-3.331-3.862l-5.377-65.907c-.184-2.255 1.015-4.207 2.663-4.338l38.657.703c1.649-.132 3.148 1.606 3.332 3.86l5.009 61.408c.184 2.255-1.014 4.206-2.663 4.337z",
    fill: "#545153"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.951,
    d: "M118.317 86.03l-38.17 3.786c-1.647.13-3.144-1.6-3.327-3.845l-5.365-65.764c-.183-2.246 1.014-4.19 2.66-4.32l38.536.702c1.646-.13 3.144 1.6 3.327 3.846l4.998 61.273c.184 2.246-1.013 4.19-2.659 4.321z",
    fill: "#4F4C4F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    d: "M118.396 86.017l-38.051 3.776c-1.644.13-3.138-1.593-3.32-3.83l-5.354-65.62c-.183-2.236 1.013-4.174 2.657-4.304l38.417.703c1.644-.13 3.138 1.593 3.32 3.83l4.988 61.14c.183 2.237-1.013 4.174-2.657 4.305z",
    fill: "#4B484B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.475 86.004l-37.931 3.764c-1.642.131-3.134-1.585-3.315-3.813l-5.342-65.476c-.181-2.228 1.013-4.158 2.654-4.288l38.297.704c1.641-.13 3.133 1.585 3.315 3.814l4.977 61.007c.181 2.228-1.014 4.158-2.655 4.288z",
    fill: "#474447"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M142.286 95.142l-58.47 3.691c-2.594-.006-4.883-2.044-5.087-4.529l-6.082-74.557c-.203-2.485 1.755-4.513 4.35-4.506l58.626-1.776c2.595.006 4.884 2.044 5.087 4.529l5.926 72.641c.202 2.485-1.755 4.513-4.35 4.507z",
    fill: "#F4F0EF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M143.764 95.025l-58.47 3.691c-2.595-.006-4.884-2.044-5.087-4.529L74.125 19.63c-.203-2.485 1.755-4.513 4.35-4.507l58.626-1.776c2.595.007 4.884 2.045 5.087 4.53l5.926 72.64c.202 2.486-1.755 4.514-4.35 4.508z",
    fill: "url(#paint2_linear_3128_3574)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.024,
    d: "M141.969 95.668l-50.68 1.369c-2.358.063-4.335-1.745-4.392-4.019l-1.804-71.77c-.057-2.274 1.826-4.186 4.184-4.25l50.68-1.37c2.358-.063 4.334 1.745 4.392 4.02l1.804 71.769c.057 2.274-1.826 4.187-4.184 4.25z",
    fill: "#F0ECEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.049,
    d: "M141.978 95.658l-50.513 1.365c-2.353.063-4.325-1.741-4.382-4.01l-1.802-71.685c-.056-2.27 1.822-4.178 4.176-4.241l50.513-1.365c2.353-.063 4.325 1.74 4.382 4.01l1.801 71.685c.057 2.269-1.822 4.178-4.175 4.241z",
    fill: "#ECE8E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.073,
    d: "M141.987 95.648l-50.346 1.36c-2.348.064-4.315-1.736-4.372-4l-1.8-71.601c-.057-2.264 1.818-4.168 4.166-4.231l50.346-1.36c2.348-.064 4.315 1.736 4.372 4l1.8 71.6c.057 2.265-1.818 4.169-4.166 4.232z",
    fill: "#E7E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    d: "M141.997 95.639l-50.18 1.356c-2.342.063-4.305-1.734-4.362-3.992l-1.797-71.516c-.058-2.26 1.813-4.159 4.155-4.222l50.18-1.356c2.343-.063 4.306 1.733 4.363 3.992l1.797 71.516c.057 2.259-1.813 4.158-4.156 4.222z",
    fill: "#E3DFDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.122,
    d: "M142.006 95.63l-50.012 1.35c-2.338.064-4.296-1.729-4.353-3.982l-1.795-71.431c-.056-2.254 1.81-4.15 4.147-4.212l50.012-1.352c2.338-.063 4.296 1.73 4.353 3.983l1.795 71.431c.057 2.254-1.809 4.15-4.147 4.212z",
    fill: "#DFDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.146,
    d: "M142.016 95.62L92.17 96.967c-2.332.062-4.287-1.726-4.343-3.974l-1.793-71.347c-.057-2.248 1.805-4.14 4.137-4.203l49.846-1.347c2.332-.062 4.286 1.726 4.343 3.974l1.793 71.346c.056 2.25-1.806 4.141-4.137 4.204z",
    fill: "#DBD7D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.171,
    d: "M142.025 95.61l-49.68 1.342c-2.326.063-4.276-1.722-4.332-3.965l-1.791-71.262c-.056-2.243 1.8-4.13 4.128-4.194l49.679-1.342c2.327-.063 4.277 1.722 4.333 3.965l1.791 71.262c.056 2.243-1.801 4.13-4.128 4.193z",
    fill: "#D6D3D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.195,
    d: "M142.034 95.6l-49.512 1.338c-2.322.063-4.267-1.718-4.324-3.956L86.41 21.805c-.057-2.239 1.797-4.122 4.118-4.184l49.513-1.338c2.321-.063 4.267 1.717 4.323 3.956l1.788 71.177c.057 2.238-1.796 4.121-4.118 4.184z",
    fill: "#D2CECE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M142.044 95.59l-49.345 1.333c-2.316.063-4.257-1.714-4.313-3.947l-1.787-71.093c-.056-2.233 1.793-4.112 4.109-4.174l49.345-1.333c2.317-.063 4.258 1.713 4.314 3.947l1.786 71.092c.057 2.234-1.793 4.113-4.109 4.175z",
    fill: "#CECACA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.244,
    d: "M142.052 95.581L92.873 96.91c-2.31.063-4.247-1.71-4.303-3.938l-1.785-71.008c-.055-2.228 1.79-4.103 4.1-4.165l49.179-1.328c2.311-.062 4.248 1.71 4.304 3.938l1.784 71.008c.057 2.228-1.788 4.103-4.1 4.165z",
    fill: "#CAC6C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.268,
    d: "M142.063 95.571l-49.012 1.324c-2.305.062-4.237-1.705-4.294-3.929l-1.782-70.923c-.056-2.223 1.785-4.094 4.09-4.156l49.012-1.324c2.306-.062 4.238 1.705 4.294 3.929l1.782 70.924c.056 2.223-1.784 4.093-4.09 4.155z",
    fill: "#C6C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.293,
    d: "M142.071 95.562L93.227 96.88c-2.3.062-4.228-1.702-4.284-3.92l-1.78-70.839c-.056-2.218 1.78-4.084 4.08-4.146l48.845-1.32c2.301-.061 4.229 1.703 4.284 3.921l1.781 70.838c.055 2.219-1.781 4.084-4.082 4.147z",
    fill: "#C1BEBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.317,
    d: "M142.082 95.552l-48.678 1.315c-2.296.062-4.219-1.698-4.275-3.911l-1.778-70.754c-.056-2.213 1.776-4.074 4.072-4.137l48.678-1.314c2.295-.063 4.218 1.697 4.274 3.91l1.778 70.755c.056 2.213-1.776 4.074-4.071 4.136z",
    fill: "#BDB9BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.342,
    d: "M142.091 95.543l-48.511 1.31c-2.29.062-4.209-1.694-4.265-3.902L87.54 22.28c-.055-2.208 1.773-4.065 4.063-4.127l48.511-1.31c2.29-.062 4.209 1.694 4.265 3.902l1.776 70.67c.055 2.207-1.774 4.065-4.063 4.127z",
    fill: "#B9B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.366,
    d: "M142.1 95.533l-48.345 1.306c-2.284.061-4.2-1.69-4.254-3.894l-1.774-70.584c-.055-2.204 1.769-4.056 4.053-4.118l48.344-1.306c2.285-.061 4.2 1.69 4.255 3.894l1.774 70.584c.056 2.203-1.768 4.056-4.053 4.118z",
    fill: "#B5B1B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M142.109 95.523l-48.177 1.301c-2.28.062-4.19-1.686-4.245-3.884l-1.772-70.5c-.055-2.198 1.765-4.047 4.044-4.109l48.177-1.301c2.279-.062 4.19 1.686 4.245 3.884l1.772 70.5c.055 2.198-1.764 4.047-4.044 4.109z",
    fill: "#B0ADAD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.415,
    d: "M142.118 95.514l-48.01 1.297c-2.275.061-4.18-1.683-4.236-3.876l-1.77-70.415c-.054-2.193 1.761-4.038 4.036-4.1l48.01-1.296c2.274-.062 4.18 1.682 4.235 3.875l1.77 70.416c.055 2.193-1.761 4.037-4.035 4.099z",
    fill: "#ACA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    d: "M142.128 95.504l-47.843 1.293c-2.27.061-4.17-1.679-4.225-3.867L88.292 22.6c-.055-2.189 1.757-4.029 4.025-4.09l47.844-1.292c2.269-.062 4.17 1.678 4.225 3.866l1.767 70.331c.055 2.188-1.756 4.028-4.025 4.09z",
    fill: "#A8A4A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.463,
    d: "M142.137 95.494L94.46 96.782c-2.264.062-4.16-1.675-4.215-3.857l-1.766-70.246c-.055-2.183 1.752-4.02 4.016-4.08l47.677-1.288c2.264-.06 4.161 1.675 4.215 3.858l1.766 70.246c.055 2.182-1.752 4.018-4.016 4.08z",
    fill: "#A4A0A1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.488,
    d: "M142.147 95.485l-47.51 1.283c-2.258.061-4.15-1.67-4.206-3.848l-1.763-70.162c-.054-2.177 1.749-4.009 4.007-4.07l47.51-1.283c2.258-.061 4.15 1.67 4.205 3.848l1.763 70.162c.056 2.177-1.748 4.008-4.006 4.07z",
    fill: "#A09C9D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.512,
    d: "M142.155 95.475l-47.343 1.28c-2.253.06-4.141-1.668-4.196-3.84l-1.761-70.077c-.055-2.173 1.744-4 3.997-4.06l47.344-1.28c2.253-.06 4.141 1.668 4.196 3.84l1.761 70.077c.054 2.171-1.745 4-3.998 4.06z",
    fill: "#9B9899"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.537,
    d: "M142.165 95.466L94.989 96.74c-2.248.061-4.131-1.663-4.186-3.83l-1.759-69.993c-.054-2.167 1.74-3.99 3.988-4.051l47.176-1.275c2.248-.06 4.132 1.664 4.186 3.83l1.759 69.993c.055 2.168-1.74 3.99-3.988 4.052z",
    fill: "#979495"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.561,
    d: "M142.174 95.456l-47.01 1.27c-2.242.06-4.121-1.66-4.176-3.821l-1.756-69.908c-.055-2.162 1.736-3.981 3.978-4.042l47.01-1.27c2.242-.06 4.122 1.66 4.176 3.821l1.757 69.908c.054 2.162-1.737 3.981-3.979 4.042z",
    fill: "#939091"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.585,
    d: "M142.183 95.446l-46.842 1.266c-2.237.06-4.113-1.655-4.167-3.813l-1.755-69.823c-.054-2.157 1.732-3.972 3.97-4.033l46.842-1.265c2.237-.06 4.112 1.655 4.167 3.812l1.755 69.824c.054 2.157-1.732 3.972-3.97 4.032z",
    fill: "#8F8B8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M142.193 95.436l-46.676 1.261c-2.232.06-4.103-1.65-4.156-3.803l-1.753-69.739c-.054-2.152 1.727-3.962 3.96-4.022l46.675-1.261c2.232-.06 4.103 1.651 4.157 3.803l1.753 69.74c.054 2.151-1.728 3.961-3.96 4.021z",
    fill: "#8B8789"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.634,
    d: "M142.202 95.427l-46.509 1.256c-2.227.06-4.093-1.647-4.147-3.795l-1.75-69.653c-.054-2.147 1.724-3.953 3.951-4.013l46.509-1.257c2.227-.06 4.093 1.648 4.147 3.795l1.75 69.654c.054 2.147-1.724 3.952-3.951 4.013z",
    fill: "#868384"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.658,
    d: "M142.211 95.417L95.869 96.67c-2.221.06-4.083-1.643-4.137-3.785l-1.748-69.57c-.054-2.142 1.72-3.943 3.94-4.003l46.343-1.253c2.222-.06 4.084 1.644 4.137 3.786l1.749 69.57c.054 2.141-1.72 3.944-3.942 4.003z",
    fill: "#827F80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.683,
    d: "M142.221 95.407l-46.175 1.248c-2.217.06-4.074-1.64-4.127-3.777l-1.747-69.484c-.054-2.137 1.716-3.934 3.932-3.994l46.175-1.248c2.216-.06 4.074 1.64 4.127 3.777l1.746 69.484c.054 2.137-1.715 3.935-3.931 3.995z",
    fill: "#7E7B7C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.707,
    d: "M142.23 95.397L96.222 96.64c-2.21.06-4.064-1.635-4.117-3.767l-1.744-69.4c-.054-2.132 1.712-3.925 3.922-3.985l46.009-1.243c2.211-.06 4.063 1.636 4.117 3.768l1.744 69.4c.054 2.132-1.712 3.925-3.923 3.984z",
    fill: "#7A7678"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.732,
    d: "M142.239 95.388l-45.841 1.239c-2.206.06-4.054-1.632-4.108-3.759l-1.742-69.315c-.053-2.127 1.707-3.916 3.913-3.976l45.842-1.238c2.205-.06 4.054 1.632 4.107 3.759l1.742 69.315c.053 2.127-1.707 3.916-3.913 3.975z",
    fill: "#757274"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.756,
    d: "M142.249 95.379l-45.674 1.234c-2.2.06-4.045-1.628-4.098-3.75l-1.74-69.23c-.054-2.123 1.703-3.907 3.904-3.966l45.675-1.235c2.2-.06 4.044 1.628 4.097 3.75l1.74 69.231c.053 2.122-1.703 3.906-3.904 3.966z",
    fill: "#716E70"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M142.258 95.369l-45.508 1.23c-2.195.059-4.034-1.625-4.088-3.741L90.925 23.71c-.053-2.116 1.7-3.897 3.895-3.956l45.507-1.23c2.196-.06 4.035 1.624 4.088 3.74l1.738 69.147c.053 2.117-1.699 3.898-3.895 3.957z",
    fill: "#6D6A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.805,
    d: "M142.268 95.359l-45.34 1.225c-2.19.06-4.026-1.62-4.079-3.732l-1.736-69.06C91.06 21.68 92.81 19.903 95 19.843l45.341-1.225c2.189-.059 4.025 1.62 4.078 3.732l1.736 69.061c.053 2.112-1.696 3.888-3.886 3.947z",
    fill: "#696668"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.829,
    d: "M142.277 95.35l-45.174 1.22c-2.184.06-4.015-1.616-4.068-3.722L91.3 23.87c-.053-2.107 1.691-3.879 3.876-3.938l45.174-1.22c2.185-.06 4.016 1.616 4.069 3.723l1.733 68.976c.054 2.107-1.691 3.879-3.876 3.938z",
    fill: "#656164"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.854,
    d: "M142.286 95.34l-45.007 1.216c-2.18.06-4.006-1.612-4.058-3.714L91.489 23.95c-.052-2.101 1.687-3.869 3.867-3.928l45.007-1.216c2.179-.059 4.006 1.613 4.058 3.714l1.731 68.892c.053 2.101-1.687 3.87-3.866 3.928z",
    fill: "#605D60"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.878,
    d: "M142.295 95.33l-44.84 1.212c-2.174.059-3.996-1.608-4.049-3.705l-1.73-68.808c-.052-2.096 1.684-3.86 3.858-3.918l44.841-1.211c2.174-.059 3.996 1.608 4.049 3.705l1.729 68.807c.052 2.097-1.683 3.86-3.858 3.919z",
    fill: "#5C595B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M142.305 95.32l-44.673 1.207c-2.17.059-3.987-1.604-4.04-3.696L91.866 24.11c-.052-2.091 1.68-3.85 3.848-3.91l44.673-1.206c2.17-.058 3.987 1.605 4.04 3.696l1.727 68.723c.052 2.091-1.679 3.85-3.848 3.909z",
    fill: "#585557"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.927,
    d: "M142.314 95.311l-44.506 1.202c-2.164.058-3.977-1.6-4.03-3.687l-1.724-68.638c-.053-2.087 1.675-3.841 3.839-3.9l44.506-1.202c2.164-.058 3.977 1.6 4.029 3.687l1.726 68.639c.052 2.086-1.676 3.84-3.84 3.9z",
    fill: "#545153"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.951,
    d: "M142.323 95.302l-44.34 1.197c-2.158.059-3.966-1.596-4.019-3.678l-1.723-68.554c-.052-2.081 1.671-3.831 3.83-3.89l44.339-1.197c2.158-.059 3.967 1.596 4.02 3.678l1.722 68.554c.053 2.081-1.671 3.831-3.829 3.89z",
    fill: "#4F4C4F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    d: "M142.333 95.292l-44.174 1.193c-2.153.059-3.957-1.592-4.01-3.669l-1.72-68.469c-.052-2.076 1.667-3.822 3.82-3.88l44.173-1.193c2.153-.058 3.957 1.593 4.01 3.669l1.721 68.469c.052 2.075-1.667 3.822-3.82 3.88z",
    fill: "#4B484B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.343 95.282l-44.006 1.189c-2.148.058-3.948-1.59-4-3.66l-1.719-68.385c-.051-2.07 1.663-3.813 3.811-3.87l44.006-1.189c2.148-.058 3.948 1.589 3.999 3.66l1.719 68.384c.052 2.07-1.662 3.813-3.81 3.871z",
    fill: "#474447"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M159.986 107.687l-61.567 1.663c-2.725.074-5.01-2.016-5.076-4.645l-1.987-79.077c-.066-2.628 2.11-4.839 4.836-4.913l61.567-1.663c2.725-.073 5.01 2.017 5.076 4.645l1.987 79.077c.066 2.629-2.11 4.839-4.836 4.913z",
    fill: "#F4F0EF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M161.572 107.645l-61.567 1.663c-2.725.074-5.01-2.017-5.076-4.645l-1.987-79.077c-.066-2.629 2.11-4.84 4.836-4.913l61.567-1.663c2.725-.074 5.01 2.016 5.076 4.645l1.987 79.077c.067 2.628-2.11 4.839-4.836 4.913z",
    fill: "url(#paint3_linear_3128_3574)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.012,
    d: "M95.69 22.087c.007-.023 8.442-.452 8.465-.447l54.389-2.535c1.812.062 3.228 1.663 3.098 3.543.023.006.42 5.113.413 5.136l6.457 85.883c-.136 1.903-1.749 3.405-3.584 3.338l-65.922-2.398c-1.812-.062-3.248-1.665-3.118-3.545-.023-.005-.277-5.137-.27-5.16l-3.454-79.983c-.03-.518.032-1.064.223-1.546.532-1.342 1.854-2.336 3.303-2.286z",
    fill: "url(#paint4_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.025,
    d: "M95.997 22.13c.013-.045 8.366-.483 8.412-.474l54.133-2.38c1.789.061 3.229 1.654 3.101 3.51.045.01.45 5.077.438 5.122l6.431 85.914c-.142 1.902-1.758 3.401-3.592 3.329l-65.858-2.535c-1.79-.062-3.268-1.657-3.14-3.514-.045-.01-.31-5.102-.297-5.147l-3.13-79.968c-.029-.512.036-1.07.225-1.547.525-1.324 1.845-2.358 3.277-2.31z",
    fill: "url(#paint5_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.037,
    d: "M96.302 22.174c.019-.068 8.291-.515 8.359-.5l53.878-2.226c1.767.06 3.23 1.645 3.103 3.478.067.015.481 5.04.461 5.109l6.406 85.943c-.146 1.901-1.766 3.395-3.601 3.32l-65.793-2.673c-1.767-.061-3.289-1.65-3.162-3.483-.067-.015-.342-5.065-.323-5.133l-2.807-79.954c-.03-.506.041-1.076.228-1.547.518-1.307 1.837-2.382 3.25-2.334z",
    fill: "url(#paint6_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.049,
    d: "M96.608 22.219c.025-.091 8.217-.549 8.307-.529l53.622-2.07c1.744.059 3.23 1.636 3.106 3.445.09.02.512 5.005.486 5.096l6.38 85.972c-.151 1.901-1.776 3.391-3.61 3.311l-65.728-2.81c-1.744-.059-3.309-1.642-3.184-3.452-.09-.02-.374-5.029-.349-5.119l-2.485-79.94c-.028-.5.047-1.081.231-1.546.511-1.291 1.828-2.406 3.224-2.358z",
    fill: "url(#paint7_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.062,
    d: "M96.913 22.262c.032-.114 8.142-.58 8.255-.555l53.366-1.917c1.721.059 3.231 1.627 3.107 3.414.113.025.543 4.968.511 5.082l6.354 86.002c-.155 1.9-1.784 3.386-3.618 3.303l-65.663-2.947c-1.722-.059-3.33-1.635-3.206-3.422-.112-.025-.407-4.992-.375-5.106l-2.162-79.925c-.028-.493.052-1.088.234-1.546.505-1.274 1.82-2.43 3.197-2.383z",
    fill: "url(#paint8_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.074,
    d: "M97.218 22.306c.039-.136 8.067-.612 8.202-.582l53.11-1.762c1.699.058 3.232 1.618 3.11 3.38.135.03.574 4.933.534 5.07l6.329 86.031c-.16 1.9-1.792 3.382-3.626 3.294l-65.6-3.084c-1.699-.059-3.348-1.628-3.227-3.39-.135-.03-.44-4.957-.401-5.093l-1.84-79.91a3.935 3.935 0 01.236-1.547c.5-1.258 1.814-2.453 3.173-2.407z",
    fill: "url(#paint9_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.086,
    d: "M97.525 22.35c.045-.16 7.992-.644 8.149-.61l52.855-1.607c1.676.058 3.233 1.61 3.112 3.349.158.035.605 4.897.56 5.056l6.303 86.061c-.165 1.899-1.801 3.377-3.635 3.285l-65.534-3.221c-1.676-.058-3.37-1.62-3.25-3.359-.157-.035-.472-4.92-.426-5.08L94.14 26.328c-.026-.48.063-1.1.24-1.547.491-1.24 1.803-2.477 3.144-2.43z",
    fill: "url(#paint10_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.099,
    d: "M97.83 22.394c.053-.182 7.918-.677 8.098-.637l52.599-1.453c1.653.057 3.232 1.6 3.113 3.317.18.04.636 4.86.584 5.043l6.278 86.09c-.17 1.898-1.81 3.372-3.643 3.276l-65.47-3.359c-1.654-.056-3.39-1.612-3.27-3.328-.18-.04-.506-4.883-.454-5.066L94.47 26.396a4.036 4.036 0 01.242-1.547c.485-1.224 1.796-2.5 3.119-2.455z",
    fill: "url(#paint11_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "M98.136 22.438c.058-.205 7.842-.709 8.044-.664l52.344-1.298c1.63.056 3.233 1.592 3.116 3.284.202.045.667 4.825.608 5.03l6.252 86.121c-.175 1.897-1.819 3.367-3.652 3.267l-65.405-3.496c-1.63-.056-3.41-1.605-3.293-3.297-.202-.045-.538-4.848-.48-5.053l-.87-79.867a4.1 4.1 0 01.244-1.547c.478-1.208 1.787-2.524 3.092-2.48z",
    fill: "url(#paint12_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.123,
    d: "M98.441 22.483c.065-.228 7.768-.741 7.992-.692l52.088-1.143c1.608.055 3.234 1.582 3.118 3.251.226.05.698 4.79.633 5.017l6.226 86.15c-.179 1.896-1.827 3.362-3.66 3.258l-65.34-3.633c-1.608-.056-3.43-1.598-3.314-3.267-.226-.049-.57-4.811-.506-5.039l-.549-79.852a4.157 4.157 0 01.247-1.547c.472-1.19 1.779-2.548 3.065-2.503z",
    fill: "url(#paint13_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.136,
    d: "M98.747 22.526c.071-.25 7.692-.773 7.94-.718l51.831-.989c1.586.055 3.234 1.574 3.121 3.219.248.054.728 4.753.657 5.004l6.201 86.179c-.185 1.896-1.836 3.358-3.67 3.249l-65.275-3.77c-1.586-.055-3.45-1.59-3.336-3.236-.248-.054-.603-4.775-.532-5.025L95.458 26.6a4.231 4.231 0 01.25-1.547c.465-1.173 1.771-2.57 3.04-2.527z",
    fill: "url(#paint14_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.148,
    d: "M99.053 22.57c.077-.273 7.617-.805 7.888-.746l51.575-.834c1.563.054 3.235 1.566 3.123 3.187.271.06.759 4.717.682 4.99l6.175 86.21c-.19 1.895-1.845 3.353-3.678 3.24l-65.21-3.908c-1.563-.054-3.47-1.582-3.358-3.204-.27-.059-.636-4.738-.559-5.012l.096-79.824a4.287 4.287 0 01.253-1.547c.457-1.157 1.762-2.595 3.013-2.552z",
    fill: "url(#paint15_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.161,
    d: "M99.358 22.615c.084-.296 7.543-.838 7.835-.773l51.321-.68c1.54.053 3.235 1.557 3.125 3.155.293.064.79 4.68.706 4.977l6.149 86.238c-.195 1.895-1.854 3.349-3.687 3.231l-65.145-4.044c-1.54-.052-3.49-1.575-3.38-3.173-.292-.065-.668-4.703-.584-4.999l.418-79.809c-.025-.441.093-1.137.256-1.547.45-1.14 1.754-2.618 2.986-2.576z",
    fill: "url(#paint16_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.173,
    d: "M99.664 22.66c.09-.32 7.467-.87 7.783-.802l51.064-.524c1.518.052 3.236 1.547 3.127 3.122.315.069.821 4.645.73 4.963l6.123 86.268c-.199 1.894-1.862 3.344-3.695 3.222l-65.08-4.181c-1.519-.052-3.511-1.568-3.402-3.143-.315-.069-.701-4.666-.611-4.985l.741-79.795c-.024-.434.098-1.142.258-1.547.446-1.123 1.748-2.64 2.962-2.599z",
    fill: "url(#paint17_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.185,
    d: "M99.969 22.702c.097-.342 7.392-.902 7.73-.828l50.809-.37c1.494.051 3.236 1.538 3.129 3.09.337.074.852 4.609.754 4.95l6.098 86.299c-.204 1.893-1.871 3.339-3.704 3.213l-65.016-4.319c-1.495-.051-3.53-1.56-3.423-3.112-.338-.074-.734-4.63-.637-4.972l1.065-79.78c-.025-.428.103-1.149.26-1.547.44-1.106 1.74-2.665 2.935-2.624z",
    fill: "url(#paint18_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.198,
    d: "M100.275 22.747c.103-.365 7.317-.935 7.677-.855l50.553-.215c1.473.05 3.238 1.529 3.132 3.056.361.08.883 4.574.779 4.938L168.488 116c-.209 1.892-1.88 3.334-3.712 3.204l-64.952-4.456c-1.472-.05-3.55-1.553-3.445-3.08-.36-.08-.766-4.594-.662-4.959l1.387-79.766c-.024-.421.108-1.154.264-1.547.43-1.09 1.729-2.689 2.907-2.648z",
    fill: "url(#paint19_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M100.581 22.79c.11-.387 7.242-.966 7.625-.882l50.297-.06c1.45.05 3.238 1.52 3.134 3.024.383.084.913 4.538.803 4.925l6.047 86.357c-.214 1.891-1.888 3.33-3.721 3.196l-64.887-4.594c-1.45-.05-3.57-1.545-3.467-3.049-.383-.085-.8-4.558-.689-4.945l1.71-79.752c-.024-.415.113-1.16.266-1.547.425-1.073 1.722-2.712 2.882-2.672z",
    fill: "url(#paint20_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "M100.886 22.834c.117-.41 7.167-.998 7.573-.909l50.041.094c1.427.049 3.239 1.512 3.136 2.992.406.09.944 4.502.828 4.912l6.021 86.386c-.219 1.891-1.897 3.325-3.729 3.187l-64.822-4.73c-1.427-.049-3.59-1.539-3.488-3.019-.406-.089-.832-4.522-.715-4.932l2.032-79.737c-.023-.409.118-1.167.269-1.547.417-1.056 1.712-2.736 2.854-2.697z",
    fill: "url(#paint21_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.235,
    d: "M101.192 22.878c.122-.433 7.092-1.03 7.52-.937l49.785.249c1.405.048 3.24 1.502 3.139 2.96.427.093.974 4.465.852 4.898l5.995 86.416c-.223 1.89-1.906 3.32-3.737 3.178l-64.758-4.868c-1.404-.048-3.61-1.53-3.51-2.987-.427-.094-.864-4.485-.741-4.918l2.355-79.723c-.023-.402.123-1.172.271-1.547.412-1.04 1.705-2.76 2.829-2.72z",
    fill: "url(#paint22_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.247,
    d: "M101.498 22.922c.129-.455 7.017-1.063 7.467-.963l49.53.403c1.381.047 3.24 1.494 3.141 2.928.45.099 1.006 4.43.876 4.885l5.97 86.445c-.229 1.889-1.914 3.316-3.747 3.169l-64.692-5.004c-1.382-.048-3.631-1.523-3.532-2.957-.45-.1-.897-4.45-.768-4.905l2.678-79.708c-.022-.396.129-1.18.274-1.548.406-1.023 1.697-2.782 2.803-2.745z",
    fill: "url(#paint23_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.259,
    d: "M101.803 22.966c.136-.478 6.943-1.095 7.415-.991l49.274.557c1.359.047 3.24 1.485 3.143 2.895.473.105 1.037 4.394.901 4.873l5.944 86.475c-.233 1.888-1.923 3.31-3.755 3.159l-64.628-5.142c-1.359-.046-3.651-1.516-3.553-2.926-.473-.104-.93-4.412-.794-4.891l3-79.694c-.022-.389.134-1.184.278-1.547.398-1.005 1.688-2.805 2.775-2.768z",
    fill: "url(#paint24_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.272,
    d: "M102.109 23.01c.142-.501 6.868-1.127 7.363-1.018l49.019.713c1.337.046 3.241 1.475 3.145 2.862.496.109 1.068 4.358.926 4.86l5.918 86.504c-.238 1.888-1.932 3.306-3.764 3.151l-64.563-5.279c-1.337-.046-3.671-1.508-3.575-2.895-.496-.108-.963-4.376-.82-4.877l3.321-79.68c-.021-.383.14-1.192.28-1.548.392-.99 1.681-2.83 2.75-2.793z",
    fill: "url(#paint25_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.284,
    d: "M102.414 23.054c.149-.523 6.793-1.16 7.311-1.045l48.762.867c1.314.044 3.241 1.466 3.147 2.83.518.114 1.099 4.322.95 4.846l5.893 86.534c-.243 1.888-1.941 3.301-3.772 3.142l-64.499-5.416c-1.314-.045-3.692-1.501-3.597-2.864-.518-.114-.995-4.34-.846-4.864l3.645-79.665c-.02-.376.145-1.197.283-1.547.385-.973 1.672-2.854 2.723-2.818z",
    fill: "url(#paint26_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.296,
    d: "M102.721 23.099c.155-.547 6.717-1.192 7.258-1.073l48.507 1.022c1.291.044 3.242 1.458 3.149 2.797.54.12 1.129 4.287.974 4.834l5.867 86.564c-.248 1.886-1.949 3.296-3.781 3.133l-64.434-5.554c-1.29-.044-3.711-1.494-3.618-2.834-.54-.119-1.028-4.304-.872-4.85l3.968-79.651c-.021-.37.149-1.203.285-1.547.378-.957 1.664-2.877 2.697-2.841z",
    fill: "url(#paint27_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.309,
    d: "M103.025 23.142c.162-.57 6.643-1.224 7.206-1.1l48.251 1.176c1.269.044 3.243 1.449 3.152 2.766.563.123 1.16 4.25.998 4.82l5.842 86.593c-.253 1.885-1.958 3.292-3.79 3.124l-64.369-5.69c-1.269-.044-3.732-1.486-3.64-2.802-.563-.125-1.06-4.268-.899-4.838l4.291-79.636c-.02-.363.154-1.209.288-1.547.372-.94 1.656-2.9 2.67-2.866z",
    fill: "url(#paint28_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.321,
    d: "M103.332 23.186c.167-.592 6.567-1.256 7.153-1.127l47.995 1.332c1.246.043 3.243 1.44 3.153 2.733.586.128 1.192 4.214 1.023 4.807l5.816 86.622c-.257 1.885-1.966 3.287-3.798 3.115l-64.304-5.827c-1.246-.043-3.752-1.479-3.663-2.771-.585-.129-1.093-4.232-.924-4.824l4.613-79.622c-.019-.357.159-1.215.291-1.547.365-.923 1.647-2.925 2.645-2.89z",
    fill: "url(#paint29_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M103.637 23.23c.175-.614 6.493-1.288 7.101-1.154l47.74 1.486c1.223.042 3.243 1.432 3.156 2.7.608.134 1.222 4.18 1.047 4.794l5.79 86.652c-.263 1.885-1.975 3.283-3.806 3.107l-64.24-5.965c-1.223-.042-3.772-1.472-3.684-2.741-.608-.134-1.125-4.195-.95-4.811l4.936-79.607c-.02-.35.164-1.222.293-1.548.358-.905 1.639-2.946 2.617-2.912z",
    fill: "url(#paint30_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.346,
    d: "M103.943 23.274c.181-.638 6.418-1.32 7.048-1.182l47.484 1.641c1.2.041 3.245 1.423 3.158 2.668.631.14 1.253 4.143 1.072 4.781l5.765 86.682c-.267 1.883-1.984 3.278-3.815 3.098l-64.175-6.103c-1.201-.041-3.793-1.463-3.706-2.709-.63-.139-1.158-4.159-.977-4.797l5.258-79.593c-.019-.344.169-1.228.296-1.548.352-.889 1.631-2.97 2.592-2.938z",
    fill: "url(#paint31_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.358,
    d: "M104.248 23.319c.187-.661 6.343-1.353 6.995-1.21l47.228 1.796c1.178.04 3.245 1.414 3.161 2.636.653.143 1.283 4.106 1.096 4.767l5.739 86.711c-.272 1.883-1.992 3.273-3.823 3.089l-64.111-6.239c-1.177-.041-3.812-1.457-3.727-2.679-.653-.143-1.19-4.123-1.004-4.784l5.582-79.578c-.019-.338.174-1.234.299-1.548.345-.872 1.623-2.994 2.565-2.961z",
    fill: "url(#paint32_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M104.553 23.363c.195-.684 6.268-1.386 6.943-1.236l46.973 1.95c1.155.04 3.246 1.404 3.162 2.602.676.149 1.315 4.071 1.121 4.755l5.714 86.741c-.277 1.882-2.002 3.268-3.832 3.08l-64.046-6.376c-1.155-.04-3.832-1.449-3.75-2.648-.675-.148-1.222-4.086-1.03-4.77l5.905-79.564c-.018-.33.179-1.24.302-1.548.339-.856 1.614-3.018 2.538-2.986z",
    fill: "url(#paint33_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.383,
    d: "M104.86 23.406c.201-.706 6.193-1.417 6.891-1.263l46.717 2.105c1.132.039 3.246 1.395 3.165 2.57.698.154 1.345 4.035 1.145 4.742l5.687 86.77c-.281 1.882-2.009 3.263-3.84 3.071l-63.982-6.513c-1.132-.039-3.852-1.442-3.77-2.617-.699-.154-1.256-4.051-1.056-4.757l6.226-79.55c-.018-.324.185-1.245.305-1.548.331-.838 1.606-3.04 2.512-3.01z",
    fill: "url(#paint34_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.395,
    d: "M105.165 23.45c.207-.728 6.118-1.449 6.839-1.29l46.461 2.26c1.11.037 3.246 1.386 3.167 2.537.72.16 1.376 4 1.169 4.729l5.662 86.8c-.286 1.881-2.018 3.258-3.849 3.062l-63.916-6.65c-1.11-.038-3.873-1.434-3.793-2.586-.72-.159-1.289-4.014-1.082-4.744l6.55-79.535c-.018-.317.19-1.252.307-1.548.325-.822 1.597-3.065 2.485-3.035z",
    fill: "url(#paint35_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.407,
    d: "M105.47 23.494c.213-.751 6.043-1.48 6.786-1.318l46.205 2.415c1.088.037 3.247 1.377 3.169 2.506.743.163 1.407 3.963 1.194 4.715l5.637 86.829c-.292 1.88-2.027 3.255-3.858 3.053l-63.852-6.788c-1.087-.037-3.892-1.426-3.814-2.554-.743-.164-1.321-3.979-1.108-4.731l6.873-79.52c-.018-.312.194-1.258.309-1.548.318-.805 1.589-3.089 2.459-3.059z",
    fill: "url(#paint36_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M105.777 23.538c.22-.775 5.967-1.514 6.733-1.345l45.95 2.57c1.064.036 3.248 1.368 3.172 2.472.766.169 1.437 3.928 1.218 4.703l5.611 86.859c-.296 1.879-2.036 3.249-3.867 3.044l-63.787-6.925c-1.064-.037-3.913-1.42-3.836-2.524-.766-.169-1.354-3.942-1.134-4.717l7.194-79.506c-.017-.305.2-1.265.313-1.548.312-.788 1.581-3.112 2.433-3.083z",
    fill: "url(#paint37_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.432,
    d: "M106.081 23.582c.226-.797 5.893-1.546 6.681-1.372l45.694 2.723c1.042.036 3.248 1.36 3.173 2.441.789.174 1.469 3.891 1.243 4.689l5.585 86.888c-.301 1.879-2.045 3.245-3.875 3.035l-63.722-7.062c-1.042-.036-3.933-1.411-3.858-2.492-.789-.174-1.387-3.906-1.16-4.704l7.517-79.492c-.017-.298.205-1.27.315-1.548.305-.77 1.574-3.134 2.407-3.106z",
    fill: "url(#paint38_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M106.388 23.626c.232-.82 5.818-1.578 6.628-1.4l45.438 2.879c1.02.035 3.249 1.35 3.176 2.408.811.179 1.5 3.856 1.267 4.676l5.56 86.919c-.306 1.877-2.053 3.239-3.884 3.026l-63.658-7.199c-1.02-.036-3.952-1.405-3.88-2.462-.81-.179-1.419-3.87-1.186-4.69l7.84-79.478c-.017-.292.21-1.276.318-1.547.298-.756 1.565-3.16 2.381-3.132z",
    fill: "url(#paint39_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.457,
    d: "M106.694 23.671c.239-.843 5.743-1.61 6.576-1.427l45.182 3.033c.997.034 3.25 1.342 3.178 2.376.833.183 1.531 3.82 1.291 4.663l5.534 86.948c-.31 1.877-2.062 3.235-3.892 3.017l-63.593-7.336c-.996-.034-3.973-1.397-3.901-2.432-.834-.183-1.452-3.833-1.213-4.676l8.163-79.463c-.016-.286.215-1.282.32-1.548.292-.738 1.557-3.183 2.355-3.155z",
    fill: "url(#paint40_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.469,
    d: "M106.999 23.714c.245-.866 5.668-1.643 6.523-1.454l44.927 3.187c.974.033 3.25 1.333 3.18 2.344.856.188 1.561 3.783 1.316 4.65l5.508 86.977c-.315 1.876-2.07 3.23-3.9 3.008l-63.528-7.474c-.974-.033-3.993-1.389-3.924-2.399-.855-.189-1.484-3.797-1.239-4.663l8.486-79.449c-.016-.278.22-1.288.323-1.548.285-.72 1.548-3.205 2.328-3.179z",
    fill: "url(#paint41_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.481,
    d: "M107.304 23.758c.253-.888 5.593-1.674 6.471-1.48l44.671 3.341c.951.033 3.251 1.325 3.182 2.312.878.193 1.592 3.748 1.341 4.636l5.482 87.007c-.32 1.876-2.079 3.225-3.909 3l-63.464-7.611c-.951-.033-4.013-1.382-3.945-2.369-.878-.194-1.517-3.761-1.265-4.65l8.808-79.434c-.016-.272.225-1.295.326-1.548.279-.705 1.541-3.23 2.302-3.204z",
    fill: "url(#paint42_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.494,
    d: "M107.611 23.803c.258-.912 5.518-1.707 6.418-1.51l44.415 3.498c.929.032 3.252 1.315 3.184 2.278.902.199 1.623 3.712 1.365 4.624l5.457 87.036c-.325 1.875-2.087 3.221-3.917 2.991l-63.399-7.748c-.929-.032-4.034-1.374-3.967-2.338-.901-.199-1.55-3.725-1.291-4.636l9.131-79.42c-.015-.266.23-1.3.328-1.548.272-.687 1.532-3.253 2.276-3.227z",
    fill: "url(#paint43_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.506,
    d: "M107.917 23.846c.265-.934 5.443-1.74 6.366-1.536l44.159 3.652c.906.03 3.252 1.307 3.187 2.247.924.203 1.654 3.676 1.389 4.61l5.432 87.066c-.33 1.874-2.097 3.216-3.926 2.981l-63.335-7.885c-.906-.03-4.054-1.367-3.988-2.306-.924-.203-1.583-3.689-1.318-4.623l9.454-79.406c-.015-.26.236-1.306.331-1.548.265-.67 1.524-3.276 2.249-3.252z",
    fill: "url(#paint44_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.518,
    d: "M108.222 23.89c.271-.957 5.368-1.771 6.314-1.563l43.903 3.806c.883.03 3.252 1.298 3.189 2.214.946.208 1.685 3.64 1.413 4.597l5.406 87.096c-.335 1.873-2.106 3.211-3.935 2.972l-63.27-8.022c-.883-.03-4.074-1.359-4.01-2.276-.946-.208-1.615-3.652-1.344-4.609l9.776-79.39c-.014-.254.241-1.314.334-1.549.259-.654 1.517-3.3 2.224-3.276z",
    fill: "url(#paint45_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.531,
    d: "M108.527 23.934c.278-.98 5.293-1.803 6.261-1.59l43.648 3.961c.861.03 3.253 1.289 3.192 2.182.968.213 1.715 3.604 1.437 4.583l5.38 87.126c-.339 1.872-2.114 3.206-3.943 2.964l-63.205-8.159c-.861-.03-4.094-1.352-4.032-2.246-.969-.213-1.648-3.616-1.37-4.596l10.099-79.376c-.014-.247.246-1.32.337-1.548.251-.638 1.507-3.324 2.196-3.3z",
    fill: "url(#paint46_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.543,
    d: "M108.832 23.978c.285-1.003 5.219-1.836 6.209-1.618l43.392 4.116c.838.028 3.253 1.28 3.193 2.149.991.218 1.747 3.568 1.462 4.57l5.354 87.156c-.344 1.872-2.123 3.201-3.951 2.955l-63.14-8.297c-.839-.028-4.115-1.345-4.054-2.214-.991-.219-1.68-3.58-1.397-4.583l10.422-79.362c-.013-.24.251-1.325.34-1.548.246-.62 1.5-3.347 2.17-3.324z",
    fill: "url(#paint47_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "M109.139 24.022c.291-1.025 5.143-1.868 6.157-1.644l43.136 4.27c.815.028 3.254 1.27 3.196 2.117 1.013.223 1.777 3.532 1.486 4.557l5.328 87.184c-.349 1.872-2.131 3.197-3.96 2.946l-63.076-8.434c-.815-.028-4.134-1.337-4.076-2.183-1.013-.223-1.713-3.543-1.422-4.569l10.744-79.348c-.013-.233.256-1.33.342-1.548.24-.604 1.492-3.37 2.145-3.348z",
    fill: "url(#paint48_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.568,
    d: "M109.444 24.067c.297-1.048 5.068-1.9 6.104-1.672l42.88 4.424c.793.027 3.255 1.262 3.198 2.085 1.036.228 1.808 3.497 1.511 4.545l5.303 87.213c-.354 1.871-2.141 3.193-3.969 2.937l-63.011-8.571c-.793-.026-4.154-1.329-4.097-2.152-1.037-.228-1.746-3.508-1.45-4.555l11.068-79.334c-.013-.226.261-1.337.344-1.548.233-.587 1.485-3.394 2.119-3.372z",
    fill: "url(#paint49_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M109.75 24.11c.304-1.07 4.994-1.932 6.052-1.7l42.624 4.58c.771.027 3.256 1.253 3.2 2.053 1.059.233 1.84 3.46 1.536 4.53l5.277 87.244c-.359 1.87-2.149 3.188-3.978 2.928l-62.946-8.708c-.771-.026-4.175-1.322-4.12-2.122-1.058-.233-1.778-3.471-1.474-4.542l11.389-79.319c-.012-.22.267-1.343.348-1.548.227-.57 1.476-3.416 2.092-3.396z",
    fill: "url(#paint50_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.593,
    d: "M110.055 24.154c.31-1.094 4.918-1.964 5.999-1.726l42.369 4.734c.747.025 3.256 1.243 3.202 2.019 1.081.238 1.87 3.424 1.56 4.518l5.251 87.273c-.364 1.87-2.157 3.183-3.986 2.919l-62.881-8.845c-.748-.026-4.195-1.315-4.142-2.09-1.08-.239-1.81-3.436-1.5-4.529l11.712-79.304c-.013-.214.271-1.35.35-1.549.22-.553 1.468-3.44 2.066-3.42z",
    fill: "url(#paint51_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.605,
    d: "M110.361 24.198c.316-1.116 4.843-1.997 5.946-1.753l42.114 4.889c.725.025 3.256 1.235 3.204 1.987 1.103.243 1.901 3.389 1.584 4.505l5.226 87.302c-.369 1.868-2.166 3.178-3.994 2.91l-62.817-8.982c-.725-.025-4.215-1.308-4.163-2.059-1.103-.243-1.844-3.399-1.527-4.516l12.035-79.29c-.011-.207.277-1.354.353-1.548.213-.537 1.459-3.465 2.039-3.445z",
    fill: "url(#paint52_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.617,
    d: "M110.666 24.242c.324-1.139 4.769-2.028 5.895-1.78l41.857 5.043c.702.024 3.258 1.226 3.207 1.954 1.126.248 1.932 3.353 1.609 4.493l5.2 87.332c-.373 1.867-2.175 3.173-4.003 2.901l-62.752-9.119c-.702-.024-4.236-1.3-4.185-2.029-1.126-.248-1.877-3.362-1.553-4.502l12.357-79.275c-.011-.201.282-1.362.356-1.549.206-.52 1.451-3.488 2.012-3.468z",
    fill: "url(#paint53_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M110.972 24.286c.33-1.162 4.693-2.06 5.842-1.808l41.602 5.199c.68.023 3.257 1.216 3.209 1.922 1.148.253 1.962 3.317 1.633 4.478l5.175 87.362c-.379 1.867-2.184 3.169-4.012 2.893l-62.688-9.257c-.679-.023-4.255-1.292-4.206-1.998-1.148-.253-1.91-3.326-1.58-4.488l12.681-79.26c-.011-.195.287-1.368.358-1.55.199-.503 1.443-3.511 1.986-3.493z",
    fill: "url(#paint54_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.642,
    d: "M111.277 24.33c.337-1.185 4.619-2.093 5.79-1.835l41.346 5.352c.657.023 3.258 1.209 3.211 1.89 1.172.258 1.994 3.281 1.658 4.466l5.149 87.391c-.383 1.867-2.192 3.164-4.02 2.884l-62.623-9.394c-.657-.022-4.275-1.285-4.228-1.966-1.172-.258-1.942-3.29-1.606-4.475l13.003-79.247c-.011-.188.292-1.374.361-1.549.192-.486 1.434-3.535 1.959-3.517z",
    fill: "url(#paint55_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.654,
    d: "M111.584 24.375c.342-1.207 4.543-2.126 5.737-1.863l41.09 5.508c.634.022 3.258 1.2 3.213 1.857 1.193.263 2.024 3.246 1.681 4.453l5.124 87.421c-.388 1.866-2.201 3.159-4.029 2.875l-62.558-9.531c-.634-.022-4.296-1.278-4.25-1.936-1.194-.263-1.975-3.254-1.632-4.461l13.326-79.234c-.01-.182.297-1.38.364-1.548.186-.47 1.426-3.56 1.934-3.541z",
    fill: "url(#paint56_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M111.89 24.418c.349-1.23 4.468-2.158 5.684-1.89l40.835 5.662c.611.021 3.259 1.19 3.215 1.825 1.216.268 2.055 3.21 1.706 4.44l5.098 87.45c-.392 1.865-2.209 3.155-4.037 2.866l-62.493-9.668c-.612-.021-4.316-1.271-4.272-1.905-1.216-.268-2.007-3.218-1.658-4.448l13.648-79.218c-.009-.175.302-1.386.366-1.548.18-.453 1.418-3.583 1.908-3.566z",
    fill: "url(#paint57_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.679,
    d: "M112.195 24.462c.356-1.253 4.394-2.19 5.632-1.917l40.579 5.817c.59.02 3.26 1.182 3.218 1.793 1.239.272 2.086 3.173 1.73 4.426l5.073 87.48c-.398 1.864-2.219 3.15-4.046 2.857l-62.429-9.805c-.589-.021-4.335-1.263-4.293-1.874-1.239-.273-2.04-3.182-1.685-4.435l13.972-79.203c-.01-.168.306-1.391.368-1.548.173-.437 1.41-3.607 1.881-3.59z",
    fill: "url(#paint58_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.691,
    d: "M112.5 24.507c.362-1.276 4.318-2.222 5.579-1.945l40.324 5.972c.566.019 3.26 1.172 3.219 1.76 1.261.277 2.117 3.137 1.755 4.413l5.047 87.51c-.403 1.863-2.227 3.145-4.055 2.848l-62.364-9.943c-.566-.019-4.356-1.255-4.315-1.843-1.261-.277-2.073-3.145-1.71-4.421l14.292-79.189c-.008-.162.312-1.398.373-1.548.167-.42 1.402-3.63 1.855-3.614z",
    fill: "url(#paint59_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.704,
    d: "M112.805 24.55c.369-1.299 4.244-2.254 5.527-1.972l40.068 6.127c.543.018 3.261 1.163 3.222 1.728 1.283.282 2.147 3.101 1.779 4.4l5.021 87.539c-.408 1.863-2.236 3.14-4.063 2.839l-62.3-10.08c-.543-.018-4.376-1.248-4.337-1.812-1.283-.282-2.105-3.109-1.736-4.407l14.616-79.175c-.009-.155.317-1.404.375-1.548.16-.403 1.393-3.654 1.828-3.639z",
    fill: "url(#paint60_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.716,
    d: "M113.111 24.594c.375-1.321 4.169-2.286 5.475-1.999l39.811 6.28c.521.019 3.262 1.156 3.224 1.696 1.307.288 2.179 3.066 1.804 4.387l4.995 87.569c-.412 1.862-2.245 3.135-4.071 2.83l-62.235-10.217c-.521-.018-4.396-1.241-4.359-1.781-1.306-.288-2.137-3.073-1.762-4.394l14.939-79.16c-.009-.15.322-1.41.377-1.549.153-.386 1.386-3.676 1.802-3.662z",
    fill: "url(#paint61_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.728,
    d: "M113.417 24.639c.381-1.345 4.094-2.319 5.422-2.027l39.556 6.436c.498.017 3.262 1.146 3.227 1.663 1.329.292 2.209 3.03 1.827 4.374l4.97 87.598c-.417 1.861-2.253 3.131-4.08 2.821l-62.17-10.354c-.498-.017-4.417-1.233-4.38-1.75-1.33-.293-2.171-3.037-1.79-4.381l15.262-79.145c-.008-.143.328-1.416.38-1.549.146-.37 1.377-3.7 1.776-3.686z",
    fill: "url(#paint62_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.741,
    d: "M113.723 24.682c.388-1.367 4.019-2.351 5.37-2.053l39.3 6.59c.476.016 3.263 1.136 3.229 1.63 1.351.297 2.24 2.994 1.852 4.361l4.945 87.628c-.422 1.86-2.262 3.126-4.089 2.812l-62.105-10.491c-.476-.016-4.437-1.226-4.403-1.72-1.351-.297-2.203-3-1.815-4.367l15.585-79.132c-.008-.136.332-1.422.383-1.549.138-.35 1.368-3.722 1.748-3.71z",
    fill: "url(#paint63_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.753,
    d: "M114.029 24.726c.394-1.39 3.944-2.383 5.317-2.08l39.045 6.744c.453.016 3.263 1.128 3.231 1.598 1.374.303 2.271 2.958 1.877 4.348l4.919 87.657c-.427 1.86-2.271 3.122-4.098 2.803l-62.041-10.628c-.452-.015-4.456-1.218-4.424-1.688-1.374-.302-2.236-2.964-1.841-4.354l15.907-79.116c-.007-.13.337-1.429.385-1.55.133-.335 1.36-3.746 1.723-3.734z",
    fill: "url(#paint64_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.765,
    d: "M114.334 24.77c.4-1.412 3.868-2.415 5.265-2.107l38.788 6.9c.431.014 3.264 1.118 3.233 1.565 1.397.307 2.302 2.922 1.902 4.334l4.893 87.687c-.432 1.859-2.28 3.116-4.106 2.795l-61.976-10.765c-.43-.015-4.477-1.211-4.446-1.658-1.396-.307-2.268-2.928-1.868-4.34l16.23-79.103c-.007-.123.343-1.434.388-1.549.126-.319 1.353-3.77 1.697-3.759z",
    fill: "url(#paint65_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "M114.639 24.814c.408-1.435 3.794-2.447 5.213-2.135l38.533 7.055c.408.014 3.264 1.11 3.235 1.533 1.419.312 2.333 2.886 1.926 4.322l4.867 87.716c-.436 1.858-2.287 3.111-4.114 2.785l-61.911-10.902c-.408-.014-4.497-1.203-4.468-1.626-1.419-.313-2.3-2.892-1.894-4.328l16.552-79.088c-.006-.116.348-1.44.391-1.55.12-.3 1.344-3.793 1.67-3.782z",
    fill: "url(#paint66_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M114.945 24.858c.413-1.458 3.718-2.48 5.16-2.162l38.277 7.209c.385.013 3.265 1.1 3.237 1.5 1.441.317 2.364 2.85 1.951 4.309l4.841 87.746c-.441 1.858-2.296 3.107-4.123 2.777l-61.847-11.04c-.384-.014-4.517-1.197-4.489-1.596-1.441-.317-2.333-2.855-1.92-4.314l16.875-79.074c-.007-.11.353-1.446.394-1.549.112-.284 1.336-3.816 1.644-3.806z",
    fill: "url(#paint67_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.802,
    d: "M115.251 24.902c.42-1.48 3.644-2.511 5.108-2.19l38.021 7.364c.363.013 3.266 1.093 3.24 1.469 1.464.322 2.394 2.814 1.974 4.295l4.816 87.776c-.446 1.857-2.305 3.102-4.131 2.768l-61.782-11.177c-.363-.012-4.537-1.189-4.511-1.565-1.464-.322-2.366-2.819-1.946-4.3l17.198-79.06c-.006-.103.358-1.452.396-1.549.106-.268 1.327-3.84 1.617-3.83z",
    fill: "url(#paint68_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.815,
    d: "M115.557 24.946c.427-1.503 3.569-2.543 5.055-2.216l37.765 7.518c.341.011 3.267 1.084 3.242 1.436 1.487.327 2.426 2.778 1.999 4.282l4.791 87.805c-.451 1.856-2.314 3.098-4.14 2.759l-61.717-11.314c-.34-.012-4.558-1.181-4.533-1.534-1.487-.327-2.399-2.783-1.972-4.287l17.52-79.045c-.006-.098.363-1.459.399-1.55.099-.25 1.319-3.863 1.591-3.854z",
    fill: "url(#paint69_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.827,
    d: "M115.863 24.99c.432-1.526 3.493-2.576 5.002-2.244l37.51 7.673c.317.011 3.267 1.075 3.244 1.403 1.509.333 2.456 2.743 2.023 4.27l4.765 87.834c-.456 1.855-2.323 3.093-4.149 2.75l-61.653-11.451c-.317-.011-4.577-1.174-4.554-1.503-1.51-.332-2.431-2.746-1.999-4.273l17.843-79.03c-.005-.091.368-1.465.402-1.55.094-.234 1.312-3.887 1.566-3.879z",
    fill: "url(#paint70_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M116.168 25.034c.439-1.549 3.418-2.608 4.95-2.27l37.254 7.827c.295.01 3.268 1.066 3.246 1.37 1.532.338 2.488 2.707 2.048 4.257l4.739 87.864c-.46 1.854-2.331 3.088-4.157 2.741l-61.588-11.589c-.294-.01-4.598-1.166-4.576-1.471-1.532-.337-2.464-2.711-2.025-4.26l18.166-79.016c-.005-.084.373-1.47.404-1.55.086-.217 1.303-3.911 1.539-3.903z",
    fill: "url(#paint71_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.852,
    d: "M116.473 25.078c.446-1.572 3.344-2.64 4.899-2.298l36.998 7.982c.271.01 3.268 1.057 3.248 1.339 1.554.342 2.518 2.67 2.072 4.243l4.714 87.893c-.466 1.854-2.341 3.084-4.166 2.732l-61.523-11.725c-.272-.01-4.618-1.159-4.599-1.441-1.553-.342-2.496-2.675-2.05-4.247l18.488-79.001c-.004-.078.379-1.477.407-1.55.08-.2 1.295-3.934 1.512-3.927z",
    fill: "url(#paint72_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.864,
    d: "M116.778 25.122c.452-1.595 3.269-2.672 4.846-2.325l36.743 8.136c.249.009 3.268 1.048 3.25 1.307 1.577.347 2.549 2.635 2.097 4.23l4.688 87.923c-.47 1.853-2.349 3.078-4.175 2.723l-61.458-11.863c-.249-.008-4.638-1.151-4.62-1.41-1.577-.347-2.53-2.638-2.077-4.233l18.811-78.987c-.004-.07.383-1.482.409-1.549.073-.184 1.287-3.958 1.486-3.952z",
    fill: "url(#paint73_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.876,
    d: "M117.085 25.166c.459-1.618 3.194-2.705 4.793-2.353l36.487 8.292c.227.008 3.269 1.039 3.253 1.274 1.599.352 2.58 2.599 2.121 4.216l4.662 87.953c-.475 1.853-2.357 3.074-4.183 2.714l-61.394-12c-.226-.007-4.657-1.143-4.641-1.378-1.6-.353-2.562-2.603-2.104-4.22l19.134-78.973c-.004-.065.389-1.489.413-1.55.066-.167 1.278-3.981 1.459-3.975z",
    fill: "url(#paint74_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "M117.39 25.21c.466-1.64 3.119-2.737 4.741-2.38l36.23 8.447c.204.006 3.27 1.03 3.256 1.24 1.621.357 2.61 2.564 2.145 4.204l4.636 87.982c-.479 1.852-2.365 3.07-4.191 2.705l-61.329-12.137c-.204-.007-4.678-1.136-4.663-1.348-1.622-.356-2.595-2.565-2.13-4.206l19.457-78.958c-.004-.058.394-1.495.415-1.55.06-.15 1.27-4.005 1.433-3.999z",
    fill: "url(#paint75_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.901,
    d: "M117.696 25.254c.472-1.663 3.044-2.77 4.688-2.408l35.975 8.602c.181.006 3.27 1.02 3.258 1.209 1.644.362 2.641 2.527 2.169 4.19l4.611 88.012c-.485 1.851-2.375 3.065-4.2 2.696l-61.265-12.274c-.181-.006-4.698-1.129-4.684-1.317-1.645-.362-2.627-2.53-2.156-4.193l19.779-78.944c-.004-.052.399-1.501.418-1.55.053-.133 1.261-4.027 1.407-4.023z",
    fill: "url(#paint76_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.914,
    d: "M118.002 25.298c.479-1.686 2.969-2.801 4.636-2.434l35.72 8.755c.158.005 3.27 1.012 3.259 1.177 1.666.367 2.672 2.49 2.194 4.177l4.585 88.041c-.489 1.85-2.384 3.06-4.208 2.688l-61.2-12.411c-.159-.005-4.718-1.122-4.707-1.286-1.666-.367-2.66-2.494-2.181-4.18L116.2 30.896c-.002-.045.404-1.507.421-1.55.046-.117 1.253-4.052 1.38-4.048z",
    fill: "url(#paint77_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.926,
    d: "M118.307 25.342c.485-1.708 2.894-2.834 4.583-2.462l35.463 8.91c.136.005 3.272 1.004 3.262 1.145 1.689.372 2.703 2.455 2.219 4.164l4.559 88.07c-.494 1.85-2.392 3.055-4.217 2.679L103.041 115.3c-.136-.004-4.74-1.114-4.729-1.255-1.689-.372-2.692-2.457-2.207-4.166l20.424-78.915a52.9 52.9 0 01.423-1.55c.041-.1 1.246-4.076 1.355-4.072z",
    fill: "url(#paint78_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.938,
    d: "M118.613 25.386c.491-1.731 2.819-2.866 4.53-2.489l35.208 9.065c.114.004 3.272.994 3.264 1.112 1.711.376 2.734 2.42 2.243 4.15l4.533 88.1c-.499 1.849-2.401 3.051-4.225 2.67l-61.071-12.685c-.113-.004-4.758-1.107-4.75-1.225-1.711-.376-2.725-2.421-2.234-4.153l20.747-78.9c-.002-.032.415-1.519.426-1.549.034-.083 1.238-4.099 1.329-4.096z",
    fill: "url(#paint79_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.951,
    d: "M118.918 25.43c.497-1.754 2.744-2.898 4.478-2.516l34.952 9.22c.091.003 3.273.984 3.267 1.078 1.734.382 2.764 2.384 2.267 4.138l4.508 88.131c-.504 1.848-2.41 3.046-4.234 2.661l-61.006-12.823c-.09-.003-4.779-1.1-4.772-1.193-1.734-.382-2.757-2.385-2.26-4.139l21.07-78.887c-.001-.026.419-1.525.428-1.55.027-.066 1.229-4.123 1.302-4.12z",
    fill: "url(#paint80_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.963,
    d: "M119.224 25.474c.504-1.777 2.669-2.93 4.425-2.544l34.697 9.375c.068.003 3.273.977 3.268 1.047 1.757.387 2.795 2.348 2.291 4.125l4.483 88.159c-.509 1.848-2.418 3.041-4.243 2.652l-60.941-12.959c-.068-.003-4.799-1.092-4.794-1.163-1.757-.387-2.79-2.348-2.286-4.126l21.392-78.871c-.001-.02.424-1.531.431-1.55.022-.05 1.222-4.147 1.277-4.145z",
    fill: "url(#paint81_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.975,
    d: "M119.529 25.519c.511-1.8 2.595-2.963 4.374-2.571l34.441 9.529c.045.001 3.274.968 3.271 1.014 1.779.392 2.827 2.312 2.315 4.112l4.457 88.189c-.513 1.847-2.426 3.037-4.251 2.643l-60.876-13.097c-.046-.001-4.819-1.084-4.816-1.131-1.779-.392-2.823-2.313-2.312-4.113l21.714-78.857c0-.013.429-1.538.435-1.55.013-.033 1.212-4.17 1.248-4.168z",
    fill: "url(#paint82_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.988,
    d: "M119.835 25.562c.517-1.823 2.52-2.995 4.321-2.598l34.186 9.684c.022 0 3.274.959 3.272.982 1.802.396 2.858 2.276 2.34 4.098l4.432 88.219c-.519 1.846-2.436 3.031-4.26 2.634l-60.812-13.234c-.022 0-4.839-1.077-4.837-1.1-1.801-.396-2.856-2.276-2.339-4.099l22.038-78.842c-.001-.007.434-1.544.437-1.55.007-.018 1.204-4.195 1.222-4.194z",
    fill: "url(#paint83_linear_3128_3574)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.115 128.728l-65.606-14.441c-1.824-.402-2.888-2.24-2.365-4.086l23.996-84.595c.523-1.845 2.445-3.027 4.269-2.625l37.204 10.788c1.824.402 2.888 2.24 2.365 4.086l4.406 88.248c-.524 1.845-2.445 3.026-4.269 2.625z",
    fill: "#6B656A"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M164.115 128.728l-65.606-14.441c-1.824-.402-2.888-2.24-2.365-4.086l23.996-84.595c.523-1.845 2.445-3.027 4.269-2.625l65.606 14.441c1.824.402 2.888 2.24 2.365 4.086l-23.996 84.595c-.524 1.845-2.445 3.026-4.269 2.625z",
    fill: "url(#paint84_linear_3128_3574)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M174.847 81.79l-60.745-13.37c-1.169-.258-1.851-1.437-1.515-2.62l10.612-37.412c.335-1.183 1.567-1.94 2.736-1.683l60.745 13.371c1.169.258 1.852 1.436 1.516 2.62l-10.612 37.411c-.336 1.183-1.567 1.94-2.737 1.683z",
    fill: "url(#paint85_linear_3128_3574)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M147.785 63.51l-8.239 2.232c-.88.238-1.587-.615-1.197-1.443l3.655-7.765c.155-.329.142-.702-.035-.999l-4.172-6.986c-.445-.746.197-1.733 1.088-1.671l8.338.585c.354.025.709-.126.948-.404l5.661-6.55c.604-.699 1.709-.456 1.869.412l1.498 8.126a.988.988 0 00.62.749l7.671 2.938c.819.314.859 1.451.067 1.925l-7.412 4.437a1.169 1.169 0 00-.565.867l-.92 8.366c-.098.894-1.178 1.354-1.826.779l-6.08-5.384a1.038 1.038 0 00-.969-.214z",
    fill: "url(#paint86_linear_3128_3574)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M147.777 63.478l-8.23 2.229c-.879.238-1.585-.614-1.195-1.442l3.651-7.755a1.06 1.06 0 00-.036-.998l-4.167-6.98c-.445-.744.197-1.73 1.086-1.668l8.329.585c.352.025.707-.127.947-.404l5.654-6.542c.604-.699 1.707-.456 1.867.41l1.496 8.117a.988.988 0 00.62.749l7.662 2.935c.818.313.857 1.449.067 1.922l-7.403 4.432a1.168 1.168 0 00-.564.866l-.919 8.356c-.098.893-1.177 1.352-1.825.778l-6.072-5.378a1.044 1.044 0 00-.968-.212z",
    fill: "url(#paint87_radial_3128_3574)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M147.769 63.446l-8.221 2.226c-.877.238-1.583-.613-1.193-1.44l3.646-7.746a1.058 1.058 0 00-.035-.997l-4.162-6.97c-.445-.744.196-1.73 1.085-1.667l8.318.584c.353.025.707-.126.946-.403l5.648-6.535c.604-.697 1.705-.455 1.865.41l1.495 8.108a.984.984 0 00.619.747l7.652 2.932c.818.313.857 1.448.068 1.92l-7.395 4.427a1.166 1.166 0 00-.563.866l-.919 8.347c-.098.89-1.175 1.35-1.822.776l-6.065-5.37a1.037 1.037 0 00-.967-.215z",
    fill: "url(#paint88_radial_3128_3574)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M147.762 63.413l-8.211 2.225c-.877.237-1.582-.613-1.193-1.44L142 56.462c.155-.328.142-.7-.034-.995l-4.157-6.962c-.444-.744.196-1.727 1.083-1.665l8.309.583c.352.025.706-.125.945-.402l5.641-6.527c.603-.697 1.703-.455 1.862.41L157.142 49a.986.986 0 00.619.747l7.644 2.928c.816.313.856 1.446.067 1.918l-7.386 4.422c-.313.188-.523.51-.562.864l-.917 8.337c-.098.89-1.174 1.348-1.821.776l-6.058-5.365a1.037 1.037 0 00-.966-.214z",
    fill: "url(#paint89_radial_3128_3574)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M147.754 63.38l-8.202 2.223c-.875.237-1.579-.613-1.191-1.438l3.638-7.728c.155-.328.142-.7-.034-.994l-4.153-6.954c-.443-.743.196-1.726 1.083-1.663l8.299.582c.352.025.705-.125.943-.402l5.636-6.52c.601-.696 1.7-.454 1.859.41l1.492 8.088a.983.983 0 00.618.745l7.635 2.925c.816.313.855 1.445.068 1.916l-7.378 4.417c-.313.187-.523.51-.562.862l-.916 8.328c-.098.889-1.172 1.347-1.818.775l-6.051-5.358a1.04 1.04 0 00-.966-.213z",
    fill: "url(#paint90_radial_3128_3574)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M147.746 63.349l-8.192 2.219c-.874.237-1.577-.612-1.189-1.435l3.634-7.72a1.057 1.057 0 00-.035-.993l-4.147-6.946c-.443-.742.196-1.723 1.081-1.661l8.29.582c.351.025.704-.126.943-.402l5.628-6.512c.6-.695 1.698-.453 1.858.409l1.489 8.078a.982.982 0 00.618.745l7.626 2.922c.814.312.854 1.443.067 1.914l-7.369 4.41c-.313.188-.522.51-.561.863l-.915 8.317c-.098.889-1.171 1.346-1.817.774l-6.044-5.353a1.041 1.041 0 00-.965-.211z",
    fill: "url(#paint91_radial_3128_3574)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M147.739 63.317l-8.182 2.216c-.874.237-1.575-.61-1.188-1.434l3.629-7.71a1.057 1.057 0 00-.034-.992l-4.143-6.938c-.443-.74.196-1.72 1.08-1.66l8.28.582a1.15 1.15 0 00.941-.401l5.622-6.505c.6-.694 1.697-.452 1.855.41l1.488 8.069c.063.342.294.62.617.744l7.617 2.918c.814.312.853 1.441.068 1.912l-7.361 4.406a1.162 1.162 0 00-.56.861l-.914 8.308c-.098.887-1.17 1.343-1.815.773l-6.036-5.347a1.037 1.037 0 00-.964-.212z",
    fill: "url(#paint92_radial_3128_3574)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M147.731 63.285l-8.173 2.214c-.872.236-1.573-.61-1.187-1.432l3.626-7.701a1.052 1.052 0 00-.035-.991l-4.137-6.93c-.442-.74.195-1.72 1.078-1.658l8.271.58c.35.025.702-.125.94-.4l5.615-6.497c.6-.694 1.695-.453 1.854.408l1.485 8.06a.98.98 0 00.617.743l7.608 2.914c.812.312.852 1.44.067 1.91l-7.353 4.4c-.312.187-.52.508-.559.86l-.913 8.299c-.097.886-1.168 1.342-1.812.772l-6.03-5.34a1.036 1.036 0 00-.962-.211z",
    fill: "url(#paint93_radial_3128_3574)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M147.724 63.252l-8.163 2.212c-.872.236-1.573-.61-1.186-1.43l3.621-7.693c.154-.326.14-.696-.034-.99l-4.134-6.922c-.441-.739.196-1.717 1.077-1.655l8.261.58c.351.024.702-.126.94-.4l5.609-6.49c.599-.693 1.693-.453 1.851.407l1.485 8.05a.979.979 0 00.615.742l7.599 2.912c.812.31.851 1.438.067 1.907l-7.343 4.396a1.155 1.155 0 00-.559.859l-.912 8.289c-.098.885-1.167 1.34-1.81.77l-6.023-5.333a1.038 1.038 0 00-.961-.21z",
    fill: "url(#paint94_radial_3128_3574)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M147.715 63.22l-8.153 2.209c-.871.236-1.571-.609-1.184-1.429l3.617-7.683c.153-.326.14-.696-.035-.988l-4.128-6.915c-.441-.738.195-1.715 1.076-1.653l8.251.579c.35.024.701-.125.938-.4l5.602-6.482c.599-.691 1.691-.451 1.849.407l1.483 8.042a.98.98 0 00.614.742l7.591 2.908c.81.31.85 1.436.066 1.904l-7.335 4.391c-.311.187-.52.508-.558.859l-.911 8.278c-.097.884-1.165 1.34-1.808.77l-6.015-5.327a1.031 1.031 0 00-.96-.212z",
    fill: "url(#paint95_radial_3128_3574)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M147.708 63.188l-8.144 2.206c-.87.236-1.568-.608-1.183-1.427l3.613-7.674c.153-.325.14-.694-.035-.988l-4.123-6.905c-.44-.738.194-1.714 1.074-1.651l8.242.578c.35.024.7-.125.937-.4l5.596-6.473c.597-.691 1.688-.451 1.847.406l1.48 8.032c.063.34.292.617.614.74l7.582 2.905c.81.31.849 1.434.067 1.903l-7.327 4.385a1.156 1.156 0 00-.558.857l-.91 8.27c-.097.882-1.164 1.337-1.805.769l-6.009-5.322a1.03 1.03 0 00-.958-.211z",
    fill: "url(#paint96_radial_3128_3574)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M147.7 63.155l-8.134 2.204c-.869.235-1.567-.607-1.181-1.425l3.608-7.666c.153-.325.14-.694-.035-.986l-4.118-6.898c-.44-.736.194-1.71 1.073-1.649l8.232.578c.349.024.699-.125.936-.4l5.589-6.466c.597-.69 1.687-.45 1.844.406l1.48 8.023c.063.34.292.616.613.74l7.573 2.9c.808.31.848 1.433.067 1.9l-7.318 4.381c-.31.186-.519.506-.557.856l-.909 8.26c-.097.882-1.163 1.336-1.804.768l-6.001-5.315a1.033 1.033 0 00-.958-.21z",
    fill: "url(#paint97_radial_3128_3574)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M147.693 63.123l-8.126 2.201c-.867.235-1.564-.606-1.179-1.423l3.604-7.657c.153-.325.14-.693-.035-.985l-4.114-6.89c-.439-.735.195-1.71 1.072-1.647l8.223.577c.348.024.698-.124.935-.398l5.583-6.46c.596-.689 1.685-.449 1.842.406l1.478 8.013c.062.34.291.617.612.74l7.564 2.897c.808.31.847 1.432.067 1.899l-7.31 4.375c-.31.185-.518.505-.556.855l-.908 8.25c-.096.88-1.161 1.334-1.801.767l-5.995-5.31a1.029 1.029 0 00-.956-.21z",
    fill: "url(#paint98_radial_3128_3574)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M147.685 63.091l-8.116 2.199c-.866.234-1.563-.606-1.178-1.423l3.6-7.647a1.05 1.05 0 00-.035-.984l-4.109-6.881c-.439-.735.194-1.708 1.071-1.646l8.213.577c.348.024.697-.125.934-.398l5.575-6.451c.595-.689 1.683-.45 1.841.405l1.475 8.004c.063.34.292.615.612.738l7.555 2.894c.807.308.846 1.43.067 1.895l-7.3 4.37a1.15 1.15 0 00-.556.854l-.907 8.24c-.096.88-1.159 1.333-1.799.767l-5.988-5.303a1.027 1.027 0 00-.955-.21z",
    fill: "url(#paint99_radial_3128_3574)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M147.676 63.059l-8.106 2.196c-.865.235-1.561-.605-1.177-1.42l3.596-7.639c.153-.324.14-.691-.034-.982l-4.104-6.874c-.438-.734.194-1.704 1.069-1.643l8.203.576c.348.024.697-.124.932-.397l5.57-6.444c.594-.688 1.681-.449 1.838.405l1.473 7.994a.973.973 0 00.611.737l7.547 2.891c.805.309.844 1.428.066 1.894l-7.292 4.364a1.15 1.15 0 00-.555.854l-.906 8.23c-.096.879-1.158 1.331-1.797.766l-5.98-5.297a1.025 1.025 0 00-.954-.211z",
    fill: "url(#paint100_radial_3128_3574)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M147.668 63.026l-8.096 2.193c-.865.235-1.559-.604-1.176-1.418l3.591-7.63c.153-.323.14-.69-.034-.982l-4.1-6.865c-.437-.733.194-1.703 1.069-1.642l8.193.575a1.14 1.14 0 00.932-.396l5.562-6.437c.594-.687 1.679-.448 1.837.404l1.472 7.985a.971.971 0 00.61.737l7.538 2.887c.804.309.844 1.427.066 1.892l-7.284 4.36a1.152 1.152 0 00-.555.85l-.904 8.222c-.097.877-1.157 1.33-1.795.764l-5.974-5.29a1.025 1.025 0 00-.952-.209z",
    fill: "url(#paint101_radial_3128_3574)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M147.661 62.995l-8.086 2.19c-.864.234-1.558-.603-1.175-1.418l3.587-7.62c.152-.323.139-.69-.034-.98l-4.095-6.858c-.437-.732.194-1.7 1.067-1.64l8.184.575c.347.025.695-.123.93-.396l5.557-6.429c.593-.687 1.676-.448 1.834.404l1.47 7.975a.971.971 0 00.61.735l7.529 2.884c.803.308.842 1.424.065 1.89l-7.274 4.354a1.145 1.145 0 00-.554.85l-.904 8.212c-.097.877-1.156 1.328-1.793.764l-5.966-5.284a1.027 1.027 0 00-.952-.209z",
    fill: "url(#paint102_radial_3128_3574)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M147.654 62.963l-8.077 2.187c-.862.234-1.556-.602-1.173-1.415l3.583-7.611c.152-.323.139-.69-.034-.98l-4.09-6.848c-.437-.731.193-1.7 1.066-1.638l8.174.574c.346.025.694-.123.929-.396l5.549-6.42c.593-.686 1.675-.448 1.832.403l1.468 7.966a.972.972 0 00.609.734l7.519 2.88c.803.308.842 1.423.066 1.888l-7.266 4.349a1.15 1.15 0 00-.554.85l-.902 8.201c-.096.876-1.155 1.326-1.791.763l-5.959-5.278a1.017 1.017 0 00-.949-.21z",
    fill: "url(#paint103_radial_3128_3574)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M147.646 62.93l-8.067 2.185c-.862.233-1.554-.602-1.172-1.414l3.579-7.602a1.037 1.037 0 00-.035-.978l-4.084-6.84c-.437-.73.192-1.698 1.064-1.636l8.164.573c.346.024.693-.124.928-.396l5.543-6.413c.592-.685 1.673-.447 1.83.402l1.467 7.957c.062.337.29.611.608.733l7.511 2.878c.802.307.841 1.421.066 1.885l-7.257 4.344a1.145 1.145 0 00-.553.85l-.901 8.191c-.096.875-1.154 1.325-1.789.762l-5.952-5.271a1.022 1.022 0 00-.95-.21z",
    fill: "url(#paint104_radial_3128_3574)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M147.638 62.898l-8.058 2.182c-.861.234-1.552-.6-1.17-1.412l3.574-7.593a1.04 1.04 0 00-.033-.976l-4.081-6.833c-.435-.73.193-1.695 1.063-1.634l8.155.573c.346.024.692-.124.927-.396l5.537-6.405c.591-.684 1.671-.447 1.827.402l1.466 7.947a.965.965 0 00.607.733l7.502 2.873c.801.307.839 1.42.066 1.883l-7.249 4.339c-.308.183-.514.5-.552.848l-.901 8.182c-.096.873-1.152 1.323-1.787.761l-5.945-5.265a1.017 1.017 0 00-.948-.21z",
    fill: "url(#paint105_radial_3128_3574)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M147.631 62.866l-8.049 2.18c-.859.232-1.55-.6-1.168-1.41l3.57-7.585a1.042 1.042 0 00-.034-.976l-4.075-6.825c-.435-.728.193-1.693 1.062-1.632l8.146.572c.345.025.691-.123.926-.394l5.53-6.398c.59-.684 1.669-.446 1.825.401l1.463 7.938c.063.336.289.61.607.732l7.493 2.87c.8.307.839 1.419.066 1.88l-7.241 4.335c-.307.183-.513.5-.551.846l-.899 8.172c-.096.873-1.151 1.322-1.785.76l-5.938-5.259a1.022 1.022 0 00-.948-.207z",
    fill: "url(#paint106_radial_3128_3574)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M147.623 62.833l-8.04 2.178c-.858.232-1.548-.6-1.167-1.41l3.566-7.574a1.04 1.04 0 00-.034-.975l-4.071-6.817c-.435-.727.192-1.69 1.061-1.63l8.136.571c.345.025.691-.123.924-.394l5.524-6.39c.589-.683 1.667-.446 1.823.401l1.462 7.928a.96.96 0 00.606.73l7.484 2.868c.799.306.838 1.416.066 1.878l-7.232 4.33c-.307.183-.512.499-.551.845l-.897 8.163c-.097.871-1.149 1.32-1.783.76l-5.931-5.254a1.02 1.02 0 00-.946-.208z",
    fill: "url(#paint107_radial_3128_3574)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M147.615 62.801l-8.03 2.175c-.857.233-1.546-.6-1.166-1.407l3.562-7.566c.151-.32.138-.685-.034-.974l-4.065-6.808c-.435-.727.192-1.689 1.06-1.628l8.125.57c.345.025.69-.122.925-.393l5.516-6.384c.59-.68 1.665-.444 1.821.401l1.46 7.92c.062.335.289.608.606.73l7.475 2.864c.798.305.837 1.414.066 1.875l-7.224 4.324a1.14 1.14 0 00-.55.845l-.897 8.153c-.096.87-1.148 1.318-1.781.758l-5.924-5.247a1.018 1.018 0 00-.945-.208z",
    fill: "url(#paint108_radial_3128_3574)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M147.608 62.77l-8.02 2.172c-.856.231-1.545-.6-1.164-1.406l3.557-7.557c.151-.32.139-.684-.034-.972l-4.061-6.8c-.433-.727.192-1.688 1.059-1.627l8.116.57c.344.024.689-.123.923-.394l5.51-6.375c.589-.681 1.664-.444 1.819.4l1.459 7.91a.96.96 0 00.604.729l7.466 2.86c.798.306.836 1.413.066 1.874l-7.214 4.318a1.142 1.142 0 00-.55.845l-.896 8.143c-.095.869-1.146 1.317-1.778.757l-5.918-5.24a1.014 1.014 0 00-.944-.208z",
    fill: "url(#paint109_radial_3128_3574)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M147.599 62.737l-8.01 2.17c-.855.232-1.543-.598-1.163-1.404l3.553-7.548c.15-.32.138-.683-.034-.97l-4.056-6.793c-.433-.725.191-1.685 1.057-1.624l8.107.568c.344.025.689-.123.922-.392l5.504-6.368c.587-.68 1.661-.444 1.816.4l1.456 7.9a.96.96 0 00.604.727l7.457 2.857c.797.305.836 1.411.066 1.872l-7.206 4.313a1.137 1.137 0 00-.549.843l-.895 8.134c-.095.868-1.145 1.315-1.776.757l-5.911-5.235c-.25-.221-.602-.299-.942-.207z",
    fill: "url(#paint110_radial_3128_3574)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M147.593 62.704l-8.001 2.168c-.855.23-1.541-.597-1.162-1.402l3.549-7.54a1.03 1.03 0 00-.034-.97l-4.05-6.784c-.433-.724.191-1.683 1.056-1.622l8.097.568c.343.024.687-.123.92-.392l5.498-6.36c.586-.68 1.659-.444 1.814.4l1.455 7.89a.96.96 0 00.603.728l7.448 2.854c.795.304.834 1.409.065 1.869l-7.198 4.308a1.142 1.142 0 00-.548.842l-.894 8.124c-.095.867-1.144 1.315-1.774.756l-5.903-5.228a1.01 1.01 0 00-.941-.209z",
    fill: "url(#paint111_radial_3128_3574)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M147.585 62.672l-7.992 2.165c-.853.231-1.539-.596-1.16-1.4l3.545-7.531c.15-.319.137-.681-.034-.969l-4.046-6.776c-.433-.724.191-1.682 1.054-1.62l8.087.567c.343.024.687-.123.92-.392l5.49-6.353c.586-.678 1.657-.442 1.813.4l1.453 7.88a.957.957 0 00.602.727l7.44 2.85c.794.305.833 1.408.065 1.867l-7.189 4.303a1.137 1.137 0 00-.547.841l-.893 8.115c-.095.866-1.143 1.312-1.772.755l-5.897-5.222a1.01 1.01 0 00-.939-.207z",
    fill: "url(#paint112_radial_3128_3574)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M147.575 62.64l-7.981 2.163c-.853.23-1.537-.596-1.16-1.399l3.541-7.521c.15-.32.138-.681-.034-.968l-4.041-6.768c-.431-.723.191-1.68 1.054-1.618l8.077.566c.343.025.686-.122.918-.391l5.485-6.345c.585-.678 1.654-.442 1.809.398l1.452 7.872a.954.954 0 00.601.726l7.431 2.847c.794.304.832 1.405.065 1.864l-7.18 4.298a1.136 1.136 0 00-.547.84l-.892 8.105c-.095.865-1.141 1.31-1.769.754l-5.89-5.216a1.009 1.009 0 00-.939-.206z",
    fill: "url(#paint113_radial_3128_3574)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M147.568 62.608l-7.972 2.16c-.851.23-1.535-.596-1.158-1.398l3.537-7.512c.149-.318.137-.68-.034-.966l-4.037-6.76c-.431-.722.191-1.677 1.052-1.617l8.068.566a1.12 1.12 0 00.917-.39l5.478-6.338c.584-.676 1.653-.441 1.808.398l1.45 7.862a.955.955 0 00.6.725l7.422 2.843c.793.304.831 1.405.066 1.863l-7.172 4.293a1.13 1.13 0 00-.546.839l-.89 8.094c-.095.864-1.14 1.31-1.768.753l-5.883-5.21a1.01 1.01 0 00-.938-.205z",
    fill: "url(#paint114_radial_3128_3574)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M147.561 62.576l-7.963 2.157c-.85.23-1.533-.595-1.156-1.396l3.532-7.503c.15-.318.137-.679-.034-.965l-4.031-6.752c-.431-.721.19-1.675 1.051-1.615l8.058.566a1.12 1.12 0 00.916-.39l5.471-6.33c.584-.676 1.651-.441 1.806.397l1.448 7.853a.956.956 0 00.6.725l7.414 2.84c.791.302.83 1.402.065 1.86l-7.163 4.287a1.127 1.127 0 00-.545.838l-.89 8.085c-.095.863-1.138 1.308-1.766.753l-5.875-5.203a1.01 1.01 0 00-.938-.207z",
    fill: "url(#paint115_radial_3128_3574)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M147.553 62.544l-7.953 2.154c-.849.23-1.531-.594-1.155-1.394l3.528-7.494c.15-.318.137-.678-.034-.965l-4.027-6.743c-.429-.72.191-1.673 1.05-1.613l8.048.565c.342.023.684-.122.916-.39l5.464-6.323c.583-.675 1.649-.44 1.803.397l1.446 7.844a.955.955 0 00.6.723l7.404 2.837c.79.302.829 1.4.065 1.857l-7.155 4.283a1.126 1.126 0 00-.544.837l-.888 8.075c-.095.862-1.137 1.306-1.763.752l-5.869-5.197a1.007 1.007 0 00-.936-.206z",
    fill: "url(#paint116_radial_3128_3574)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M147.546 62.51l-7.944 2.153c-.848.23-1.53-.593-1.154-1.392l3.524-7.486a1.025 1.025 0 00-.034-.963l-4.022-6.736c-.429-.72.19-1.671 1.048-1.611l8.039.564c.341.024.683-.122.914-.39l5.458-6.314c.583-.674 1.647-.44 1.801.396l1.445 7.834a.951.951 0 00.599.723l7.395 2.833c.789.302.828 1.4.065 1.856l-7.146 4.278a1.125 1.125 0 00-.544.835l-.887 8.066c-.095.861-1.136 1.305-1.762.75l-5.861-5.19a1.007 1.007 0 00-.934-.205z",
    fill: "url(#paint117_radial_3128_3574)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M147.538 62.479l-7.934 2.15c-.848.229-1.528-.593-1.152-1.391l3.519-7.477a1.02 1.02 0 00-.034-.962l-4.017-6.727c-.429-.718.19-1.67 1.047-1.61l8.029.564c.34.024.682-.121.913-.388l5.451-6.307c.583-.673 1.646-.44 1.799.395l1.443 7.825a.954.954 0 00.598.722l7.387 2.83c.788.302.826 1.397.064 1.853l-7.137 4.272a1.123 1.123 0 00-.543.836l-.887 8.056c-.095.86-1.134 1.303-1.759.749l-5.854-5.184a1.005 1.005 0 00-.933-.206z",
    fill: "url(#paint118_radial_3128_3574)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M147.53 62.447l-7.925 2.147c-.846.23-1.526-.592-1.15-1.389l3.515-7.467a1.023 1.023 0 00-.034-.96l-4.012-6.72c-.429-.718.189-1.667 1.045-1.607l8.02.563c.34.023.681-.122.912-.389l5.445-6.3c.582-.672 1.643-.438 1.797.396l1.441 7.816c.061.33.285.6.597.72l7.377 2.827c.788.301.826 1.395.065 1.851l-7.129 4.267c-.302.18-.505.493-.542.834l-.885 8.047c-.095.858-1.133 1.3-1.757.748l-5.847-5.178a1.003 1.003 0 00-.933-.206z",
    fill: "url(#paint119_radial_3128_3574)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M147.522 62.415l-7.915 2.144c-.845.228-1.524-.59-1.15-1.387l3.511-7.459a1.017 1.017 0 00-.034-.96l-4.008-6.711c-.427-.717.19-1.665 1.045-1.605l8.01.562c.339.024.68-.12.911-.388l5.438-6.292c.58-.672 1.641-.438 1.795.395l1.439 7.806c.061.33.284.6.596.72l7.369 2.823c.786.301.825 1.394.065 1.848l-7.121 4.263c-.301.18-.504.492-.542.832l-.884 8.037c-.094.858-1.132 1.3-1.755.748l-5.84-5.171a.997.997 0 00-.93-.205z",
    fill: "url(#paint120_radial_3128_3574)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M147.515 62.382l-7.906 2.142c-.844.229-1.522-.59-1.148-1.385l3.507-7.45a1.017 1.017 0 00-.033-.958l-4.003-6.703c-.427-.716.189-1.664 1.043-1.603l8.001.561a1.11 1.11 0 00.909-.387l5.432-6.285c.579-.671 1.639-.437 1.792.395l1.438 7.796c.061.33.284.6.596.719l7.36 2.82c.785.3.824 1.391.064 1.846l-7.112 4.257c-.301.18-.504.491-.541.832l-.883 8.027c-.094.857-1.131 1.299-1.753.747l-5.833-5.166a1.002 1.002 0 00-.93-.205z",
    fill: "url(#paint121_radial_3128_3574)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M147.507 62.35l-7.896 2.14c-.843.228-1.52-.59-1.146-1.384l3.502-7.44a1.019 1.019 0 00-.033-.958l-3.998-6.695c-.427-.715.189-1.66 1.042-1.601l7.99.56a1.11 1.11 0 00.909-.386l5.425-6.277c.579-.67 1.638-.438 1.791.394l1.436 7.787c.061.33.283.599.595.718l7.351 2.816c.784.3.823 1.39.065 1.844l-7.104 4.252c-.301.18-.503.491-.54.83l-.882 8.018c-.094.855-1.128 1.297-1.751.746l-5.826-5.16a1.002 1.002 0 00-.93-.204z",
    fill: "url(#paint122_radial_3128_3574)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 62.318l-7.887 2.137c-.842.228-1.518-.589-1.145-1.382l3.499-7.432a1.016 1.016 0 00-.033-.956l-3.993-6.688c-.427-.714.189-1.658 1.04-1.599l7.981.56c.339.024.678-.12.908-.386l5.419-6.27c.578-.669 1.635-.436 1.788.394l1.434 7.778c.061.33.284.598.595.717l7.342 2.813c.784.3.821 1.39.064 1.843l-7.094 4.246c-.301.18-.503.49-.54.83l-.881 8.008c-.095.855-1.128 1.295-1.749.745l-5.819-5.153a1 1 0 00-.929-.205z",
    fill: "url(#paint123_radial_3128_3574)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M147.492 62.286l-7.877 2.134c-.841.228-1.517-.588-1.144-1.38l3.495-7.423a1.017 1.017 0 00-.034-.955l-3.988-6.68c-.426-.712.189-1.656 1.04-1.596l7.971.56c.338.023.677-.121.907-.387l5.411-6.261c.578-.67 1.633-.437 1.786.393l1.432 7.768c.061.33.283.597.594.716l7.333 2.81c.783.299.821 1.386.065 1.84l-7.086 4.24c-.3.18-.502.49-.539.83l-.88 7.997c-.094.854-1.126 1.294-1.747.745l-5.812-5.147a.998.998 0 00-.927-.204z",
    fill: "url(#paint124_radial_3128_3574)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M147.483 62.254l-7.867 2.13c-.84.228-1.516-.586-1.143-1.378l3.49-7.414a1.017 1.017 0 00-.033-.953l-3.984-6.671c-.425-.712.188-1.655 1.038-1.596l7.962.56c.337.023.676-.12.904-.386l5.406-6.254c.577-.668 1.631-.435 1.784.393l1.431 7.759c.061.329.282.596.593.715l7.324 2.806c.782.3.82 1.386.065 1.838l-7.078 4.236c-.3.18-.501.49-.539.828l-.878 7.989c-.094.853-1.125 1.291-1.745.743l-5.805-5.141a.993.993 0 00-.925-.204z",
    fill: "url(#paint125_radial_3128_3574)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M147.475 62.221l-7.857 2.13c-.839.227-1.514-.587-1.142-1.378l3.486-7.404c.148-.314.136-.67-.033-.953l-3.978-6.663c-.425-.712.188-1.653 1.037-1.593l7.951.557c.337.024.675-.12.905-.384l5.398-6.247c.577-.666 1.63-.434 1.782.392l1.429 7.75a.943.943 0 00.592.714l7.315 2.803c.781.299.82 1.384.065 1.835l-7.07 4.232c-.299.18-.5.489-.538.827l-.878 7.978c-.093.852-1.123 1.29-1.742.743l-5.798-5.135a.993.993 0 00-.924-.204z",
    fill: "url(#paint126_radial_3128_3574)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M147.468 62.19l-7.848 2.126c-.837.227-1.511-.586-1.14-1.375l3.482-7.395c.147-.314.135-.67-.034-.952l-3.974-6.655c-.424-.71.188-1.65 1.036-1.591l7.942.557c.337.023.674-.12.903-.385l5.393-6.24c.575-.665 1.627-.434 1.779.393l1.427 7.74a.942.942 0 00.591.713l7.307 2.8c.78.298.817 1.381.064 1.833l-7.061 4.226c-.299.18-.5.488-.537.826l-.877 7.969c-.093.85-1.122 1.288-1.74.741l-5.791-5.128a.988.988 0 00-.922-.203z",
    fill: "url(#paint127_radial_3128_3574)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M147.468 62.189l-7.848 2.126c-.837.227-1.511-.586-1.14-1.375l3.482-7.395c.147-.314.135-.67-.034-.952l-3.974-6.654c-.424-.71.188-1.651 1.036-1.592l7.942.557c.337.024.674-.12.903-.385l5.393-6.239c.575-.666 1.627-.435 1.779.392l1.427 7.74a.942.942 0 00.591.713l7.307 2.8c.78.299.817 1.382.064 1.833l-7.061 4.227c-.299.179-.5.488-.537.825l-.877 7.97c-.093.85-1.122 1.288-1.74.74l-5.791-5.127a.989.989 0 00-.922-.204z",
    fill: "url(#paint128_linear_3128_3574)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M166.02 93.202l-50.221-11.055c-1.416-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.897 2.351-3.314 2.04z",
    fill: "url(#paint129_linear_3128_3574)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M166.029 93.173l-50.221-11.055c-1.417-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l50.221 11.055c1.417.311 2.243 1.739 1.836 3.172-.406 1.433-1.898 2.35-3.314 2.039z",
    fill: "url(#paint130_radial_3128_3574)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M166.037 93.144l-50.221-11.055c-1.417-.311-2.243-1.739-1.836-3.172.406-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.416.312 2.243 1.74 1.836 3.173-.406 1.432-1.898 2.35-3.314 2.038z",
    fill: "url(#paint131_radial_3128_3574)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M166.045 93.115l-50.22-11.054c-1.417-.312-2.243-1.74-1.837-3.173.407-1.434 1.899-2.35 3.315-2.039l50.22 11.055c1.417.312 2.243 1.74 1.837 3.172-.406 1.433-1.898 2.351-3.315 2.04z",
    fill: "url(#paint132_radial_3128_3574)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M166.054 93.086l-50.221-11.054c-1.416-.312-2.242-1.74-1.836-3.172.407-1.434 1.899-2.35 3.315-2.039l50.22 11.055c1.417.312 2.243 1.74 1.836 3.172-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint133_radial_3128_3574)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M166.062 93.057l-50.221-11.055c-1.416-.311-2.243-1.739-1.836-3.172.407-1.434 1.898-2.35 3.314-2.039l50.221 11.055c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.898 2.35-3.314 2.039z",
    fill: "url(#paint134_radial_3128_3574)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M166.069 93.028l-50.221-11.055c-1.417-.312-2.243-1.74-1.836-3.172.407-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.417.312 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint135_radial_3128_3574)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M166.078 93l-50.221-11.055c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.416.312 2.243 1.74 1.836 3.172-.406 1.434-1.898 2.351-3.314 2.04z",
    fill: "url(#paint136_radial_3128_3574)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M166.085 92.97l-50.22-11.054c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.416.312 2.242 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.315 2.039z",
    fill: "url(#paint137_radial_3128_3574)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M166.094 92.941l-50.221-11.055c-1.416-.311-2.242-1.739-1.836-3.172.407-1.434 1.899-2.35 3.315-2.039l50.22 11.055c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.897 2.351-3.314 2.04z",
    fill: "url(#paint138_radial_3128_3574)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M166.103 92.912l-50.221-11.054c-1.416-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.039l50.221 11.055c1.417.312 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint139_radial_3128_3574)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M166.111 92.883L115.89 81.83c-1.417-.312-2.243-1.74-1.836-3.172.407-1.433 1.898-2.35 3.314-2.039l50.221 11.055c1.417.312 2.243 1.74 1.836 3.173-.407 1.432-1.898 2.35-3.314 2.037z",
    fill: "url(#paint140_radial_3128_3574)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M166.12 92.854L115.899 81.8c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.416.312 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint141_radial_3128_3574)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M166.127 92.826l-50.22-11.055c-1.417-.312-2.243-1.74-1.837-3.172.407-1.433 1.899-2.35 3.315-2.039l50.221 11.055c1.416.312 2.242 1.74 1.836 3.173-.406 1.432-1.898 2.349-3.315 2.038z",
    fill: "url(#paint142_radial_3128_3574)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M166.136 92.796l-50.221-11.054c-1.416-.312-2.242-1.74-1.836-3.173.407-1.433 1.899-2.35 3.315-2.038l50.22 11.054c1.417.312 2.243 1.74 1.836 3.173-.406 1.433-1.897 2.35-3.314 2.038z",
    fill: "url(#paint143_radial_3128_3574)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M166.144 92.767l-50.221-11.054c-1.416-.312-2.243-1.74-1.836-3.172.407-1.434 1.898-2.35 3.314-2.039l50.221 11.055c1.417.312 2.243 1.74 1.836 3.172-.406 1.433-1.897 2.35-3.314 2.038z",
    fill: "url(#paint144_radial_3128_3574)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M166.153 92.738l-50.221-11.054c-1.417-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.417.312 2.243 1.74 1.836 3.172-.407 1.434-1.898 2.351-3.314 2.04z",
    fill: "url(#paint145_radial_3128_3574)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M166.16 92.71l-50.221-11.054c-1.417-.312-2.243-1.74-1.836-3.173.406-1.434 1.898-2.35 3.314-2.039L167.638 87.5c1.416.312 2.243 1.74 1.836 3.173-.406 1.432-1.898 2.35-3.314 2.038z",
    fill: "url(#paint146_radial_3128_3574)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M166.168 92.68l-50.22-11.054c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.039l50.221 11.055c1.416.312 2.242 1.74 1.836 3.172-.406 1.434-1.898 2.351-3.315 2.04z",
    fill: "url(#paint147_radial_3128_3574)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M166.176 92.651l-50.221-11.054c-1.416-.312-2.242-1.74-1.836-3.173.407-1.433 1.899-2.35 3.315-2.038l50.22 11.054c1.417.312 2.243 1.74 1.836 3.173-.406 1.433-1.897 2.35-3.314 2.038z",
    fill: "url(#paint148_radial_3128_3574)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M166.185 92.622l-50.221-11.054c-1.416-.312-2.243-1.74-1.836-3.172.407-1.434 1.898-2.35 3.314-2.039l50.221 11.055c1.417.312 2.243 1.74 1.836 3.172-.406 1.432-1.897 2.35-3.314 2.038z",
    fill: "url(#paint149_radial_3128_3574)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M166.193 92.594l-50.221-11.055c-1.417-.312-2.243-1.74-1.836-3.172.407-1.434 1.898-2.35 3.314-2.039l50.221 11.055c1.417.312 2.243 1.74 1.836 3.172-.407 1.433-1.898 2.35-3.314 2.039z",
    fill: "url(#paint150_radial_3128_3574)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M166.202 92.565L115.981 81.51c-1.417-.311-2.243-1.739-1.836-3.172.406-1.434 1.898-2.35 3.314-2.039l50.221 11.055c1.416.312 2.243 1.74 1.836 3.172-.407 1.433-1.898 2.35-3.314 2.04z",
    fill: "url(#paint151_radial_3128_3574)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M166.208 92.535l-50.22-11.054c-1.417-.312-2.243-1.74-1.836-3.172.406-1.434 1.898-2.35 3.314-2.039l50.221 11.055c1.416.312 2.242 1.74 1.836 3.172-.406 1.433-1.898 2.35-3.315 2.038z",
    fill: "url(#paint152_radial_3128_3574)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M166.217 92.507l-50.221-11.055c-1.416-.312-2.242-1.74-1.836-3.172.407-1.433 1.899-2.35 3.315-2.038l50.22 11.054c1.417.312 2.243 1.74 1.837 3.173-.407 1.433-1.898 2.35-3.315 2.038z",
    fill: "url(#paint153_radial_3128_3574)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M166.226 92.478l-50.221-11.055c-1.416-.312-2.243-1.74-1.836-3.172.407-1.434 1.898-2.35 3.314-2.039l50.221 11.055c1.417.312 2.243 1.74 1.836 3.172-.406 1.433-1.897 2.35-3.314 2.039z",
    fill: "url(#paint154_radial_3128_3574)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M166.234 92.449l-50.221-11.055c-1.417-.312-2.243-1.74-1.836-3.172.407-1.434 1.898-2.35 3.314-2.039l50.221 11.055c1.417.311 2.243 1.739 1.836 3.172-.406 1.433-1.898 2.35-3.314 2.039z",
    fill: "url(#paint155_radial_3128_3574)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M166.243 92.42l-50.221-11.055c-1.417-.312-2.243-1.74-1.836-3.172.406-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.416.312 2.243 1.74 1.836 3.172-.407 1.434-1.898 2.35-3.314 2.039z",
    fill: "url(#paint156_radial_3128_3574)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M166.25 92.391l-50.22-11.055c-1.417-.311-2.243-1.74-1.836-3.172.406-1.434 1.898-2.35 3.314-2.039l50.221 11.055c1.416.312 2.242 1.74 1.836 3.172-.407 1.434-1.899 2.35-3.315 2.039z",
    fill: "url(#paint157_radial_3128_3574)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M166.258 92.362l-50.22-11.055c-1.417-.312-2.243-1.74-1.837-3.172.407-1.433 1.899-2.35 3.315-2.038l50.22 11.054c1.417.312 2.243 1.74 1.837 3.173-.407 1.432-1.898 2.35-3.315 2.038z",
    fill: "url(#paint158_radial_3128_3574)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M166.266 92.333L116.045 81.28c-1.416-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.897 2.351-3.314 2.04z",
    fill: "url(#paint159_radial_3128_3574)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M166.275 92.305L116.054 81.25c-1.417-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.417.312 2.243 1.74 1.836 3.173-.406 1.433-1.897 2.35-3.314 2.039z",
    fill: "url(#paint160_radial_3128_3574)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M166.284 92.275L116.063 81.22c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l50.221 11.055c1.416.311 2.243 1.739 1.836 3.172-.406 1.434-1.898 2.35-3.314 2.039z",
    fill: "url(#paint161_radial_3128_3574)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M166.292 92.246l-50.22-11.054c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.039l50.221 11.055c1.416.312 2.242 1.74 1.836 3.173-.407 1.433-1.899 2.35-3.315 2.038z",
    fill: "url(#paint162_radial_3128_3574)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M166.3 92.218l-50.221-11.055c-1.416-.312-2.242-1.74-1.836-3.173.407-1.433 1.899-2.35 3.315-2.038l50.22 11.054c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.898 2.352-3.314 2.04z",
    fill: "url(#paint163_radial_3128_3574)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M166.308 92.188l-50.221-11.054c-1.416-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.417.312 2.243 1.74 1.836 3.173-.406 1.432-1.897 2.35-3.314 2.038z",
    fill: "url(#paint164_radial_3128_3574)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M166.316 92.16l-50.221-11.055c-1.417-.312-2.243-1.74-1.836-3.172.407-1.433 1.898-2.35 3.314-2.039l50.221 11.055c1.417.312 2.243 1.74 1.836 3.173-.406 1.432-1.898 2.349-3.314 2.038z",
    fill: "url(#paint165_radial_3128_3574)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M166.325 92.13l-50.221-11.054c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l50.221 11.054c1.416.312 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint166_radial_3128_3574)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M166.332 92.101l-50.22-11.054c-1.417-.312-2.243-1.74-1.836-3.172.406-1.434 1.898-2.35 3.314-2.039l50.221 11.055c1.416.312 2.242 1.74 1.836 3.172-.406 1.433-1.898 2.35-3.315 2.038z",
    fill: "url(#paint167_radial_3128_3574)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M166.341 92.073L116.12 81.018c-1.416-.312-2.242-1.74-1.836-3.173.407-1.433 1.899-2.35 3.315-2.038l50.22 11.054c1.417.312 2.243 1.74 1.837 3.172-.407 1.434-1.899 2.352-3.315 2.04z",
    fill: "url(#paint168_radial_3128_3574)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M166.349 92.044l-50.221-11.055c-1.416-.312-2.243-1.74-1.836-3.172.407-1.434 1.898-2.35 3.314-2.04l50.222 11.056c1.416.311 2.243 1.739 1.836 3.172-.407 1.433-1.898 2.35-3.315 2.039z",
    fill: "url(#paint169_radial_3128_3574)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M166.357 92.014L116.136 80.96c-1.417-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.039l50.221 11.055c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.897 2.351-3.314 2.04z",
    fill: "url(#paint170_radial_3128_3574)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M166.357 92.014L116.136 80.96c-1.417-.312-2.243-1.739-1.836-3.172.407-1.434 1.898-2.35 3.314-2.039l50.221 11.055c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.897 2.351-3.314 2.04z",
    fill: "url(#paint171_linear_3128_3574)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M156.776 100.235l-36.576-8.05c-1.417-.313-2.243-1.74-1.837-3.174.407-1.433 1.899-2.35 3.315-2.038l36.577 8.051c1.416.312 2.242 1.74 1.836 3.172-.406 1.433-1.898 2.351-3.315 2.039z",
    fill: "url(#paint172_linear_3128_3574)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M156.785 100.206l-36.577-8.05c-1.416-.312-2.242-1.74-1.836-3.173.407-1.434 1.899-2.35 3.315-2.039l36.576 8.051c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.897 2.351-3.314 2.039z",
    fill: "url(#paint173_radial_3128_3574)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M156.793 100.177l-36.577-8.05c-1.416-.313-2.243-1.74-1.836-3.173.407-1.434 1.898-2.35 3.314-2.039l36.577 8.051c1.417.312 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint174_radial_3128_3574)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M156.801 100.148l-36.577-8.05c-1.417-.313-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.417.313 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint175_radial_3128_3574)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M156.809 100.119l-36.577-8.05c-1.417-.313-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.416.313 2.243 1.74 1.836 3.174-.406 1.431-1.898 2.349-3.314 2.037z",
    fill: "url(#paint176_radial_3128_3574)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M156.817 100.091l-36.576-8.051c-1.417-.312-2.243-1.74-1.837-3.172.407-1.434 1.899-2.35 3.315-2.039l36.577 8.05c1.416.313 2.242 1.74 1.836 3.174-.406 1.432-1.898 2.349-3.315 2.038z",
    fill: "url(#paint177_radial_3128_3574)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M156.825 100.061l-36.577-8.05c-1.416-.313-2.242-1.74-1.836-3.173.407-1.434 1.899-2.35 3.315-2.04l36.576 8.052c1.417.312 2.243 1.74 1.837 3.172-.407 1.434-1.898 2.351-3.315 2.039z",
    fill: "url(#paint178_radial_3128_3574)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M156.834 100.032l-36.577-8.05c-1.416-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.417.313 2.243 1.74 1.836 3.173-.406 1.433-1.897 2.35-3.314 2.038z",
    fill: "url(#paint179_radial_3128_3574)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M156.842 100.004l-36.577-8.051c-1.417-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.039l36.577 8.051c1.417.312 2.243 1.74 1.836 3.172-.407 1.434-1.898 2.351-3.314 2.04z",
    fill: "url(#paint180_radial_3128_3574)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M156.85 99.975l-36.577-8.051c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.416.312 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.351-3.314 2.039z",
    fill: "url(#paint181_radial_3128_3574)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M156.858 99.946l-36.576-8.051c-1.417-.312-2.243-1.74-1.837-3.173.407-1.433 1.899-2.35 3.315-2.038l36.577 8.05c1.416.313 2.242 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.315 2.039z",
    fill: "url(#paint182_radial_3128_3574)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M156.867 99.916l-36.577-8.05c-1.416-.313-2.242-1.74-1.836-3.173.407-1.434 1.899-2.35 3.315-2.039l36.576 8.051c1.417.312 2.243 1.74 1.837 3.172-.407 1.434-1.898 2.351-3.315 2.04z",
    fill: "url(#paint183_radial_3128_3574)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M156.875 99.887l-36.577-8.05c-1.416-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.417.313 2.243 1.74 1.836 3.173-.406 1.433-1.897 2.35-3.314 2.038z",
    fill: "url(#paint184_radial_3128_3574)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M156.884 99.859l-36.577-8.051c-1.417-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.417.312 2.243 1.74 1.836 3.173-.407 1.433-1.898 2.351-3.314 2.039z",
    fill: "url(#paint185_radial_3128_3574)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M156.892 99.83l-36.577-8.051c-1.417-.312-2.243-1.74-1.836-3.172.406-1.434 1.898-2.35 3.314-2.039l36.577 8.051c1.416.312 2.243 1.74 1.836 3.172-.407 1.433-1.898 2.351-3.314 2.039z",
    fill: "url(#paint186_radial_3128_3574)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M156.899 99.8l-36.576-8.05c-1.417-.313-2.243-1.74-1.836-3.174.406-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.416.313 2.242 1.74 1.836 3.174-.406 1.433-1.898 2.35-3.315 2.038z",
    fill: "url(#paint187_radial_3128_3574)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M156.907 99.772L120.33 91.72c-1.416-.311-2.242-1.739-1.836-3.172.407-1.433 1.899-2.35 3.315-2.038l36.576 8.05c1.417.313 2.243 1.74 1.837 3.174-.406 1.432-1.898 2.349-3.315 2.038z",
    fill: "url(#paint188_radial_3128_3574)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M156.916 99.743l-36.577-8.051c-1.416-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.039l36.577 8.051c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.897 2.351-3.314 2.04z",
    fill: "url(#paint189_radial_3128_3574)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M156.924 99.714l-36.577-8.051c-1.417-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.417.312 2.243 1.74 1.836 3.173-.406 1.433-1.897 2.351-3.314 2.039z",
    fill: "url(#paint190_radial_3128_3574)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M156.933 99.685l-36.577-8.05c-1.417-.313-2.243-1.74-1.836-3.174.406-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.416.313 2.243 1.74 1.836 3.173-.407 1.433-1.898 2.35-3.314 2.04z",
    fill: "url(#paint191_radial_3128_3574)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M156.941 99.656l-36.576-8.051c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.039l36.577 8.051c1.416.312 2.242 1.74 1.836 3.173-.407 1.433-1.899 2.35-3.315 2.039z",
    fill: "url(#paint192_radial_3128_3574)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M156.948 99.627l-36.577-8.051c-1.416-.312-2.242-1.74-1.836-3.172.407-1.433 1.899-2.35 3.315-2.039l36.576 8.051c1.417.312 2.243 1.74 1.837 3.173-.406 1.433-1.898 2.35-3.315 2.038z",
    fill: "url(#paint193_radial_3128_3574)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M156.957 99.598l-36.577-8.05c-1.416-.313-2.243-1.74-1.836-3.174.407-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.417.313 2.243 1.74 1.836 3.173-.406 1.433-1.897 2.35-3.314 2.039z",
    fill: "url(#paint194_radial_3128_3574)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M156.965 99.57l-36.577-8.052c-1.417-.312-2.243-1.74-1.836-3.172.407-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.417.312 2.243 1.74 1.836 3.173-.406 1.432-1.897 2.35-3.314 2.038z",
    fill: "url(#paint195_radial_3128_3574)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M156.974 99.54l-36.577-8.05c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.416.313 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint196_radial_3128_3574)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M156.981 99.511l-36.576-8.051c-1.417-.312-2.243-1.74-1.836-3.172.406-1.433 1.898-2.35 3.314-2.039L158.46 94.3c1.416.312 2.242 1.74 1.836 3.172-.407 1.434-1.898 2.35-3.315 2.039z",
    fill: "url(#paint197_radial_3128_3574)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M156.99 99.482l-36.577-8.05c-1.416-.313-2.242-1.74-1.836-3.174.407-1.433 1.899-2.35 3.315-2.038l36.576 8.05c1.417.313 2.243 1.74 1.837 3.173-.407 1.433-1.899 2.351-3.315 2.04z",
    fill: "url(#paint198_radial_3128_3574)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M156.998 99.454l-36.577-8.051c-1.416-.312-2.243-1.74-1.836-3.173.407-1.434 1.898-2.35 3.314-2.039l36.577 8.051c1.417.312 2.243 1.74 1.836 3.173-.406 1.433-1.897 2.35-3.314 2.038z",
    fill: "url(#paint199_radial_3128_3574)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M157.006 99.424l-36.577-8.05c-1.417-.313-2.243-1.74-1.836-3.173.407-1.434 1.898-2.35 3.314-2.039l36.577 8.05c1.417.313 2.243 1.74 1.836 3.174-.406 1.432-1.897 2.35-3.314 2.038z",
    fill: "url(#paint200_radial_3128_3574)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M157.015 99.395l-36.577-8.05c-1.417-.313-2.243-1.74-1.836-3.174.406-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.416.313 2.243 1.74 1.836 3.173-.406 1.434-1.898 2.351-3.314 2.04z",
    fill: "url(#paint201_radial_3128_3574)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M157.023 99.366l-36.577-8.05c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.416.313 2.242 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint202_radial_3128_3574)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M157.031 99.338l-36.577-8.051c-1.416-.312-2.242-1.74-1.836-3.173.407-1.434 1.899-2.35 3.315-2.039l36.576 8.051c1.417.312 2.243 1.74 1.837 3.172-.407 1.434-1.899 2.351-3.315 2.04z",
    fill: "url(#paint203_radial_3128_3574)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M157.039 99.308l-36.577-8.05c-1.416-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.039l36.577 8.051c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.897 2.351-3.314 2.04z",
    fill: "url(#paint204_radial_3128_3574)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M157.048 99.28l-36.577-8.051c-1.417-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.417.313 2.243 1.74 1.836 3.173-.406 1.433-1.897 2.35-3.314 2.039z",
    fill: "url(#paint205_radial_3128_3574)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M157.056 99.25l-36.577-8.05c-1.417-.313-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.416.313 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint206_radial_3128_3574)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M157.065 99.221l-36.577-8.05c-1.417-.313-2.243-1.74-1.836-3.173.406-1.434 1.898-2.35 3.314-2.039l36.577 8.051c1.416.312 2.242 1.74 1.836 3.172-.406 1.434-1.898 2.351-3.314 2.04z",
    fill: "url(#paint207_radial_3128_3574)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M157.072 99.193l-36.576-8.051c-1.417-.312-2.243-1.74-1.837-3.173.407-1.433 1.899-2.35 3.315-2.038l36.576 8.05c1.417.313 2.243 1.74 1.837 3.173-.407 1.433-1.898 2.35-3.315 2.039z",
    fill: "url(#paint208_radial_3128_3574)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M157.081 99.164l-36.577-8.051c-1.416-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.417.312 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.314 2.039z",
    fill: "url(#paint209_radial_3128_3574)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M157.088 99.134l-36.577-8.05c-1.417-.313-2.243-1.74-1.836-3.174.407-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.417.313 2.243 1.74 1.836 3.174-.406 1.433-1.897 2.35-3.314 2.038z",
    fill: "url(#paint210_radial_3128_3574)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M157.097 99.106l-36.577-8.051c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.417.313 2.243 1.74 1.836 3.174-.406 1.432-1.898 2.35-3.314 2.038z",
    fill: "url(#paint211_radial_3128_3574)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M157.106 99.077l-36.577-8.051c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l36.577 8.05c1.416.312 2.242 1.74 1.836 3.173-.406 1.433-1.898 2.35-3.314 2.039z",
    fill: "url(#paint212_radial_3128_3574)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M157.113 99.048l-36.576-8.051c-1.417-.312-2.243-1.74-1.837-3.173.407-1.433 1.899-2.35 3.315-2.038l36.576 8.05c1.417.313 2.243 1.74 1.837 3.173-.406 1.433-1.898 2.35-3.315 2.039z",
    fill: "url(#paint213_radial_3128_3574)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M157.113 99.048l-36.576-8.051c-1.417-.312-2.243-1.74-1.837-3.173.407-1.433 1.899-2.35 3.315-2.038l36.576 8.05c1.417.313 2.243 1.74 1.837 3.173-.406 1.433-1.898 2.35-3.315 2.039z",
    fill: "url(#paint214_linear_3128_3574)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M145.218 106.47l-18.145-3.995c-1.417-.312-2.243-1.739-1.836-3.172.406-1.433 1.898-2.35 3.314-2.038l18.145 3.994c1.417.312 2.243 1.739 1.837 3.172-.407 1.433-1.898 2.35-3.315 2.039z",
    fill: "url(#paint215_linear_3128_3574)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M145.227 106.44l-18.146-3.994c-1.416-.312-2.242-1.74-1.836-3.173.407-1.433 1.899-2.35 3.315-2.039l18.145 3.995c1.417.312 2.243 1.739 1.836 3.172-.406 1.434-1.897 2.351-3.314 2.039z",
    fill: "url(#paint216_radial_3128_3574)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M145.235 106.412l-18.146-3.995c-1.416-.312-2.243-1.739-1.836-3.172.407-1.434 1.898-2.351 3.314-2.04l18.146 3.995c1.417.312 2.243 1.74 1.836 3.173-.407 1.433-1.898 2.351-3.314 2.039z",
    fill: "url(#paint217_radial_3128_3574)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M145.243 106.383l-18.146-3.995c-1.417-.312-2.243-1.739-1.836-3.172.407-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.416.312 2.243 1.739 1.836 3.173-.406 1.432-1.898 2.35-3.314 2.038z",
    fill: "url(#paint218_radial_3128_3574)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M145.251 106.354l-18.145-3.995c-1.417-.311-2.243-1.739-1.836-3.172.406-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.416.312 2.242 1.74 1.836 3.172-.406 1.433-1.898 2.35-3.315 2.039z",
    fill: "url(#paint219_radial_3128_3574)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M145.26 106.324l-18.145-3.994c-1.417-.312-2.243-1.74-1.836-3.172.406-1.433 1.898-2.35 3.314-2.039l18.145 3.995c1.417.312 2.243 1.739 1.837 3.172-.407 1.433-1.898 2.35-3.315 2.038z",
    fill: "url(#paint220_radial_3128_3574)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M145.268 106.295l-18.146-3.994c-1.416-.312-2.242-1.739-1.836-3.173.407-1.433 1.899-2.35 3.315-2.038l18.145 3.994c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.897 2.351-3.314 2.039z",
    fill: "url(#paint221_radial_3128_3574)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M145.277 106.267l-18.146-3.995c-1.416-.312-2.243-1.739-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.417.312 2.243 1.74 1.836 3.172-.407 1.434-1.898 2.351-3.314 2.04z",
    fill: "url(#paint222_radial_3128_3574)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M145.285 106.238l-18.146-3.995c-1.417-.311-2.243-1.739-1.836-3.172.407-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.416.312 2.243 1.74 1.836 3.172-.407 1.433-1.898 2.351-3.314 2.039z",
    fill: "url(#paint223_radial_3128_3574)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M145.292 106.209l-18.145-3.994c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.039l18.146 3.995c1.416.312 2.242 1.739 1.836 3.172-.406 1.433-1.898 2.35-3.315 2.039z",
    fill: "url(#paint224_radial_3128_3574)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M145.3 106.18l-18.145-3.995c-1.417-.312-2.243-1.739-1.836-3.172.406-1.433 1.898-2.35 3.314-2.038l18.145 3.994c1.417.312 2.243 1.739 1.837 3.172-.406 1.433-1.898 2.35-3.315 2.039z",
    fill: "url(#paint225_radial_3128_3574)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M145.309 106.15l-18.146-3.994c-1.416-.312-2.242-1.739-1.836-3.172.407-1.433 1.899-2.35 3.315-2.039l18.145 3.995c1.417.312 2.243 1.739 1.836 3.172-.406 1.433-1.897 2.35-3.314 2.038z",
    fill: "url(#paint226_radial_3128_3574)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M145.317 106.122l-18.146-3.995c-1.416-.312-2.243-1.739-1.836-3.172.407-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.417.312 2.243 1.739 1.836 3.172-.406 1.433-1.897 2.351-3.314 2.039z",
    fill: "url(#paint227_radial_3128_3574)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M145.326 106.093l-18.146-3.994c-1.417-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.416.312 2.243 1.739 1.836 3.173-.407 1.432-1.898 2.35-3.314 2.038z",
    fill: "url(#paint228_radial_3128_3574)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M145.334 106.064l-18.145-3.995c-1.417-.312-2.243-1.739-1.836-3.172.406-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.416.312 2.242 1.74 1.836 3.173-.407 1.433-1.899 2.35-3.315 2.038z",
    fill: "url(#paint229_radial_3128_3574)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M145.341 106.035l-18.145-3.995c-1.417-.312-2.243-1.739-1.836-3.172.406-1.433 1.898-2.35 3.314-2.038l18.145 3.994c1.417.312 2.243 1.739 1.837 3.172-.406 1.433-1.898 2.35-3.315 2.039z",
    fill: "url(#paint230_radial_3128_3574)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M145.35 106.006l-18.146-3.994c-1.416-.312-2.242-1.74-1.836-3.172.407-1.434 1.899-2.35 3.315-2.039l18.145 3.995c1.417.311 2.243 1.739 1.836 3.172-.406 1.432-1.897 2.35-3.314 2.038z",
    fill: "url(#paint231_radial_3128_3574)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M145.358 105.977l-18.146-3.994c-1.416-.312-2.243-1.74-1.836-3.172.407-1.434 1.898-2.35 3.314-2.039l18.146 3.995c1.417.311 2.243 1.739 1.836 3.172-.406 1.432-1.897 2.35-3.314 2.038z",
    fill: "url(#paint232_radial_3128_3574)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M145.367 105.948l-18.146-3.994c-1.417-.312-2.243-1.74-1.836-3.172.407-1.433 1.898-2.35 3.314-2.039l18.146 3.995c1.416.312 2.243 1.739 1.836 3.172-.406 1.432-1.898 2.35-3.314 2.038z",
    fill: "url(#paint233_radial_3128_3574)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M145.374 105.919l-18.145-3.994c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.039l18.146 3.995c1.416.312 2.242 1.739 1.836 3.172-.407 1.434-1.898 2.351-3.315 2.039z",
    fill: "url(#paint234_radial_3128_3574)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M145.383 105.89l-18.145-3.995c-1.417-.311-2.243-1.739-1.836-3.172.406-1.434 1.898-2.35 3.314-2.039l18.145 3.995c1.417.312 2.243 1.739 1.837 3.172-.407 1.434-1.899 2.351-3.315 2.039z",
    fill: "url(#paint235_radial_3128_3574)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M145.39 105.861l-18.145-3.994c-1.417-.312-2.243-1.74-1.837-3.172.407-1.434 1.899-2.35 3.315-2.039l18.145 3.995c1.417.311 2.243 1.739 1.836 3.172-.406 1.432-1.897 2.35-3.314 2.038z",
    fill: "url(#paint236_radial_3128_3574)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M145.399 105.832l-18.146-3.994c-1.416-.312-2.243-1.739-1.836-3.172.407-1.433 1.898-2.35 3.314-2.039l18.146 3.995c1.417.312 2.243 1.739 1.836 3.172-.406 1.433-1.897 2.35-3.314 2.038z",
    fill: "url(#paint237_radial_3128_3574)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M145.407 105.803l-18.146-3.995c-1.417-.311-2.243-1.739-1.836-3.172.407-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.898 2.351-3.314 2.039z",
    fill: "url(#paint238_radial_3128_3574)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M145.416 105.774l-18.146-3.994c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.416.312 2.242 1.739 1.836 3.172-.406 1.434-1.898 2.351-3.314 2.039z",
    fill: "url(#paint239_radial_3128_3574)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M145.423 105.745l-18.145-3.994c-1.417-.312-2.243-1.74-1.836-3.173.406-1.433 1.898-2.35 3.314-2.038l18.145 3.994c1.417.312 2.243 1.74 1.837 3.173-.407 1.432-1.899 2.35-3.315 2.038z",
    fill: "url(#paint240_radial_3128_3574)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M145.432 105.717l-18.145-3.995c-1.417-.312-2.243-1.74-1.837-3.172.407-1.433 1.899-2.35 3.315-2.038l18.145 3.994c1.417.312 2.243 1.739 1.836 3.172-.406 1.433-1.897 2.351-3.314 2.039z",
    fill: "url(#paint241_radial_3128_3574)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M145.44 105.688l-18.146-3.995c-1.416-.311-2.242-1.739-1.836-3.172.407-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.417.312 2.243 1.74 1.836 3.173-.406 1.432-1.897 2.349-3.314 2.038z",
    fill: "url(#paint242_radial_3128_3574)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M145.448 105.658l-18.146-3.994c-1.417-.312-2.243-1.74-1.836-3.172.407-1.434 1.898-2.35 3.314-2.039l18.146 3.995c1.417.312 2.243 1.739 1.836 3.172-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint243_radial_3128_3574)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M145.457 105.629l-18.145-3.994c-1.417-.312-2.243-1.74-1.836-3.172.406-1.434 1.898-2.35 3.314-2.039l18.146 3.995c1.416.311 2.242 1.739 1.836 3.172-.406 1.433-1.898 2.35-3.315 2.038z",
    fill: "url(#paint244_radial_3128_3574)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M145.465 105.601l-18.145-3.995c-1.417-.312-2.243-1.74-1.836-3.172.406-1.433 1.898-2.35 3.314-2.038l18.145 3.994c1.417.312 2.243 1.739 1.837 3.172-.406 1.433-1.898 2.351-3.315 2.039z",
    fill: "url(#paint245_radial_3128_3574)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M145.473 105.572l-18.145-3.995c-1.417-.312-2.243-1.74-1.837-3.172.407-1.434 1.899-2.35 3.315-2.039l18.145 3.994c1.417.312 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.351-3.314 2.039z",
    fill: "url(#paint246_radial_3128_3574)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M145.481 105.542l-18.146-3.994c-1.416-.312-2.242-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.417.312 2.243 1.739 1.836 3.173-.406 1.433-1.897 2.35-3.314 2.038z",
    fill: "url(#paint247_radial_3128_3574)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M145.49 105.514l-18.146-3.995c-1.417-.312-2.243-1.74-1.836-3.172.407-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.417.312 2.243 1.74 1.836 3.172-.406 1.434-1.898 2.351-3.314 2.039z",
    fill: "url(#paint248_radial_3128_3574)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M145.498 105.484l-18.146-3.994c-1.417-.312-2.243-1.74-1.836-3.172.406-1.433 1.898-2.35 3.314-2.039l18.146 3.995c1.416.312 2.242 1.739 1.836 3.172-.406 1.433-1.898 2.35-3.314 2.038z",
    fill: "url(#paint249_radial_3128_3574)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M145.506 105.456l-18.145-3.995c-1.417-.312-2.243-1.74-1.836-3.172.406-1.433 1.898-2.35 3.314-2.038l18.145 3.994c1.417.312 2.243 1.739 1.837 3.172-.406 1.433-1.898 2.351-3.315 2.039z",
    fill: "url(#paint250_radial_3128_3574)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M145.514 105.427l-18.145-3.994c-1.417-.312-2.243-1.74-1.837-3.173.407-1.433 1.899-2.35 3.315-2.038l18.145 3.994c1.417.312 2.243 1.739 1.836 3.172-.406 1.433-1.897 2.35-3.314 2.039z",
    fill: "url(#paint251_radial_3128_3574)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M145.523 105.398l-18.146-3.995c-1.416-.312-2.242-1.74-1.836-3.172.407-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.417.312 2.243 1.739 1.836 3.172-.406 1.433-1.898 2.35-3.314 2.039z",
    fill: "url(#paint252_radial_3128_3574)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M145.531 105.369l-18.146-3.995c-1.417-.312-2.243-1.74-1.836-3.172.407-1.434 1.898-2.35 3.314-2.039l18.146 3.994c1.417.312 2.243 1.74 1.836 3.173-.406 1.433-1.898 2.351-3.314 2.039z",
    fill: "url(#paint253_radial_3128_3574)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M145.539 105.34l-18.146-3.994c-1.417-.312-2.243-1.74-1.836-3.173.407-1.433 1.898-2.35 3.314-2.038l18.146 3.994c1.416.312 2.243 1.74 1.836 3.173-.406 1.432-1.898 2.35-3.314 2.038z",
    fill: "url(#paint254_radial_3128_3574)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M145.546 105.311l-18.145-3.994c-1.417-.312-2.243-1.74-1.836-3.172.406-1.434 1.898-2.35 3.314-2.039l18.145 3.994c1.417.312 2.243 1.74 1.837 3.173-.406 1.432-1.898 2.35-3.315 2.038z",
    fill: "url(#paint255_radial_3128_3574)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M145.555 105.282l-18.145-3.994c-1.417-.312-2.243-1.74-1.837-3.172.407-1.433 1.899-2.35 3.315-2.039l18.145 3.995c1.417.312 2.243 1.739 1.836 3.172-.406 1.432-1.897 2.35-3.314 2.038z",
    fill: "url(#paint256_radial_3128_3574)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M145.554 105.282l-18.145-3.994c-1.417-.312-2.243-1.74-1.837-3.172.407-1.434 1.899-2.35 3.315-2.039l18.145 3.994c1.417.312 2.243 1.74 1.836 3.173-.406 1.432-1.897 2.349-3.314 2.038z",
    fill: "url(#paint257_linear_3128_3574)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-11.71008 -2.69143 2.84474 -12.3771 148.712 53.323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#E3E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EEF6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.067 77.402 18.227) scale(12.0521 12.7302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#DFDCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE9F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.079 77.423 18.228) scale(12.089 12.7605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#DBD7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E4EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-11.8187 -2.70902 2.85786 -12.46806 148.859 53.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#D6D3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DFEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.103 77.466 18.231) scale(12.1623 12.8214)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1CCDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#D2CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDAE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-11.89221 -2.7204 2.86584 -12.528 148.957 53.285)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#CEC9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.127 77.508 18.234) scale(12.2359 12.8824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#CAC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D1E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-11.96579 -2.73196 2.87402 -12.58798 149.053 53.27)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4BFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#C6C0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2CCDD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-12.00224 -2.73764 2.87818 -12.61841 149.101 53.261)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#C2BCD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC7D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.163 77.57 18.237) scale(12.3478 12.9725)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCB6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#BEB7CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C2D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.176 77.59 18.24) scale(12.3852 13.0024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B9B3CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BDD1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-12.11273 -2.75461 2.8901 -12.70852 149.245 53.236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B5AEC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0B8CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-12.1508 -2.76037 2.89367 -12.73755 149.293 53.229)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B1A9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBB3CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-12.18746 -2.76602 2.89775 -12.7679 149.34 53.22)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#ADA5C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AEC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.226 77.671 18.245) scale(12.535 13.1224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A89FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A9A0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2A9C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.239 77.692 18.247) scale(12.5728 13.1521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A39AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A59CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEA4BF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.251 77.712 18.248) scale(12.6101 13.1823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F96B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A197B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99FBB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-12.33686 -2.78815 2.91248 -12.88699 149.529 53.187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B91B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9C92B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A59AB8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.277 77.752 18.251) scale(12.686 13.2416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#978DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#988EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A095B4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.291 77.772 18.254) scale(12.724 13.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9388AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9489AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C90B0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.303 77.791 18.255) scale(12.7614 13.3012)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F84A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9085A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978CAD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-12.48738 -2.81026 2.92678 -13.00513 149.715 53.153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B7FA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#8C80A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9387A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-12.52544 -2.8156 2.93003 -13.03444 149.762 53.144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#877BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#887CA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E82A5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.344 77.85 18.261) scale(12.8763 13.389)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83769D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#83779E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A7DA2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.358 77.87 18.263) scale(12.9146 13.4181)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F729A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#7F729A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85789E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.371 77.89 18.265) scale(12.9525 13.4478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#7B6E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81739A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-12.6774 -2.83722 2.94332 -13.15146 149.945 53.109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#776993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6E97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.399 77.927 18.27) scale(13.0296 13.5057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#736590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786993"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-12.75344 -2.8477 2.94964 -13.21 150.036 53.09)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E5F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#6F608D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73648F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-12.79278 -2.8532 2.95248 -13.23795 150.082 53.08)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#6B5B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5F8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.441 77.983 18.276) scale(13.1451 13.5927)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#665786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5A88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.455 78.003 18.278) scale(13.1839 13.6213)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#625282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665584"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.47 78.02 18.28) scale(13.2228 13.6498)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E4D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5E4E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.484 78.04 18.283) scale(13.2612 13.6789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A497B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5A497B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4B7D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.499 78.058 18.286) scale(13.301 13.7065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#564578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584779"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-13.02376 -2.8842 2.96986 -13.41059 150.351 53.025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#524074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544275"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.529 78.094 18.291) scale(13.3785 13.7637)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D3B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#4E3B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F3D72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-13.10207 -2.8941 2.9747 -13.46697 150.441 53.005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#49376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B386E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.558 78.13 18.296) scale(13.4564 13.8204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#45326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46336A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-13.17966 -2.904 2.97983 -13.5238 150.528 52.986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#412E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#412E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422E67"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-167.588 78.166 18.301) scale(13.5353 13.8762)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#3D2963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2963"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.64325 4.54901 -4.59046 19.8222 141.657 85.04)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#E3E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EEF6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(13.023 -301.573 663.092) scale(20.1654 20.2794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#DFDCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE9F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.64933 4.54092 -4.55119 19.69375 141.674 84.982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#DBD7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E4EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.6516 4.53816 -4.53355 19.63163 141.683 84.953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#D6D3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DFEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.987 -302.212 664.879) scale(20.1712 20.0792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1CCDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#D2CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDAE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.976 -302.389 665.417) scale(20.173 20.0117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#CEC9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.966 -302.567 665.952) scale(20.1749 19.9434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#CAC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D1E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.66322 4.52338 -4.4553 19.36725 141.714 84.838)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4BFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#C6C0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2CCDD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.938 -303.1 667.33) scale(20.1792 19.8041)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#C2BCD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC7D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.66958 4.5149 -4.41506 19.2346 141.731 84.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCB6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#BEB7CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C2D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.917 -303.477 668.44) scale(20.183 19.6646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B9B3CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BDD1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.67521 4.50825 -4.37587 19.09748 141.748 84.722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B5AEC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0B8CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.67899 4.50297 -4.3544 19.02967 141.756 84.693)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B1A9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBB3CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.68181 4.49957 -4.3348 18.9611 141.765 84.664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#ADA5C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AEC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.68475 4.49615 -4.31454 18.88963 141.772 84.635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A89FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A9A0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2A9C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.6876 4.49268 -4.29474 18.8202 141.781 84.606)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A39AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A59CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEA4BF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.837 -305.012 672.471) scale(20.1964 19.2316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F96B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A197B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99FBB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.69455 4.48378 -4.25234 18.67796 141.797 84.548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B91B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9C92B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A59AB8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.815 -305.392 673.604) scale(20.2005 19.0843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#978DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#988EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A095B4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.70036 4.47715 -4.21275 18.53693 141.814 84.49)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9388AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9489AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C90B0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.70438 4.47163 -4.19052 18.46568 141.821 84.461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F84A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9085A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978CAD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.70756 4.46804 -4.16948 18.39068 141.83 84.432)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B7FA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#8C80A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9387A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.762 -306.446 676.352) scale(20.21 18.7817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#877BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#887CA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E82A5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.71382 4.46075 -4.1281 18.24369 141.846 84.374)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83769D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#83779E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A7DA2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.71816 4.45515 -4.10495 18.16823 141.855 84.345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F729A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#7F729A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85789E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.72136 4.45142 -4.0839 18.09313 141.862 84.316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#7B6E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81739A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.72466 4.44771 -4.06288 18.01801 141.871 84.287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#776993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6E97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.695 -307.795 679.864) scale(20.2223 18.3893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#736590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786993"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.73235 4.43816 -4.01798 17.86422 141.887 84.23)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E5F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#6F608D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73648F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.663 -308.473 681.501) scale(20.2278 18.2309)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#6B5B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5F8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.7392 4.4305 -3.97495 17.70959 141.903 84.172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#665786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5A88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.74272 4.42666 -3.95286 17.62958 141.912 84.142)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#625282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665584"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.619 -309.422 683.859) scale(20.236 17.9856)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E4D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5E4E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.75056 4.41727 -3.90809 17.4739 141.929 84.085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A497B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5A497B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4B7D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.594 -309.906 685.177) scale(20.2412 17.8204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#564578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584779"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.58 -310.174 685.879) scale(20.2439 17.7372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#524074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544275"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.7626 4.40327 -3.83912 17.23059 141.953 83.998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D3B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#4E3B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F3D72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.547 -310.916 687.635) scale(20.25 17.5687)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#49376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B386E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.534 -311.198 688.367) scale(20.2528 17.4809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#45326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46336A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.52 -311.48 689.097) scale(20.2557 17.3952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#412E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#412E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422E67"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.5 -311.97 690.179) scale(20.2592 17.3086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#3D2963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2963"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.87568 3.44466 -3.4945 15.09089 139.236 93.575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#E3E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EEF6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.87621 3.44281 -3.49907 15.11929 139.243 93.546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#DFDCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE9F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(13.019 -340.164 656.959) scale(15.2697 15.551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#DBD7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E4EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.87756 3.43831 -3.50904 15.1836 139.259 93.488)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#D6D3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DFEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.87875 3.43492 -3.51226 15.21374 139.268 93.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1CCDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#D2CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDAE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.993 -340.589 658.238) scale(15.2701 15.6479)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#CEC9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.985 -340.71 658.638) scale(15.2702 15.6805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#CAC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D1E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.88084 3.42807 -3.52768 15.31322 139.292 93.372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4BFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#C6C0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2CCDD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.966 -341.062 659.598) scale(15.2706 15.7498)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#C2BCD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC7D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.952 -341.391 660.306) scale(15.2711 15.7848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCB6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#BEB7CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C2D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.88302 3.42086 -3.54418 15.41953 139.318 93.285)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B9B3CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BDD1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.93 -341.832 661.405) scale(15.2718 15.8564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B5AEC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0B8CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.88503 3.41522 -3.55448 15.49196 139.334 93.228)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B1A9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBB3CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.88635 3.4117 -3.55954 15.53143 139.342 93.198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#ADA5C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AEC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.899 -342.42 662.939) scale(15.2725 15.9703)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A89FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A9A0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2A9C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.88844 3.40572 -3.57036 15.60815 139.358 93.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A39AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A59CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEA4BF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.875 -342.932 664.149) scale(15.2733 16.0512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F96B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A197B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99FBB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.86 -343.285 664.892) scale(15.2739 16.0917)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B91B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9C92B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A59AB8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.852 -343.429 665.33) scale(15.274 16.1351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#978DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#988EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A095B4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.841 -343.63 665.856) scale(15.2743 16.1769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9388AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9489AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C90B0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.825 -344.011 666.642) scale(15.2749 16.2222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F84A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9085A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978CAD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.89484 3.38802 -3.60733 15.859 139.408 92.967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B7FA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#8C80A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9387A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.89649 3.3839 -3.61324 15.90607 139.416 92.938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#877BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#887CA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E82A5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.788 -344.815 668.515) scale(15.2762 16.3588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83769D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#83779E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A7DA2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.89923 3.3768 -3.62592 15.99845 139.432 92.88)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F729A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#7F729A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85789E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.90003 3.37418 -3.63403 16.04747 139.441 92.851)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#7B6E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81739A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.90214 3.36936 -3.63947 16.09679 139.449 92.822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#776993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6E97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.90316 3.36666 -3.64743 16.14604 139.457 92.793)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#736590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786993"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.711 -346.69 672.446) scale(15.2795 16.6067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E5F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#6F608D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73648F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.698 -346.986 673.113) scale(15.2801 16.6591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#6B5B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5F8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.679 -347.487 674.096) scale(15.281 16.7148)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#665786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5A88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.665 -347.806 674.802) scale(15.2817 16.7677)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#625282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665584"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.653 -348.082 675.444) scale(15.2821 16.8257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E4D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5E4E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.632 -348.63 676.49) scale(15.2832 16.8858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A497B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5A497B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4B7D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.618 -348.99 677.262) scale(15.2839 16.9422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#564578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584779"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.9171 3.33336 -3.70852 16.596 139.523 92.562)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#524074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544275"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.581 -349.957 679.171) scale(15.2858 17.0666)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D3B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#4E3B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F3D72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.558 -350.575 680.331) scale(15.2871 17.1328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#49376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B386E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.92289 3.32027 -3.73507 16.7872 139.547 92.475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#45326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46336A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.518 -351.655 682.417) scale(15.2893 17.2648)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#412E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#412E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422E67"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.503 -352.045 683.234) scale(15.29 17.3352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#3D2963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2963"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.48205 1.96479 -2.00745 8.66622 136.893 101.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#E3E0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EEF6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(13.04 -376.933 649.805) scale(8.70291 8.97446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#DFDCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE9F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(13.033 -377.057 650.168) scale(8.69921 9.05646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#DBD7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E4EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(13.026 -377.188 650.546) scale(8.69556 9.14147)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#D6D3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DFEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.4682 1.95873 -2.07962 8.99085 136.927 101.722)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1CCDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#D2CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDAE8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(13.014 -377.32 651.117) scale(8.68821 9.31817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#CEC9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.46135 1.95534 -2.11917 9.1703 136.943 101.664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#CAC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D1E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.45815 1.95326 -2.13953 9.26475 136.951 101.635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4BFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#C6C0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2CCDD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.995 -377.6 652.092) scale(8.67709 9.60938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#C2BCD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC7D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.45123 1.9499 -2.1839 9.46544 136.967 101.577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCB6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#BEB7CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C2D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.448 1.94767 -2.2067 9.57155 136.975 101.548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B9B3CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4BDD1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint227_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.44441 1.94641 -2.23138 9.68073 136.983 101.519)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B5AEC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0B8CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.968 -377.992 653.418) scale(8.66229 10.0505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#B1A9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBB3CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.43823 1.94154 -2.281 9.91357 137 101.461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#ADA5C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AEC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.43466 1.94018 -2.30855 10.03611 137.008 101.432)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A89FBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A9A0BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2A9C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint231_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.943 -378.478 654.665) scale(8.65138 10.4306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A39AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A59CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEA4BF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint232_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.42803 1.9363 -2.36641 10.30016 137.024 101.374)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F96B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#A197B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99FBB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint233_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.42505 1.93376 -2.39618 10.43974 137.033 101.345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B91B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9C92B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A59AB8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint234_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.914 -379.076 656.076) scale(8.64066 10.8616)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#978DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#988EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A095B4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint235_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.908 -379.177 656.418) scale(8.637 11.0169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9388AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9489AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C90B0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint236_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.894 -379.521 657.083) scale(8.6336 11.1814)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F84A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#9085A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978CAD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint237_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.888 -379.59 657.37) scale(8.62994 11.352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B7FA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#8C80A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9387A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint238_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.40977 1.92205 -2.56956 11.2429 137.073 101.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#877BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#887CA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E82A5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint239_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.40706 1.91905 -2.60869 11.42824 137.082 101.172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83769D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#83779E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A7DA2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint240_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.851 -380.492 659.195) scale(8.6198 11.9201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F729A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#7F729A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85789E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.40131 1.91408 -2.69448 11.82664 137.099 101.114)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#7B6E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81739A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint242_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.39838 1.91184 -2.74096 12.04056 137.106 101.085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#776993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6E97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint243_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.39606 1.90848 -2.7884 12.26718 137.114 101.056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#736590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#786993"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint244_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.797 -381.89 661.912) scale(8.60686 12.8264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E5F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#6F608D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73648F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint245_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.39095 1.90277 -2.8943 12.76345 137.131 100.998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#6B5B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5F8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint246_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.755 -383.108 663.965) scale(8.60117 13.3638)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#665786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A5A88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint247_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.743 -383.392 664.554) scale(8.59809 13.6558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#625282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665584"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.719 -384.114 665.744) scale(8.59547 13.968)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E4D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5E4E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.38233 1.88955 -3.14416 13.94801 137.164 100.882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A497B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5A497B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4B7D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.38097 1.8851 -3.21525 14.29466 137.173 100.853)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#564578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584779"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint251_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.648 -386.304 669.335) scale(8.58821 15.0329)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#524074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544275"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint252_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.37781 1.87727 -3.3762 15.06717 137.189 100.795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D3B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#4E3B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F3D72"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint253_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.597 -387.864 671.875) scale(8.58375 15.8808)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#49376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B386E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint254_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(12.576 -388.5 672.948) scale(8.58146 16.3524)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#45326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46336A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint255_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.37542 1.86272 -3.6616 16.46374 137.213 100.708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#412E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#412E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422E67"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint256_radial_3128_3574",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.37589 1.85605 -3.7684 17.00588 137.221 100.679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#3D2963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2963"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3128_3574",
    x1: 85.097,
    y1: 119.931,
    x2: 18.753,
    y2: 29.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D3ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3128_3574",
    x1: 53.937,
    y1: 46.343,
    x2: 115.414,
    y2: 38.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7B5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A399A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3128_3574",
    x1: 76.814,
    y1: 53.003,
    x2: 144.651,
    y2: 47.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7B5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A399A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3128_3574",
    x1: 93.896,
    y1: 65.093,
    x2: 165.454,
    y2: 63.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D0C2CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7B5C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3128_3574",
    x1: 96.694,
    y1: 86.59,
    x2: 175.29,
    y2: 65.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3128_3574",
    x1: 96.699,
    y1: 86.823,
    x2: 175.411,
    y2: 65.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3EFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3128_3574",
    x1: 96.704,
    y1: 87.059,
    x2: 175.529,
    y2: 64.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EEF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3128_3574",
    x1: 96.709,
    y1: 87.29,
    x2: 175.646,
    y2: 64.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFECF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3128_3574",
    x1: 96.717,
    y1: 87.523,
    x2: 175.76,
    y2: 64.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEAF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3128_3574",
    x1: 96.726,
    y1: 87.757,
    x2: 175.869,
    y2: 64.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE8EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3128_3574",
    x1: 96.74,
    y1: 87.985,
    x2: 175.975,
    y2: 64.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAE7EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3128_3574",
    x1: 96.752,
    y1: 88.218,
    x2: 176.079,
    y2: 64.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3128_3574",
    x1: 96.765,
    y1: 88.45,
    x2: 176.18,
    y2: 63.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E3EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3128_3574",
    x1: 96.782,
    y1: 88.68,
    x2: 176.278,
    y2: 63.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDECED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E1E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3128_3574",
    x1: 96.8,
    y1: 88.912,
    x2: 176.373,
    y2: 63.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3128_3574",
    x1: 96.82,
    y1: 89.142,
    x2: 176.463,
    y2: 63.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1DEE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3128_3574",
    x1: 96.839,
    y1: 89.372,
    x2: 176.553,
    y2: 63.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E6E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0DCE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3128_3574",
    x1: 96.862,
    y1: 89.6,
    x2: 176.639,
    y2: 62.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3128_3574",
    x1: 96.885,
    y1: 89.83,
    x2: 176.722,
    y2: 62.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCD9DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3128_3574",
    x1: 96.912,
    y1: 90.059,
    x2: 176.801,
    y2: 62.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD7DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3128_3574",
    x1: 96.938,
    y1: 90.284,
    x2: 176.878,
    y2: 62.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0DFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D5DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3128_3574",
    x1: 96.967,
    y1: 90.515,
    x2: 176.953,
    y2: 62.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3128_3574",
    x1: 96.998,
    y1: 90.744,
    x2: 177.026,
    y2: 62.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D2D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3128_3574",
    x1: 97.03,
    y1: 90.97,
    x2: 177.095,
    y2: 61.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3128_3574",
    x1: 97.063,
    y1: 91.196,
    x2: 177.161,
    y2: 61.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2CED5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3128_3574",
    x1: 97.098,
    y1: 91.424,
    x2: 177.225,
    y2: 61.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0CCD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3128_3574",
    x1: 97.134,
    y1: 91.652,
    x2: 177.286,
    y2: 61.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCBD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3128_3574",
    x1: 97.167,
    y1: 91.88,
    x2: 177.346,
    y2: 61.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC9CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3128_3574",
    x1: 97.197,
    y1: 92.113,
    x2: 177.405,
    y2: 61.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1CFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC7CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3128_3574",
    x1: 97.23,
    y1: 92.344,
    x2: 177.47,
    y2: 60.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3128_3574",
    x1: 97.264,
    y1: 92.572,
    x2: 177.534,
    y2: 60.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C4CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3128_3574",
    x1: 97.3,
    y1: 92.804,
    x2: 177.596,
    y2: 60.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C2C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3128_3574",
    x1: 97.335,
    y1: 93.034,
    x2: 177.654,
    y2: 60.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3128_3574",
    x1: 97.373,
    y1: 93.263,
    x2: 177.71,
    y2: 60.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3128_3574",
    x1: 97.414,
    y1: 93.492,
    x2: 177.765,
    y2: 60.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1BDC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3128_3574",
    x1: 97.455,
    y1: 93.723,
    x2: 177.817,
    y2: 59.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBBC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3128_3574",
    x1: 97.498,
    y1: 93.956,
    x2: 177.868,
    y2: 59.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB9BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3128_3574",
    x1: 97.54,
    y1: 94.178,
    x2: 177.914,
    y2: 59.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1BEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3128_3574",
    x1: 97.582,
    y1: 94.403,
    x2: 177.958,
    y2: 59.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAB6BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3128_3574",
    x1: 97.628,
    y1: 94.627,
    x2: 178,
    y2: 59.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B4BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3128_3574",
    x1: 97.674,
    y1: 94.85,
    x2: 178.039,
    y2: 59.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBB9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B2B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3128_3574",
    x1: 97.72,
    y1: 95.073,
    x2: 178.076,
    y2: 58.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAB7B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3128_3574",
    x1: 97.769,
    y1: 95.298,
    x2: 178.112,
    y2: 58.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3AFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3128_3574",
    x1: 97.82,
    y1: 95.52,
    x2: 178.146,
    y2: 58.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1ADB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3128_3574",
    x1: 97.873,
    y1: 95.744,
    x2: 178.178,
    y2: 58.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B1B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0ABB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3128_3574",
    x1: 97.924,
    y1: 95.967,
    x2: 178.207,
    y2: 58.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2AFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEA9AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3128_3574",
    x1: 97.978,
    y1: 96.191,
    x2: 178.235,
    y2: 58.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0ADB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACA8AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3128_3574",
    x1: 98.033,
    y1: 96.411,
    x2: 178.26,
    y2: 58.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFABAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA6AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3128_3574",
    x1: 98.091,
    y1: 96.633,
    x2: 178.285,
    y2: 57.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADA9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A4AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3128_3574",
    x1: 98.148,
    y1: 96.856,
    x2: 178.305,
    y2: 57.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABA8AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A2A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3128_3574",
    x1: 98.207,
    y1: 97.075,
    x2: 178.326,
    y2: 57.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A1A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3128_3574",
    x1: 98.269,
    y1: 97.3,
    x2: 178.346,
    y2: 57.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A49FA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3128_3574",
    x1: 98.332,
    y1: 97.522,
    x2: 178.363,
    y2: 57.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A29DA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3128_3574",
    x1: 98.393,
    y1: 97.738,
    x2: 178.376,
    y2: 57.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09BA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3128_3574",
    x1: 98.459,
    y1: 97.96,
    x2: 178.39,
    y2: 56.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A29EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9A9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3128_3574",
    x1: 98.525,
    y1: 98.181,
    x2: 178.402,
    y2: 56.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D989E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3128_3574",
    x1: 98.592,
    y1: 98.4,
    x2: 178.412,
    y2: 56.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B969C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3128_3574",
    x1: 98.66,
    y1: 98.619,
    x2: 178.42,
    y2: 56.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C989C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3128_3574",
    x1: 98.732,
    y1: 98.841,
    x2: 178.43,
    y2: 56.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B969A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989398"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3128_3574",
    x1: 98.802,
    y1: 99.061,
    x2: 178.435,
    y2: 56.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969196"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3128_3574",
    x1: 98.874,
    y1: 99.278,
    x2: 178.438,
    y2: 56.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#948F95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3128_3574",
    x1: 98.948,
    y1: 99.497,
    x2: 178.441,
    y2: 56.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#928D93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3128_3574",
    x1: 99.022,
    y1: 99.716,
    x2: 178.44,
    y2: 55.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#938F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#918C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3128_3574",
    x1: 99.098,
    y1: 99.93,
    x2: 178.441,
    y2: 55.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8A8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3128_3574",
    x1: 99.176,
    y1: 100.148,
    x2: 178.44,
    y2: 55.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#908B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D888E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3128_3574",
    x1: 99.254,
    y1: 100.367,
    x2: 178.436,
    y2: 55.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E898D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C868C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3128_3574",
    x1: 99.333,
    y1: 100.582,
    x2: 178.432,
    y2: 55.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C878B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A858A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_3128_3574",
    x1: 99.414,
    y1: 100.8,
    x2: 178.426,
    y2: 55.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888388"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_3128_3574",
    x1: 99.497,
    y1: 101.015,
    x2: 178.421,
    y2: 55.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868186"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_3128_3574",
    x1: 99.582,
    y1: 101.232,
    x2: 178.414,
    y2: 55.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#857F85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_3128_3574",
    x1: 99.664,
    y1: 101.444,
    x2: 178.402,
    y2: 54.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#837E83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_3128_3574",
    x1: 99.749,
    y1: 101.66,
    x2: 178.391,
    y2: 54.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#837E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#817C81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_3128_3574",
    x1: 99.836,
    y1: 101.874,
    x2: 178.381,
    y2: 54.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#817C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#807A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_3128_3574",
    x1: 99.924,
    y1: 102.088,
    x2: 178.369,
    y2: 54.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7A7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E787E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_3128_3574",
    x1: 100.014,
    y1: 102.301,
    x2: 178.354,
    y2: 54.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D787C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C777C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_3128_3574",
    x1: 100.104,
    y1: 102.515,
    x2: 178.339,
    y2: 54.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B767B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A757A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_3128_3574",
    x1: 100.194,
    y1: 102.726,
    x2: 178.322,
    y2: 54.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A7479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#797378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_3128_3574",
    x1: 100.287,
    y1: 102.938,
    x2: 178.308,
    y2: 54.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_3128_3574",
    x1: 100.379,
    y1: 103.15,
    x2: 178.287,
    y2: 54.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_3128_3574",
    x1: 100.475,
    y1: 103.362,
    x2: 178.269,
    y2: 53.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746E73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_3128_3574",
    x1: 100.569,
    y1: 103.572,
    x2: 178.248,
    y2: 53.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#726C71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_3128_3574",
    x1: 100.668,
    y1: 103.785,
    x2: 178.231,
    y2: 53.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706B70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#706A6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_3128_3574",
    x1: 100.765,
    y1: 103.994,
    x2: 178.208,
    y2: 53.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F696E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E696E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_3128_3574",
    x1: 100.864,
    y1: 104.202,
    x2: 178.186,
    y2: 53.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D676C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D676C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_3128_3574",
    x1: 102.992,
    y1: 87.225,
    x2: 197.331,
    y2: 80.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_3128_3574",
    x1: 118.835,
    y1: 62.942,
    x2: 190.97,
    y2: 58.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6851A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9056D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_3128_3574",
    x1: 162.895,
    y1: 51.706,
    x2: 136.072,
    y2: 60.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_3128_3574",
    x1: 161.861,
    y1: 50.946,
    x2: 136.311,
    y2: 58.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_3128_3574",
    x1: 114.022,
    y1: 78.666,
    x2: 159.336,
    y2: 107.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_3128_3574",
    x1: 114.359,
    y1: 77.478,
    x2: 159.673,
    y2: 106.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6851A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9056D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_3128_3574",
    x1: 118.379,
    y1: 88.772,
    x2: 152.575,
    y2: 110.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_3128_3574",
    x1: 118.715,
    y1: 87.585,
    x2: 152.912,
    y2: 109.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6851A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9056D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_3128_3574",
    x1: 125.193,
    y1: 99.157,
    x2: 144.37,
    y2: 111.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_3128_3574",
    x1: 125.528,
    y1: 97.969,
    x2: 144.706,
    y2: 110.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6851A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9056D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxIcon);
export default __webpack_public_path__ + "static/media/ux_icon.f8233bf0b872f0f888b22c8373165c10.svg";
export { ForwardRef as ReactComponent };